var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 24,
    viewBox: "0 0 112 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2358 5.87773H98.21C98.2358 5.85195 98.2358 5.85195 98.2358 5.87773Z",
    fill: "url(#paint0_linear_4741_7283)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.652 3.55762H102.677C102.652 3.55762 102.6 3.5834 102.548 3.60917L102.652 3.55762Z",
    fill: "url(#paint1_linear_4741_7283)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4238 5.38798C99.4497 5.38798 99.4755 5.38798 99.5013 5.3622H99.4755L99.5529 5.33643L99.4238 5.38798Z",
    fill: "url(#paint2_linear_4741_7283)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6046 5.28467C99.5529 5.31045 99.5787 5.31045 99.5271 5.31045L99.6046 5.28467H99.6304C99.5787 5.33623 99.5788 5.31045 99.6046 5.28467Z",
    fill: "url(#paint3_linear_4741_7283)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.043 5.07851H100.018L100.069 5.05273L100.043 5.07851Z",
    fill: "url(#paint4_linear_4741_7283)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.49 4.04736L101.438 4.07314L101.49 4.04736Z",
    fill: "url(#paint5_linear_4741_7283)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.922 4.33104C100.87 4.33104 100.896 4.30526 100.87 4.27949C100.87 4.27949 100.896 4.27948 100.896 4.25371C100.896 4.25371 100.973 4.22793 100.947 4.22793C100.973 4.22793 100.973 4.22793 100.999 4.22793C100.947 4.25371 101.076 4.20215 100.999 4.25371C100.999 4.25371 101.051 4.25371 101.076 4.22793C101.076 4.22793 101.025 4.25371 101.051 4.22793C101.076 4.20215 101.102 4.20215 101.102 4.22793C101.128 4.22793 101.18 4.20215 101.206 4.20215C101.102 4.25371 101.025 4.30526 100.922 4.33104Z",
    fill: "url(#paint6_linear_4741_7283)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.128 4.15039C101.128 4.15039 101.102 4.15039 101.076 4.17617C101.076 4.15039 101.102 4.15039 101.128 4.15039Z",
    fill: "url(#paint7_linear_4741_7283)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.56 4.61465L100.638 4.58887C100.638 4.58887 100.612 4.58887 100.612 4.61465C100.586 4.58887 100.56 4.61465 100.56 4.61465Z",
    fill: "url(#paint8_linear_4741_7283)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6819 5.28506C99.6819 5.28506 99.7077 5.28506 99.7335 5.25928C99.7335 5.25928 99.7077 5.25928 99.6819 5.28506Z",
    fill: "url(#paint9_linear_4741_7283)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0551 5.95527H98.0293C98.0809 5.92949 98.1068 5.90371 98.1584 5.87793C98.1326 5.90371 98.0809 5.95527 98.0551 5.95527Z",
    fill: "url(#paint10_linear_4741_7283)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.46 2.50078C104.434 2.50078 104.434 2.50078 104.46 2.50078C104.46 2.475 104.46 2.475 104.46 2.50078Z",
    fill: "url(#paint11_linear_4741_7283)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.516 3.2997H101.49C101.516 3.2997 101.541 3.27393 101.567 3.27393C101.567 3.27393 101.541 3.2997 101.516 3.2997Z",
    fill: "url(#paint12_linear_4741_7283)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.206 3.53174C101.154 3.55752 101.154 3.55752 101.154 3.55752C101.102 3.55752 101.128 3.5833 101.102 3.55752C101.102 3.53174 101.051 3.5833 101.076 3.5833L100.999 3.60907L101.051 3.5833C101.025 3.5833 100.973 3.60907 100.973 3.60907L101.051 3.5833C101.076 3.5833 101.102 3.5833 101.128 3.55752C101.128 3.55752 101.128 3.55752 101.102 3.55752C101.18 3.50596 101.128 3.55752 101.206 3.53174Z",
    fill: "url(#paint13_linear_4741_7283)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.231 3.48011H101.257L101.309 3.45433C101.309 3.45433 101.36 3.45433 101.335 3.45433C101.335 3.45433 101.335 3.45433 101.309 3.45433C101.309 3.45433 101.386 3.42855 101.386 3.45433C101.36 3.45433 101.335 3.48011 101.309 3.48011C101.283 3.48011 101.257 3.50589 101.231 3.53166H101.206V3.50589C101.231 3.50589 101.231 3.48011 101.231 3.48011L101.18 3.50589C101.18 3.48011 101.257 3.45433 101.283 3.45433C101.231 3.45433 101.283 3.42855 101.231 3.48011Z",
    fill: "url(#paint14_linear_4741_7283)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.415 1.80469H105.441C105.467 1.80469 105.467 1.83047 105.518 1.80469C105.492 1.80469 105.467 1.83047 105.441 1.80469H105.415Z",
    fill: "url(#paint15_linear_4741_7283)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.833 2.78418C102.807 2.80996 102.807 2.80996 102.833 2.78418V2.78418Z",
    fill: "url(#paint16_linear_4741_7283)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.386 3.40312C101.438 3.37734 101.464 3.37734 101.516 3.35156L101.438 3.40312C101.412 3.4289 101.438 3.4289 101.464 3.40312C101.438 3.4289 101.335 3.45468 101.386 3.40312C101.386 3.40312 101.361 3.4289 101.335 3.4289C101.335 3.4289 101.361 3.40312 101.386 3.40312C101.361 3.40312 101.335 3.40312 101.309 3.4289C101.335 3.40312 101.283 3.4289 101.309 3.40312C101.361 3.37734 101.438 3.35156 101.49 3.35156C101.464 3.35156 101.438 3.37734 101.386 3.40312Z",
    fill: "url(#paint17_linear_4741_7283)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.516 3.40283H101.464C101.464 3.42861 101.516 3.40283 101.516 3.40283Z",
    fill: "url(#paint18_linear_4741_7283)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.464 3.53193C101.438 3.53193 101.412 3.53193 101.386 3.53193C101.412 3.55771 101.464 3.53193 101.464 3.53193C101.412 3.55771 101.386 3.55771 101.361 3.58349C101.361 3.55771 101.464 3.50615 101.464 3.53193Z",
    fill: "url(#paint19_linear_4741_7283)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.516 3.53174L101.464 3.55752L101.516 3.53174Z",
    fill: "url(#paint20_linear_4741_7283)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.833 2.73291C102.833 2.75869 102.884 2.73291 102.884 2.73291C102.833 2.75869 102.858 2.75869 102.833 2.73291Z",
    fill: "url(#paint21_linear_4741_7283)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.002 1.93359L104.95 1.95937L105.002 1.93359Z",
    fill: "url(#paint22_linear_4741_7283)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M105.208 1.85634H105.157H105.183L105.208 1.83057V1.85634Z",
    fill: "url(#paint23_linear_4741_7283)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.267 1.52098C106.293 1.52098 106.319 1.4952 106.345 1.4952C106.319 1.52098 106.422 1.4952 106.448 1.4952H106.474C106.474 1.4952 106.474 1.4952 106.448 1.4952H106.525L106.655 1.46943H106.732L106.913 1.44365L107.171 1.39209C107.145 1.39209 107.119 1.41787 107.094 1.41787C107.119 1.41787 107.042 1.41787 107.068 1.44365C107.094 1.44365 107.119 1.44365 107.119 1.44365L107.094 1.46943C107.016 1.4952 107.016 1.46943 106.939 1.46943C106.939 1.46943 106.964 1.46943 106.913 1.4952C106.835 1.4952 106.861 1.52098 106.81 1.4952C106.758 1.4952 106.732 1.4952 106.68 1.4952C106.629 1.4952 106.577 1.4952 106.525 1.52098H106.577C106.551 1.52098 106.525 1.52098 106.5 1.52098C106.5 1.52098 106.5 1.52098 106.525 1.52098H106.396C106.371 1.52098 106.396 1.52098 106.396 1.4952C106.371 1.4952 106.345 1.4952 106.319 1.52098H106.345H106.293C106.241 1.54676 106.345 1.52098 106.371 1.52098C106.319 1.52098 106.293 1.52098 106.216 1.54676C106.216 1.54676 106.241 1.54676 106.267 1.52098C106.371 1.52098 106.319 1.52098 106.267 1.52098C106.293 1.54676 106.293 1.54676 106.267 1.52098Z",
    fill: "url(#paint24_linear_4741_7283)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.558 1.31474C107.481 1.31474 107.429 1.31474 107.378 1.31474C107.455 1.31474 107.403 1.34052 107.507 1.31474C107.403 1.31474 107.3 1.34052 107.197 1.34052C107.274 1.31474 107.145 1.34052 107.171 1.31474H107.223H107.248H107.274C107.274 1.31474 107.248 1.31474 107.248 1.34052C107.326 1.34052 107.274 1.34052 107.326 1.31474H107.403L107.687 1.26318C107.739 1.26318 107.662 1.28896 107.687 1.28896C107.662 1.28896 107.558 1.34052 107.558 1.31474Z",
    fill: "url(#paint25_linear_4741_7283)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.152 1.26357H108.101V1.23779C108.126 1.23779 108.126 1.23779 108.101 1.26357C108.152 1.26357 108.152 1.23779 108.152 1.26357Z",
    fill: "url(#paint26_linear_4741_7283)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.791 1.26318L107.817 1.28896H107.791V1.26318Z",
    fill: "url(#paint27_linear_4741_7283)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.894 1.23779L107.843 1.26357C107.843 1.26357 107.868 1.23779 107.894 1.23779Z",
    fill: "url(#paint28_linear_4741_7283)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M100.818 4.97549L100.87 4.94971L100.844 4.97549H100.818Z",
    fill: "url(#paint29_linear_4741_7283)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M102.523 4.0216C102.497 4.04738 102.574 3.99582 102.523 4.0216V4.0216Z",
    fill: "url(#paint30_linear_4741_7283)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3908 6.65088C98.3391 6.67666 98.3391 6.70244 98.3391 6.70244C98.2875 6.72822 98.2875 6.72822 98.2616 6.72822C98.2358 6.72822 98.21 6.77977 98.2358 6.75399L98.1583 6.80555L98.21 6.77977C98.1842 6.77977 98.1325 6.83133 98.1067 6.83133L98.1842 6.77977C98.21 6.77977 98.2358 6.75399 98.2616 6.72822C98.2616 6.72822 98.2616 6.72822 98.2358 6.72822C98.3649 6.65088 98.3133 6.72822 98.3908 6.65088Z",
    fill: "url(#paint31_linear_4741_7283)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4425 6.59964H98.4941L98.5458 6.54808C98.5458 6.54808 98.5974 6.5223 98.5716 6.54808C98.5716 6.54808 98.5458 6.54808 98.5458 6.57386C98.5716 6.57386 98.6232 6.5223 98.6232 6.54808C98.5974 6.57386 98.5458 6.59964 98.5199 6.59964C98.4941 6.62542 98.4425 6.65119 98.4425 6.67697C98.4425 6.67697 98.4166 6.67697 98.3908 6.67697C98.3908 6.65119 98.4166 6.62542 98.4425 6.59964L98.365 6.65119C98.365 6.62541 98.4425 6.57386 98.4683 6.54808C98.4425 6.57386 98.4941 6.54808 98.4425 6.59964Z",
    fill: "url(#paint32_linear_4741_7283)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.46 3.73828L104.253 3.78984C104.253 3.78984 104.33 3.76406 104.279 3.76406C104.305 3.76406 104.33 3.73828 104.356 3.76406C104.408 3.76406 104.434 3.73828 104.408 3.73828H104.537C104.485 3.73828 104.511 3.73828 104.434 3.73828C104.46 3.73828 104.46 3.73828 104.46 3.73828Z",
    fill: "url(#paint33_linear_4741_7283)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M103.685 3.7123L103.788 3.68652C103.788 3.68652 103.84 3.68652 103.814 3.68652H103.788C103.84 3.68652 103.814 3.68652 103.891 3.68652C103.866 3.7123 103.814 3.7123 103.788 3.7123H103.762H103.685Z",
    fill: "url(#paint34_linear_4741_7283)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104.459 3.7124L104.382 3.73818H104.356C104.382 3.7124 104.434 3.7124 104.459 3.7124Z",
    fill: "url(#paint35_linear_4741_7283)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M105.157 3.66063C105.131 3.66063 105.079 3.68641 105.105 3.68641C105.053 3.68641 104.95 3.73797 104.873 3.73797H104.718H104.589H104.614C104.64 3.71219 104.64 3.71219 104.614 3.71219C104.666 3.71219 104.64 3.71219 104.718 3.71219C104.692 3.71219 104.692 3.71219 104.744 3.68641C104.924 3.66063 105.002 3.66063 105.157 3.66063C105.234 3.63485 105.286 3.60907 105.338 3.5833C105.312 3.5833 105.26 3.5833 105.234 3.5833L105.338 3.55752V3.5833C105.492 3.55752 105.312 3.5833 105.363 3.55752C105.389 3.55752 105.415 3.55752 105.441 3.55752C105.312 3.5833 105.441 3.5833 105.338 3.60907C105.363 3.60907 105.415 3.60907 105.467 3.60907C105.518 3.60907 105.415 3.60907 105.415 3.5833C105.467 3.5833 105.467 3.5833 105.492 3.5833C105.57 3.5833 105.647 3.55752 105.699 3.53174C105.725 3.53174 105.751 3.53174 105.777 3.53174C105.777 3.53174 105.699 3.55752 105.673 3.5833H105.622C105.673 3.5833 105.622 3.5833 105.596 3.5833C105.57 3.5833 105.544 3.5833 105.544 3.5833H105.57C105.544 3.5833 105.492 3.5833 105.441 3.60907C105.389 3.60907 105.338 3.60907 105.286 3.60907H105.312C105.312 3.63485 105.234 3.63485 105.157 3.66063Z",
    fill: "url(#paint36_linear_4741_7283)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.002 3.6349C105.002 3.6349 104.95 3.6349 105.028 3.60912C105.028 3.60912 105.028 3.60912 105.002 3.6349C105.079 3.60912 105.105 3.58334 105.157 3.58334C105.182 3.58334 105.105 3.58334 105.131 3.58334C105.182 3.58334 105.312 3.53178 105.312 3.55756C105.337 3.55756 105.363 3.55756 105.389 3.53178C105.467 3.53178 105.647 3.45445 105.647 3.506C105.622 3.506 105.57 3.506 105.544 3.506V3.53178C105.492 3.53178 105.544 3.53178 105.467 3.53178H105.492C105.415 3.53178 105.337 3.55756 105.26 3.58334C105.26 3.58334 105.208 3.60912 105.234 3.60912C105.208 3.60912 105.157 3.60912 105.131 3.60912C105.079 3.60912 105.028 3.60912 105.002 3.6349Z",
    fill: "url(#paint37_linear_4741_7283)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M100.818 5.05273C100.792 5.05273 100.792 5.07851 100.818 5.05273V5.05273Z",
    fill: "url(#paint38_linear_4741_7283)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M100.379 5.33643C100.379 5.3622 100.379 5.3622 100.379 5.33643C100.353 5.3622 100.353 5.3622 100.379 5.33643Z",
    fill: "url(#paint39_linear_4741_7283)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7524 6.36768C98.7007 6.39345 98.6491 6.44501 98.5974 6.47079H98.6232C98.6749 6.44501 98.7007 6.41923 98.7524 6.36768L98.6491 6.44501C98.5974 6.49657 98.6491 6.47079 98.6749 6.44501H98.6491C98.6491 6.44501 98.5199 6.52235 98.6232 6.44501C98.6232 6.44501 98.5458 6.47079 98.5458 6.49657C98.5716 6.49657 98.5716 6.47079 98.5974 6.47079C98.5974 6.47079 98.5716 6.47079 98.5458 6.49657C98.4941 6.52235 98.5716 6.47079 98.5458 6.49657C98.5974 6.44501 98.6749 6.41923 98.7524 6.36768Z",
    fill: "url(#paint40_linear_4741_7283)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M101.541 4.82099C101.515 4.84677 101.438 4.89832 101.412 4.87255L101.49 4.82099C101.515 4.82099 101.567 4.76943 101.567 4.76943C101.515 4.79521 101.567 4.76943 101.593 4.76943C101.619 4.76943 101.593 4.76943 101.593 4.74365H101.619H101.645L101.593 4.76943H101.619C101.541 4.79521 101.645 4.76943 101.541 4.82099Z",
    fill: "url(#paint41_linear_4741_7283)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M104.227 3.76406L104.279 3.73828C104.305 3.73828 104.227 3.76406 104.227 3.76406Z",
    fill: "url(#paint42_linear_4741_7283)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M104.33 3.71213H104.382H104.408C104.434 3.71213 104.537 3.71213 104.563 3.68635C104.589 3.68635 104.64 3.68635 104.666 3.66057C104.64 3.66057 104.615 3.66057 104.615 3.66057C104.666 3.63479 104.718 3.60901 104.769 3.60901H104.718H104.821C104.847 3.58323 104.769 3.60901 104.744 3.60901C104.821 3.60901 104.899 3.55745 104.95 3.55745C104.95 3.55745 104.95 3.53168 105.028 3.5059C104.976 3.53168 105.054 3.5059 105.028 3.53167C105.054 3.53167 105.105 3.5059 105.105 3.53167C105.157 3.5059 105.208 3.5059 105.26 3.5059C105.363 3.48012 105.415 3.45434 105.518 3.45434C105.518 3.42856 105.57 3.42856 105.596 3.40278C105.622 3.40278 105.699 3.40278 105.699 3.40278C105.622 3.42856 105.647 3.40278 105.622 3.40278C105.596 3.40278 105.622 3.40278 105.57 3.42856C105.647 3.42856 105.699 3.40278 105.777 3.377C105.854 3.35122 105.854 3.32544 105.957 3.29967H106.009C106.061 3.27389 106.112 3.27389 106.164 3.27389C106.216 3.27389 106.267 3.27389 106.319 3.27389C106.345 3.27389 106.319 3.27389 106.293 3.27389C106.371 3.24811 106.448 3.24811 106.526 3.27389L106.577 3.24811C106.551 3.24811 106.5 3.24811 106.5 3.24811C106.525 3.24811 106.551 3.24811 106.577 3.24811C106.577 3.24811 106.551 3.24811 106.526 3.24811C106.629 3.22233 106.551 3.27389 106.603 3.24811C106.629 3.24811 106.655 3.24811 106.655 3.24811L106.706 3.22233C106.706 3.22233 106.784 3.22233 106.81 3.22233C106.81 3.22233 106.784 3.24811 106.758 3.22233C106.758 3.22233 106.81 3.22233 106.835 3.22233C106.835 3.19655 107.042 3.19655 106.99 3.17077C107.119 3.17077 107.3 3.11922 107.404 3.11922C107.429 3.11922 107.481 3.09344 107.455 3.09344C107.558 3.09344 107.61 3.09344 107.713 3.06766H107.662C107.739 3.06766 107.791 3.04188 107.894 3.0161C107.868 3.0161 107.868 3.0161 107.868 3.0161C107.894 3.0161 107.92 3.0161 107.946 3.0161C107.92 3.0161 107.972 3.0161 107.946 3.0161C108.152 2.96454 108.307 2.99032 108.514 2.93876C108.462 2.93876 108.436 2.93876 108.436 2.93876H108.488C108.514 2.93876 108.566 2.93876 108.591 2.93876C108.721 2.91299 108.772 2.93876 108.901 2.91299H108.746L108.798 2.88721H108.721C108.772 2.88721 108.798 2.88721 108.798 2.88721H108.772C108.798 2.88721 108.824 2.88721 108.85 2.88721C108.746 2.88721 108.617 2.88721 108.514 2.91299C108.488 2.91299 108.436 2.91299 108.411 2.93876C108.385 2.93876 108.436 2.93876 108.462 2.93876C108.462 2.93876 108.462 2.93876 108.436 2.93876C108.436 2.93876 108.282 2.96454 108.256 2.99032C108.127 2.99032 108.282 2.96454 108.152 2.99032L108.101 3.0161C108.023 3.0161 107.92 3.0161 107.843 3.04188H107.868C107.868 3.04188 107.868 3.04188 107.843 3.04188C107.791 3.04188 107.739 3.04188 107.688 3.06766H107.61C107.636 3.04188 107.662 3.0161 107.636 2.99032H107.61C107.533 2.99032 107.481 2.99032 107.429 3.0161H107.404C107.378 3.04188 107.352 3.06766 107.352 3.09344C107.3 3.09344 107.274 3.09344 107.223 3.09344C107.171 3.09344 107.094 3.09344 107.068 3.11922C106.99 3.11922 106.939 3.14499 106.861 3.17077C106.81 3.17077 106.732 3.17077 106.68 3.17077C106.655 3.17077 106.5 3.22233 106.422 3.22233C106.448 3.22233 106.474 3.22233 106.5 3.22233C106.448 3.22233 106.422 3.22233 106.396 3.24811C106.5 3.22233 106.396 3.24811 106.448 3.24811C106.396 3.24811 106.371 3.24811 106.319 3.24811C106.396 3.24811 106.293 3.24811 106.371 3.22233C106.293 3.22233 106.216 3.22233 106.138 3.24811C106.138 3.24811 106.138 3.24811 106.112 3.27389H106.086C106.061 3.27389 106.164 3.27389 106.086 3.27389C106.009 3.27389 105.854 3.32544 105.854 3.29967C105.802 3.32544 105.957 3.29967 105.88 3.32545C105.932 3.32545 105.983 3.29967 106.009 3.32545C105.957 3.32545 105.983 3.32544 105.957 3.35122H105.906C105.802 3.35122 105.673 3.377 105.57 3.42856C105.493 3.42856 105.389 3.42856 105.286 3.45434C105.312 3.45434 105.183 3.48012 105.26 3.48012C105.234 3.5059 105.183 3.5059 105.157 3.5059C105.208 3.5059 105.183 3.5059 105.208 3.48012C105.183 3.48012 105.131 3.48012 105.105 3.5059C105.054 3.53168 105.079 3.5059 105.028 3.5059C104.976 3.5059 104.95 3.53167 104.899 3.55745H104.847C104.873 3.55745 104.795 3.55745 104.795 3.58323C104.744 3.58323 104.718 3.58323 104.666 3.58323C104.692 3.58323 104.615 3.60901 104.615 3.60901C104.511 3.66057 104.46 3.63479 104.356 3.66057C104.33 3.66057 104.305 3.66057 104.279 3.68635H104.253C104.201 3.68635 104.15 3.68635 104.098 3.68635C104.098 3.68635 104.175 3.66057 104.201 3.66057H104.227C104.253 3.63479 104.305 3.63479 104.305 3.63479C104.227 3.63479 104.124 3.66057 104.046 3.68635C104.124 3.63479 104.201 3.60901 104.305 3.60901L104.253 3.63479H104.305L104.253 3.66057C104.305 3.66057 104.33 3.63479 104.382 3.63479C104.33 3.63479 104.305 3.66057 104.33 3.66057C104.382 3.63479 104.382 3.66057 104.434 3.63479C104.408 3.63479 104.382 3.63479 104.408 3.66057C104.485 3.63479 104.511 3.63479 104.589 3.58323C104.589 3.60901 104.692 3.55745 104.692 3.58323H104.718C104.795 3.55745 104.64 3.58323 104.769 3.53167C104.821 3.53167 104.873 3.5059 104.924 3.5059C104.873 3.5059 104.821 3.5059 104.769 3.5059H104.795C104.744 3.5059 104.692 3.53167 104.64 3.53167C104.718 3.53167 104.615 3.53167 104.563 3.55745C104.615 3.55745 104.615 3.55745 104.692 3.53167C104.563 3.58323 104.563 3.53167 104.46 3.58323C104.511 3.58323 104.434 3.60901 104.434 3.60901C104.408 3.60901 104.356 3.63479 104.33 3.63479L104.356 3.60901C104.279 3.60901 104.279 3.66057 104.175 3.66057C104.175 3.66057 104.253 3.63479 104.227 3.63479C104.15 3.66057 104.072 3.68635 103.995 3.7379C103.995 3.7379 103.995 3.7379 103.943 3.7379C103.943 3.7379 103.943 3.76368 103.969 3.7379C103.943 3.7379 103.891 3.76368 103.866 3.76368C103.943 3.7379 103.84 3.76368 103.814 3.76368C103.788 3.76368 103.814 3.76368 103.84 3.76368C103.814 3.76368 103.788 3.78946 103.762 3.78946C103.762 3.78946 103.84 3.78946 103.891 3.78946H103.866C103.891 3.78946 103.917 3.78946 103.943 3.76368C103.917 3.78946 103.917 3.78946 103.917 3.78946C103.943 3.78946 103.969 3.78946 103.969 3.78946C103.995 3.78946 103.943 3.81524 103.917 3.81524H103.866H103.711C103.659 3.81524 103.633 3.84102 103.582 3.8668C103.53 3.89258 103.478 3.91836 103.504 3.91836L103.427 3.94413C103.53 3.94413 103.427 3.96991 103.452 3.96991H103.401H103.349C103.401 3.94413 103.349 3.96991 103.323 3.96991C103.323 3.96991 103.246 3.99569 103.22 4.02147C103.168 4.04725 103.143 4.04725 103.091 4.07303C103.065 4.07303 103.039 4.07303 103.013 4.07303C103.091 4.04725 103.039 4.04725 103.039 4.04725C103.039 4.04725 103.039 4.04725 103.013 4.04725C103.065 4.02147 103.143 4.02147 103.194 3.99569C103.168 3.99569 103.143 3.99569 103.117 4.02147C103.168 4.02147 103.22 3.99569 103.272 3.96991H103.297L103.375 3.94413C103.349 3.94413 103.375 3.94413 103.297 3.94413C103.297 3.94413 103.375 3.91836 103.401 3.89258H103.427C103.427 3.89258 103.504 3.8668 103.427 3.8668H103.375H103.323L103.349 3.84102L103.272 3.8668H103.297C103.168 3.91836 103.272 3.91835 103.143 3.94413C103.091 3.94413 103.013 3.96991 102.988 3.99569C103.039 3.96991 102.988 3.99569 103.013 3.99569C102.988 4.02147 102.936 4.02147 102.91 4.02147C102.91 4.02147 102.884 4.04725 102.936 4.02147C102.936 4.02147 102.858 4.04725 102.858 4.07303C102.807 4.09881 102.755 4.09881 102.704 4.12458C102.626 4.12458 102.574 4.15036 102.523 4.20192C102.394 4.25348 102.316 4.27926 102.187 4.33081L102.135 4.35659L102.084 4.38237C102.11 4.38237 102.161 4.35659 102.135 4.38237C102.187 4.35659 102.213 4.33081 102.264 4.30504C102.264 4.30504 102.264 4.30504 102.239 4.33081C102.264 4.33081 102.29 4.30504 102.316 4.27926L102.368 4.25348C102.445 4.2277 102.419 4.25348 102.497 4.2277C102.471 4.2277 102.445 4.2277 102.419 4.2277C102.445 4.20192 102.368 4.2277 102.394 4.2277C102.445 4.2277 102.497 4.20192 102.549 4.17614H102.523L102.626 4.12458C102.6 4.15036 102.704 4.09881 102.704 4.12458C102.6 4.17614 102.626 4.15036 102.497 4.2277C102.523 4.2277 102.574 4.20192 102.6 4.20192C102.626 4.20192 102.6 4.20192 102.6 4.2277C102.549 4.2277 102.471 4.25348 102.419 4.27926C102.394 4.27926 102.445 4.25348 102.497 4.2277L102.419 4.25348L102.264 4.33081C102.29 4.33081 102.316 4.33081 102.316 4.33081C102.29 4.33081 102.264 4.35659 102.264 4.35659C102.264 4.35659 102.264 4.33081 102.239 4.35659C102.161 4.38237 102.11 4.43393 102.058 4.45971C102.058 4.43393 101.98 4.45971 101.955 4.45971C101.955 4.45971 101.903 4.48549 101.877 4.51127C101.851 4.51127 101.877 4.48549 101.903 4.45971C101.98 4.43393 101.955 4.45971 101.98 4.45971L102.084 4.40815H102.058C102.11 4.38237 102.161 4.38237 102.161 4.35659C102.135 4.35659 102.084 4.38237 102.058 4.38237L102.084 4.35659C102.006 4.35659 102.058 4.38237 101.98 4.40815C102.006 4.38237 101.98 4.40815 101.929 4.40815C101.955 4.38237 102.058 4.35659 102.032 4.33081C101.98 4.33081 101.903 4.40815 101.851 4.40815C101.8 4.43393 101.774 4.45971 101.696 4.45971C101.671 4.48549 101.619 4.48549 101.593 4.51127L101.541 4.53704C101.567 4.53704 101.593 4.51127 101.645 4.48549C101.671 4.45971 101.722 4.43393 101.774 4.43393C101.722 4.45971 101.619 4.51127 101.593 4.51127L101.567 4.53704H101.541C101.516 4.56282 101.541 4.56282 101.619 4.53704C101.645 4.53704 101.696 4.51127 101.722 4.51127H101.696C101.748 4.48549 101.8 4.45971 101.851 4.45971C101.748 4.51127 101.645 4.56282 101.567 4.61438C101.541 4.61438 101.49 4.61438 101.464 4.5886C101.386 4.61438 101.335 4.66594 101.257 4.69172C101.232 4.69172 101.206 4.71749 101.18 4.71749C101.154 4.74327 101.206 4.71749 101.18 4.71749L101.102 4.76905C101.154 4.76905 101.18 4.74327 101.232 4.71749H101.206C101.232 4.69172 101.335 4.66594 101.335 4.64016C101.335 4.61438 101.283 4.64016 101.361 4.61438C101.412 4.5886 101.438 4.5886 101.438 4.5886C101.438 4.5886 101.361 4.64016 101.412 4.61438C101.386 4.61438 101.335 4.64016 101.309 4.66594C101.335 4.64016 101.386 4.64016 101.412 4.61438C101.49 4.5886 101.49 4.61438 101.464 4.64016C101.464 4.64016 101.335 4.69172 101.412 4.64016C101.361 4.64016 101.283 4.69172 101.232 4.71749L101.154 4.74327H101.18L101.077 4.76905C101.128 4.74327 101.051 4.79483 101.025 4.82061C101.025 4.82061 100.973 4.82061 100.999 4.82061C101.025 4.79483 101.025 4.82061 101.051 4.79483H100.999H100.973C100.896 4.82061 101.025 4.79483 100.922 4.84639V4.9495C100.87 4.97528 100.818 5.02684 100.767 5.05262C100.715 5.0784 100.689 5.10418 100.638 5.12995C100.663 5.12995 100.689 5.12995 100.663 5.15573C100.715 5.12995 100.741 5.10418 100.793 5.0784C100.741 5.0784 100.715 5.10418 100.689 5.12995C100.689 5.10418 100.818 5.0784 100.818 5.05262C100.947 4.97528 100.922 5.02684 101.025 4.9495C101.025 4.9495 101.051 4.9495 101.077 4.9495C101.051 4.97528 100.922 5.02684 100.87 5.05262H100.896C100.87 5.0784 100.818 5.0784 100.793 5.10418C100.715 5.12995 100.767 5.12995 100.741 5.15573L100.689 5.18151L100.638 5.23307C100.612 5.25885 100.612 5.25885 100.56 5.28463L100.638 5.23307C100.586 5.25885 100.612 5.23307 100.56 5.25885C100.612 5.23307 100.534 5.28463 100.534 5.31041H100.508C100.483 5.33618 100.483 5.31041 100.431 5.33618C100.457 5.31041 100.508 5.28463 100.534 5.25885C100.508 5.25885 100.431 5.31041 100.405 5.31041C100.379 5.33618 100.328 5.33618 100.328 5.36196C100.405 5.33618 100.328 5.41352 100.457 5.31041C100.457 5.31041 100.457 5.31041 100.431 5.31041C100.431 5.28463 100.508 5.25885 100.534 5.25885C100.534 5.25885 100.56 5.25885 100.508 5.28463C100.508 5.28463 100.457 5.28463 100.405 5.33618H100.431L100.353 5.38774C100.328 5.41352 100.276 5.4393 100.224 5.46508C100.199 5.46508 100.147 5.49086 100.147 5.51664C100.121 5.51664 100.095 5.54241 100.121 5.51664C100.069 5.54241 100.044 5.56819 99.992 5.59397L100.044 5.54241C100.018 5.56819 99.9661 5.56819 99.9145 5.59397C99.837 5.67131 99.7337 5.72286 99.6304 5.74864C99.5529 5.8002 99.5788 5.82598 99.4755 5.85176C99.4496 5.85176 99.4755 5.82598 99.4238 5.87754C99.3722 5.90332 99.3205 5.95487 99.243 5.98065C99.2172 6.00643 99.1656 6.03221 99.1656 6.03221C99.2172 6.00643 99.243 5.98065 99.2947 5.95487C99.3722 5.90332 99.3463 5.92909 99.4238 5.87754C99.4238 5.87754 99.398 5.90332 99.3722 5.9291C99.3722 5.9291 99.5271 5.85176 99.4496 5.90332C99.3722 5.95487 99.3205 5.92909 99.2947 5.98065C99.3205 5.95487 99.3722 5.95487 99.398 5.9291L99.3463 5.98065H99.2947C99.2172 6.05799 99.1914 6.03221 99.1139 6.05799C99.1656 6.00643 99.0881 6.05799 99.1139 6.00643C99.0623 6.03221 99.0106 6.08377 99.0365 6.08377C99.1397 6.03221 99.0623 6.08377 99.1656 6.03221C99.1656 6.03221 99.2172 6.03221 99.1656 6.08377C99.0881 6.10955 99.1656 6.05799 99.1139 6.08377C99.0881 6.08377 99.0881 6.10955 99.0365 6.13532C99.0106 6.1611 98.9848 6.1611 98.959 6.18688C98.959 6.1611 98.9332 6.18688 98.9073 6.21266C98.9332 6.1611 98.9848 6.13532 99.0365 6.10955C99.0365 6.10955 99.0365 6.10955 99.0881 6.10955L99.0365 6.13532H99.0623L99.1139 6.10955C99.0364 6.13532 99.0623 6.10955 99.0365 6.13532C98.9848 6.18688 98.9848 6.1611 98.959 6.18688C98.959 6.18688 98.8815 6.26422 98.804 6.31578L98.8299 6.29C98.8815 6.26422 98.804 6.31578 98.804 6.31578H98.7782C98.7266 6.34155 98.7266 6.31578 98.6749 6.36733C98.6749 6.36733 98.7266 6.36733 98.7007 6.36733C98.6749 6.39311 98.6491 6.44467 98.6233 6.44467C98.6233 6.44467 98.5974 6.44467 98.5716 6.47045L98.5458 6.49623C98.5974 6.49623 98.6233 6.44467 98.6491 6.41889C98.6749 6.39311 98.7007 6.39311 98.7266 6.36733C98.7007 6.39311 98.6749 6.41889 98.6491 6.41889C98.6491 6.41889 98.6749 6.41889 98.7007 6.41889C98.7524 6.36733 98.7782 6.36733 98.8557 6.34155C98.9332 6.31578 98.959 6.26422 99.0106 6.23844H98.9848L99.1914 6.13532C99.1914 6.13532 99.2172 6.13532 99.2172 6.10955L99.3205 6.05799L99.2947 6.08377C99.2947 6.08377 99.2172 6.13532 99.2172 6.10955C99.1914 6.13532 99.1397 6.1611 99.1139 6.18688C99.1397 6.1611 99.0881 6.18688 99.0623 6.18688C99.0623 6.18688 99.0106 6.21266 99.0106 6.23844L99.0365 6.21266C99.0881 6.18688 98.959 6.26422 99.0365 6.23844C98.959 6.26422 98.8815 6.34155 98.804 6.36733L98.8299 6.34155C98.804 6.36733 98.7524 6.39311 98.7266 6.41889C98.7524 6.41889 98.7782 6.39311 98.804 6.36733L98.7266 6.41889L98.6233 6.47045L98.6491 6.44467C98.5974 6.47045 98.5458 6.522 98.4941 6.54778C98.5458 6.54778 98.5716 6.49623 98.6491 6.47045C98.7007 6.44467 98.6491 6.49623 98.6749 6.47045C98.6749 6.47045 98.6491 6.49623 98.6233 6.49623C98.6749 6.49623 98.7524 6.41889 98.804 6.39311C98.8299 6.36733 98.8815 6.34155 98.9332 6.31578C98.9332 6.31578 98.9073 6.34155 98.8815 6.34155C98.9073 6.34155 98.9332 6.34155 98.9332 6.31578C98.9073 6.34155 98.9332 6.31578 98.9073 6.34155C98.9332 6.34155 98.959 6.31577 98.9848 6.29H98.959C98.9848 6.29 98.9848 6.23844 99.0365 6.21266C98.9848 6.26422 99.0623 6.21266 99.0881 6.21266C99.1139 6.21266 99.1139 6.21266 99.1397 6.18688C99.1139 6.18688 99.0881 6.21266 99.0881 6.21266C99.1139 6.21266 99.1139 6.18688 99.1397 6.18688H99.1139L99.4238 6.23844C99.4496 6.23844 99.4755 6.23844 99.5013 6.23844C99.5271 6.21266 99.5529 6.21266 99.5788 6.18688C99.6046 6.1611 99.6562 6.13532 99.7079 6.10955C99.7337 6.08377 99.5013 6.18688 99.6821 6.08377C99.7595 6.03221 99.7337 6.08377 99.7854 6.05799C99.8112 6.03221 99.8112 6.05799 99.8628 6.03221C99.8628 6.03221 99.837 6.05799 99.8112 6.05799L99.8887 6.00643C99.837 6.00643 99.9403 5.95487 99.9145 5.98065C99.9661 5.92909 100.018 5.90332 100.069 5.90332C100.095 5.85176 100.147 5.85176 100.199 5.82598C100.199 5.82598 100.173 5.82598 100.147 5.85176C100.095 5.85176 100.224 5.8002 100.147 5.82598C100.147 5.82598 100.095 5.85176 100.095 5.82598L100.147 5.77442H100.121L100.199 5.69709C100.276 5.61975 100.405 5.56819 100.483 5.51664C100.508 5.51664 100.715 5.41352 100.793 5.38774C100.767 5.38774 100.741 5.38774 100.767 5.38774C100.741 5.38774 100.689 5.41352 100.689 5.41352C100.689 5.41352 100.638 5.4393 100.689 5.4393C100.586 5.49086 100.689 5.41352 100.663 5.4393C100.741 5.38774 100.818 5.36196 100.922 5.33618L100.973 5.31041C100.922 5.33618 100.947 5.36196 100.999 5.31041C101.051 5.28463 101.077 5.25885 101.154 5.23307H101.18C101.232 5.20729 101.206 5.18151 101.232 5.15573C101.283 5.12995 101.361 5.10418 101.412 5.0784C101.438 5.05262 101.541 5.00106 101.49 5.02684C101.567 5.00106 101.567 5.05262 101.671 4.9495H101.645C101.696 4.92372 101.774 4.87217 101.825 4.87217C101.877 4.84639 101.929 4.82061 101.98 4.79483C101.929 4.79483 102.11 4.69172 102.135 4.66594H102.187C102.187 4.66594 102.213 4.64016 102.239 4.64016C102.187 4.66594 102.29 4.64016 102.187 4.69172C102.264 4.69172 102.342 4.66594 102.394 4.64016L102.316 4.69172C102.316 4.69172 102.29 4.69172 102.264 4.69172C102.419 4.61438 102.239 4.69172 102.368 4.61438C102.394 4.61438 102.368 4.61438 102.419 4.61438C102.394 4.61438 102.394 4.61438 102.419 4.61438H102.445C102.497 4.56282 102.368 4.64016 102.394 4.61438C102.342 4.64016 102.239 4.66594 102.239 4.64016C102.316 4.5886 102.316 4.64016 102.419 4.56282C102.445 4.56282 102.471 4.56282 102.497 4.56282C102.497 4.56282 102.497 4.56282 102.523 4.53704C102.6 4.53704 102.626 4.51127 102.678 4.51127C102.523 4.56282 102.574 4.5886 102.419 4.61438C102.445 4.61438 102.549 4.56282 102.574 4.5886C102.626 4.5886 102.678 4.56282 102.729 4.53704H102.704C102.781 4.51127 102.833 4.45971 102.91 4.45971H102.884C102.91 4.45971 102.962 4.43393 102.988 4.40815H103.039H103.091C103.091 4.40815 103.143 4.38237 103.117 4.38237C103.168 4.35659 103.194 4.35659 103.272 4.33081C103.349 4.30504 103.22 4.33081 103.194 4.33081C103.272 4.30504 103.349 4.25348 103.452 4.25348C103.427 4.25348 103.427 4.25348 103.427 4.27926C103.452 4.27926 103.478 4.25348 103.478 4.25348H103.504C103.53 4.2277 103.53 4.2277 103.504 4.25348C103.53 4.25348 103.582 4.2277 103.607 4.20192C103.556 4.20192 103.478 4.25348 103.452 4.25348C103.582 4.2277 103.556 4.17614 103.711 4.15036C103.788 4.12459 103.736 4.15036 103.762 4.15036C103.711 4.15036 103.685 4.17614 103.659 4.20192C103.659 4.20192 103.685 4.20192 103.711 4.17614C103.711 4.17614 103.762 4.12458 103.788 4.12458C103.736 4.15036 103.762 4.15036 103.762 4.17614C103.84 4.17614 103.84 4.15036 103.891 4.12458C103.943 4.09881 103.917 4.12458 103.969 4.12458C103.943 4.12458 103.943 4.12458 103.891 4.12458C103.866 4.12458 103.814 4.15036 103.788 4.15036L103.84 4.12458C103.762 4.15036 103.788 4.12458 103.788 4.12458C103.891 4.07303 103.866 4.12459 103.943 4.09881C103.866 4.12459 103.969 4.09881 103.943 4.09881C103.995 4.09881 103.943 4.09881 104.021 4.09881C104.046 4.09881 104.072 4.07303 104.098 4.07303C104.124 4.07303 104.072 4.12458 104.175 4.07303H104.201C104.33 4.02147 104.382 4.02147 104.485 3.99569C104.563 3.96991 104.692 3.94413 104.744 3.91836C104.769 3.91836 104.821 3.89258 104.821 3.89258C104.821 3.89258 104.847 3.89258 104.873 3.89258H104.847C104.847 3.89258 104.847 3.89258 104.873 3.89258C104.847 3.89258 104.899 3.8668 104.795 3.89258C104.769 3.91836 104.873 3.89258 104.847 3.89258C104.821 3.89258 104.821 3.89258 104.821 3.89258C104.795 3.89258 104.795 3.89258 104.795 3.91836C104.795 3.91836 104.744 3.94413 104.718 3.91836C104.64 3.94413 104.718 3.91835 104.666 3.94413H104.64L104.33 3.91836C104.227 3.94413 104.33 3.8668 104.201 3.91836C104.227 3.91836 104.175 3.94413 104.124 3.96991C104.175 3.96991 104.227 3.94413 104.279 3.94413C104.201 3.96991 104.356 3.91835 104.33 3.94413C104.279 3.94413 104.253 3.94413 104.201 3.96991C104.15 3.96991 104.098 3.99569 104.046 3.99569C104.021 3.99569 104.021 3.99569 104.021 3.99569C103.995 3.99569 103.969 3.99569 103.969 3.99569L103.84 3.91836C103.943 3.89258 104.098 3.84102 104.227 3.78946C104.253 3.76368 104.124 3.78946 104.15 3.78946H104.124H104.098C104.098 3.78946 104.227 3.76368 104.175 3.78946C104.072 3.81524 104.021 3.84102 103.917 3.8668C103.943 3.84102 104.046 3.81524 104.124 3.78946C104.098 3.78946 104.072 3.78946 104.046 3.81524C104.124 3.78946 104.175 3.76368 104.253 3.7379H104.279L104.201 3.76368C104.279 3.7379 104.33 3.7379 104.33 3.76368H104.356L104.33 3.71213ZM104.046 3.91836H104.098C104.072 3.91836 104.072 3.91836 104.046 3.91836ZM103.582 3.81524H103.556C103.556 3.81524 103.556 3.81524 103.582 3.81524ZM100.586 5.33618C100.56 5.36196 100.508 5.38774 100.483 5.41352H100.508V5.38774L100.56 5.36196C100.534 5.38774 100.508 5.41352 100.483 5.41352C100.483 5.41352 100.379 5.4393 100.353 5.46508L100.431 5.41352C100.405 5.41352 100.328 5.49086 100.276 5.49086C100.276 5.49086 100.328 5.4393 100.353 5.4393C100.353 5.4393 100.276 5.46508 100.328 5.4393C100.25 5.46508 100.199 5.51663 100.147 5.54241C100.121 5.56819 100.095 5.54241 100.069 5.59397C100.147 5.56819 100.069 5.61975 100.121 5.59397C100.121 5.59397 100.121 5.59397 100.069 5.64553C100.018 5.64553 100.018 5.69709 99.992 5.69709C99.9661 5.72287 100.018 5.69709 99.992 5.72286C99.9145 5.74864 99.9145 5.74864 99.9145 5.72286C99.9661 5.69709 99.992 5.69709 100.044 5.67131L99.9403 5.69709L99.9661 5.67131C99.9403 5.67131 99.9403 5.67131 99.9145 5.69709H99.8887C99.9145 5.67131 99.9661 5.64553 99.992 5.61975C100.018 5.61975 100.044 5.59397 100.069 5.59397C100.121 5.56819 100.173 5.54241 100.173 5.54241H100.147C100.199 5.51663 100.224 5.51664 100.276 5.46508C100.353 5.4393 100.431 5.38774 100.483 5.38774C100.534 5.38774 100.534 5.36196 100.586 5.33618ZM101.929 4.64016C101.851 4.69172 101.774 4.69172 101.671 4.76905C101.696 4.76905 101.748 4.74327 101.8 4.74327L101.748 4.76905C101.774 4.76905 101.722 4.79483 101.671 4.82061H101.722C101.748 4.79483 101.774 4.79483 101.8 4.76905C101.825 4.74327 101.877 4.7175 101.929 4.69172C101.929 4.69172 101.825 4.74327 101.877 4.74327C101.851 4.74327 101.8 4.76905 101.8 4.79483C101.851 4.79483 101.825 4.79483 101.851 4.79483L101.774 4.82061C101.774 4.82061 101.877 4.76905 101.825 4.82061C101.8 4.82061 101.722 4.87217 101.722 4.87217C101.671 4.89795 101.696 4.87217 101.645 4.89795C101.645 4.89795 101.645 4.89795 101.671 4.87217C101.696 4.87217 101.722 4.87217 101.748 4.84639C101.748 4.82061 101.696 4.87217 101.722 4.84639C101.722 4.82061 101.825 4.79483 101.8 4.79483L101.748 4.82061H101.696C101.671 4.82061 101.645 4.87217 101.593 4.87217C101.567 4.87217 101.593 4.84639 101.541 4.87217C101.464 4.92373 101.412 4.9495 101.335 5.00106H101.283C101.283 5.00106 101.361 4.9495 101.335 4.97528L101.257 5.00106C101.232 5.00106 101.206 5.02684 101.18 5.02684C101.206 5.02684 101.257 5.00106 101.257 5.02684C101.232 5.02684 101.206 5.05262 101.206 5.05262C101.18 5.0784 101.154 5.0784 101.128 5.0784C101.051 5.10418 101.18 5.02684 101.154 5.02684L101.077 5.0784L100.999 5.10418H100.973C100.999 5.10418 100.999 5.10418 100.999 5.10418C100.947 5.12995 100.999 5.10418 100.947 5.15573C100.947 5.15573 100.87 5.18151 100.818 5.20729C100.818 5.23307 100.793 5.23307 100.844 5.20729C100.844 5.20729 100.793 5.25885 100.767 5.25885L100.715 5.28463C100.715 5.28463 100.715 5.28463 100.689 5.28463C100.767 5.23307 100.818 5.20729 100.896 5.15573C100.973 5.10418 101.051 5.0784 101.077 5.05262C101.077 5.05262 101.077 5.05262 101.077 5.02684L101.128 5.00106L101.232 4.9495L101.361 4.92373C101.361 4.92373 101.361 4.92373 101.386 4.92373H101.412C101.438 4.92373 101.438 4.89795 101.464 4.87217L101.386 4.92373C101.386 4.92373 101.386 4.92373 101.412 4.87217C101.386 4.87217 101.386 4.87217 101.412 4.87217C101.412 4.87217 101.464 4.84639 101.464 4.87217C101.516 4.84639 101.541 4.82061 101.619 4.79483C101.671 4.76905 101.748 4.71749 101.8 4.71749C101.696 4.74327 101.877 4.66594 101.774 4.71749C101.851 4.66594 101.851 4.7175 101.929 4.66594L101.877 4.69172C102.006 4.61438 102.11 4.61438 102.213 4.56282L102.29 4.53704C102.11 4.51127 102.084 4.56282 101.929 4.64016ZM103.22 4.09881C103.168 4.09881 103.039 4.12459 103.039 4.09881C103.039 4.07303 103.065 4.09881 103.117 4.07303L103.375 3.96991C103.22 4.04725 103.143 4.12459 103.375 4.02147H103.401C103.323 4.07303 103.246 4.07303 103.22 4.09881ZM103.039 4.15036C103.013 4.15036 103.013 4.15036 103.039 4.15036C102.988 4.17614 103.013 4.17614 102.988 4.15036H103.039ZM102.988 4.20192C102.91 4.2277 102.884 4.25348 102.807 4.27926L102.833 4.25348C102.755 4.27926 102.781 4.30504 102.678 4.33081C102.626 4.33081 102.523 4.38237 102.523 4.38237C102.523 4.38237 102.471 4.43393 102.445 4.43393C102.419 4.43393 102.29 4.48549 102.316 4.45971C102.342 4.45971 102.394 4.43393 102.394 4.40815L102.342 4.43393L102.368 4.40815C102.342 4.40815 102.342 4.40815 102.368 4.40815L102.445 4.38237L102.523 4.35659C102.471 4.38237 102.445 4.40815 102.523 4.38237C102.549 4.35659 102.652 4.30504 102.626 4.33081C102.549 4.35659 102.626 4.35659 102.549 4.38237C102.574 4.38237 102.626 4.35659 102.652 4.35659C102.626 4.35659 102.652 4.33081 102.704 4.30504C102.729 4.30504 102.781 4.27926 102.807 4.25348C102.807 4.25348 102.833 4.25348 102.781 4.27926C102.807 4.27926 102.833 4.25348 102.858 4.25348C102.858 4.25348 102.807 4.25348 102.833 4.25348C102.858 4.25348 102.884 4.2277 102.884 4.20192H102.91H102.962C102.91 4.20192 102.936 4.20192 102.936 4.2277C102.91 4.2277 102.936 4.2277 102.988 4.20192L102.936 4.2277C102.962 4.2277 103.013 4.17614 102.988 4.20192ZM103.607 3.99569C103.633 3.99569 103.556 4.02147 103.53 4.02147C103.504 4.02147 103.452 4.04725 103.427 4.02147C103.427 3.99569 103.427 4.02147 103.452 4.02147L103.504 3.99569C103.478 3.99569 103.478 3.99569 103.478 4.02147C103.556 3.96991 103.556 3.99569 103.607 3.99569ZM107.507 2.93876C107.507 2.96454 107.507 2.96454 107.507 2.93876V2.93876ZM107.326 2.99032C107.326 2.99032 107.326 2.99032 107.378 2.99032H107.274C107.274 2.99032 107.274 2.99032 107.326 2.99032Z",
    fill: "url(#paint43_linear_4741_7283)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M98.778 6.41895C98.7521 6.41895 98.7263 6.44473 98.7263 6.44473C98.7263 6.4705 98.778 6.41895 98.778 6.41895Z",
    fill: "url(#paint44_linear_4741_7283)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M98.778 6.44482C98.7521 6.4706 98.7521 6.4706 98.7263 6.4706L98.778 6.44482Z",
    fill: "url(#paint45_linear_4741_7283)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7522 6.54808C98.7263 6.54808 98.7005 6.57386 98.6747 6.59964C98.6747 6.62542 98.7522 6.57386 98.7522 6.54808C98.7263 6.59964 98.6747 6.62542 98.623 6.62542C98.623 6.62542 98.7522 6.5223 98.7522 6.54808Z",
    fill: "url(#paint46_linear_4741_7283)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7781 6.57363L98.8039 6.54785L98.7781 6.57363Z",
    fill: "url(#paint47_linear_4741_7283)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4755 5.85205C99.4755 5.85205 99.4497 5.87783 99.4238 5.87783C99.4497 5.85205 99.4497 5.85205 99.4755 5.85205Z",
    fill: "url(#paint48_linear_4741_7283)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M100.431 5.31055C100.353 5.3621 100.302 5.3621 100.224 5.41366C100.328 5.33632 100.379 5.3621 100.431 5.31055Z",
    fill: "url(#paint49_linear_4741_7283)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M100.379 5.28479C100.379 5.31056 100.457 5.25901 100.457 5.28479C100.379 5.31056 100.405 5.28479 100.379 5.28479Z",
    fill: "url(#paint50_linear_4741_7283)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M100.741 5.07851L100.767 5.05273L100.741 5.07851Z",
    fill: "url(#paint51_linear_4741_7283)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.198 5.69717L100.173 5.72294L100.224 5.67139L100.198 5.69717Z",
    fill: "url(#paint52_linear_4741_7283)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100.482 5.43968H100.457C100.457 5.43968 100.482 5.4139 100.482 5.43968Z",
    fill: "url(#paint53_linear_4741_7283)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M101.025 4.92383L100.973 4.94961L101.025 4.92383Z",
    fill: "url(#paint54_linear_4741_7283)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M100.766 5.33651C100.741 5.33651 100.741 5.36229 100.766 5.33651C100.741 5.36229 100.818 5.28496 100.766 5.33651Z",
    fill: "url(#paint55_linear_4741_7283)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M101.128 5.02724C101.128 5.02724 101.154 5.00146 101.18 5.00146C101.154 5.02724 101.128 5.02724 101.128 5.02724Z",
    fill: "url(#paint56_linear_4741_7283)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M101.361 4.92405C101.335 4.92405 101.335 4.92405 101.335 4.92405C101.361 4.92405 101.386 4.89828 101.361 4.92405Z",
    fill: "url(#paint57_linear_4741_7283)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M102.032 4.38281C101.98 4.40859 101.954 4.43437 101.954 4.43437C101.903 4.46015 101.903 4.43437 101.877 4.46015C101.954 4.43437 101.954 4.40859 102.032 4.38281Z",
    fill: "url(#paint58_linear_4741_7283)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M102.083 4.35683C102.083 4.35683 102.135 4.33105 102.109 4.33105C102.109 4.33105 102.109 4.33106 102.083 4.35683Z",
    fill: "url(#paint59_linear_4741_7283)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M101.954 4.58887C101.929 4.58887 101.929 4.61465 101.903 4.61465C101.929 4.61465 101.954 4.58887 101.954 4.58887Z",
    fill: "url(#paint60_linear_4741_7283)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M102.316 4.2793C102.264 4.30508 102.29 4.30508 102.316 4.2793V4.2793Z",
    fill: "url(#paint61_linear_4741_7283)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M102.084 4.53711H102.058L102.032 4.56289L102.084 4.53711Z",
    fill: "url(#paint62_linear_4741_7283)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M101.98 4.71757C101.929 4.71757 102.032 4.66601 101.98 4.71757C102.058 4.64024 101.954 4.71757 102.032 4.66602C102.006 4.69179 101.98 4.71757 101.98 4.71757Z",
    fill: "url(#paint63_linear_4741_7283)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M102.264 4.56289L102.187 4.58867C102.213 4.58867 102.264 4.56289 102.264 4.56289C102.316 4.53711 102.342 4.53711 102.342 4.53711C102.342 4.56289 102.29 4.58867 102.264 4.56289Z",
    fill: "url(#paint64_linear_4741_7283)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M102.523 4.38281C102.497 4.38281 102.471 4.40859 102.445 4.40859C102.471 4.38281 102.523 4.38281 102.523 4.38281Z",
    fill: "url(#paint65_linear_4741_7283)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M103.168 4.20205L103.246 4.17627C103.194 4.20205 103.194 4.20205 103.168 4.20205H103.22C103.168 4.22783 103.143 4.22783 103.168 4.20205Z",
    fill: "url(#paint66_linear_4741_7283)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M104.769 3.40322C104.795 3.40322 104.743 3.40322 104.743 3.40322L104.847 3.37744L104.769 3.40322Z",
    fill: "url(#paint67_linear_4741_7283)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M104.898 3.35156C104.847 3.37734 104.873 3.37734 104.898 3.35156V3.35156Z",
    fill: "url(#paint68_linear_4741_7283)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M104.924 3.60938L104.898 3.63515L104.924 3.60938Z",
    fill: "url(#paint69_linear_4741_7283)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M105.182 3.53174C105.157 3.53174 105.131 3.55752 105.105 3.55752C105.131 3.53174 105.131 3.53174 105.182 3.53174Z",
    fill: "url(#paint70_linear_4741_7283)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M105.157 3.63515H105.105L105.157 3.60938V3.63515Z",
    fill: "url(#paint71_linear_4741_7283)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M106.887 2.99046C106.809 2.99046 106.68 3.04202 106.68 3.01624C106.603 3.01624 106.525 3.01624 106.448 3.0678C106.525 3.0678 106.5 3.0678 106.603 3.0678C106.448 3.09358 106.345 3.11935 106.19 3.14513C106.293 3.11935 106.112 3.14513 106.164 3.11935H106.215H106.293C106.267 3.11935 106.267 3.11935 106.267 3.14513C106.37 3.11935 106.293 3.14513 106.37 3.09358L106.474 3.0678C106.448 3.0678 106.474 3.0678 106.5 3.0678L106.68 3.04202C106.784 2.99046 106.887 2.96468 106.887 2.99046C106.939 2.96468 106.809 2.99046 106.887 2.99046Z",
    fill: "url(#paint72_linear_4741_7283)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.119 2.93896L107.042 2.96474C107.042 2.93896 107.042 2.93896 107.119 2.93896Z",
    fill: "url(#paint73_linear_4741_7283)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M105.906 3.48027C105.906 3.48027 105.88 3.48027 105.828 3.48027C105.802 3.48027 105.802 3.48027 105.802 3.48027C105.777 3.48027 105.751 3.48027 105.725 3.48027C105.802 3.45449 105.88 3.45449 105.983 3.42871C106.035 3.42871 105.983 3.45449 105.983 3.48027L105.88 3.50605C105.906 3.48027 105.802 3.50605 105.906 3.48027Z",
    fill: "url(#paint74_linear_4741_7283)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6605 7.34717L96.6347 7.37295C96.6088 7.39872 96.583 7.4245 96.6088 7.39872C96.5314 7.4245 96.5572 7.45028 96.5314 7.4245C96.4797 7.45028 96.4539 7.47606 96.5055 7.45028L96.4022 7.52762L96.4797 7.47606C96.4539 7.47606 96.3764 7.5534 96.3506 7.5534L96.4797 7.47606C96.5055 7.45028 96.5572 7.4245 96.583 7.39872C96.583 7.39872 96.583 7.39872 96.5572 7.39872C96.6347 7.32139 96.5572 7.39873 96.6605 7.34717Z",
    fill: "url(#paint75_linear_4741_7283)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7381 7.24412L96.8155 7.21834L96.893 7.16678C96.893 7.16678 96.9705 7.141 96.9188 7.16678C96.9188 7.16678 96.893 7.16678 96.893 7.19256C96.9188 7.19256 96.9963 7.11522 96.9963 7.141C96.9705 7.16678 96.9188 7.19256 96.8672 7.21834C96.8155 7.24412 96.7897 7.29567 96.7381 7.32145C96.7122 7.32145 96.7122 7.32145 96.6864 7.34723C96.7122 7.29568 96.7381 7.29568 96.7381 7.24412L96.6348 7.32145C96.6606 7.29567 96.7639 7.24412 96.7897 7.19256C96.7381 7.24412 96.8155 7.19256 96.7381 7.24412Z",
    fill: "url(#paint76_linear_4741_7283)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2946 5.59424C99.2688 5.62002 99.2946 5.62002 99.2946 5.59424C99.2429 5.62002 99.2429 5.6458 99.2946 5.59424Z",
    fill: "url(#paint77_linear_4741_7283)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M99.656 5.59398C99.6818 5.5682 99.6818 5.59398 99.656 5.59398V5.59398Z",
    fill: "url(#paint78_linear_4741_7283)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9962 7.08944C96.9962 7.08944 96.9188 7.141 96.8929 7.16678C96.8671 7.16678 96.9188 7.141 96.8929 7.16678C96.9188 7.16678 96.9446 7.141 96.9704 7.11522C96.9704 7.11522 96.9446 7.11522 96.8929 7.141C96.8413 7.16678 96.9188 7.11522 96.8929 7.141C96.9704 7.06366 97.0737 7.01211 97.177 6.98633C97.0995 7.03789 97.0479 7.06366 96.9704 7.11522H96.9962C97.0479 7.06366 97.0737 7.03789 97.1512 7.01211L96.9962 7.08944C96.9446 7.141 96.9962 7.08944 97.0479 7.06366C97.0479 7.06366 97.0221 7.06366 97.0221 7.08944C97.0221 7.08944 96.8929 7.16678 96.9962 7.08944Z",
    fill: "url(#paint79_linear_4741_7283)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7781 6.00664C98.7781 5.98086 98.8039 5.98086 98.7781 6.00664V6.00664Z",
    fill: "url(#paint80_linear_4741_7283)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7782 6.05811C98.7523 6.05811 98.7265 6.08388 98.7007 6.08388C98.7265 6.05811 98.7523 6.05811 98.7782 6.05811Z",
    fill: "url(#paint81_linear_4741_7283)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1771 7.03774C97.1513 7.03774 97.0996 7.0893 97.0996 7.06352C97.0996 7.06352 97.1771 6.98619 97.1771 7.03774Z",
    fill: "url(#paint82_linear_4741_7283)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1513 7.0376L97.1254 7.06338C97.1254 7.06338 97.1254 7.06338 97.0996 7.06338L97.1513 7.0376Z",
    fill: "url(#paint83_linear_4741_7283)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0995 7.16667C97.0737 7.16667 97.022 7.19245 96.9962 7.21823C97.022 7.244 97.0995 7.16667 97.0995 7.16667C97.022 7.244 96.9962 7.244 96.9187 7.29556C96.9703 7.244 97.0995 7.14089 97.0995 7.16667Z",
    fill: "url(#paint84_linear_4741_7283)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1252 7.19267L97.1769 7.14111V7.16689L97.1252 7.19267Z",
    fill: "url(#paint85_linear_4741_7283)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3461 5.56826C99.2428 5.61982 99.1912 5.6456 99.0879 5.69715C99.217 5.59404 99.2945 5.61982 99.3978 5.54248L99.3461 5.56826Z",
    fill: "url(#paint86_linear_4741_7283)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2946 5.5426C99.2946 5.56838 99.3721 5.51682 99.3721 5.5426C99.2946 5.59416 99.3204 5.5426 99.2688 5.59416L99.2946 5.5426Z",
    fill: "url(#paint87_linear_4741_7283)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M98.959 6.00674L99.0106 5.98096L98.9848 6.00674H98.959Z",
    fill: "url(#paint88_linear_4741_7283)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7595 5.28506L99.7853 5.25928L99.7595 5.28506Z",
    fill: "url(#paint89_linear_4741_7283)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0365 6.00684L98.9848 6.03261L98.959 6.05839L99.0365 6.00684Z",
    fill: "url(#paint90_linear_4741_7283)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M99.372 5.69716L99.3203 5.72294C99.3461 5.72294 99.3978 5.67138 99.372 5.69716Z",
    fill: "url(#paint91_linear_4741_7283)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M100.069 5.10439L100.147 5.07861H100.121L100.069 5.10439Z",
    fill: "url(#paint92_linear_4741_7283)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7593 5.5426C99.7077 5.56838 99.7335 5.5426 99.7335 5.5426C99.7077 5.56838 99.811 5.51682 99.7593 5.5426Z",
    fill: "url(#paint93_linear_4741_7283)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M101.541 4.27968C101.541 4.27968 101.516 4.30546 101.49 4.30546C101.49 4.30546 101.567 4.2539 101.541 4.27968Z",
    fill: "url(#paint94_linear_4741_7283)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M102.858 3.94424L102.936 3.91846C102.936 3.94424 102.936 3.91846 102.858 3.94424H102.936C102.884 3.94424 102.858 3.97001 102.858 3.94424Z",
    fill: "url(#paint95_linear_4741_7283)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M109.185 2.57802C109.159 2.57802 109.134 2.57802 109.134 2.57802C109.159 2.57802 109.159 2.57802 109.185 2.57802C109.134 2.57802 109.159 2.55225 109.159 2.55225C109.237 2.55225 109.185 2.57802 109.185 2.57802Z",
    fill: "url(#paint96_linear_4741_7283)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M109.237 2.34599C109.211 2.34599 109.185 2.34599 109.185 2.34599C109.159 2.32022 109.237 2.32022 109.237 2.34599Z",
    fill: "url(#paint97_linear_4741_7283)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M109.211 2.34619C109.211 2.34619 109.185 2.34619 109.159 2.37197C109.159 2.34619 109.185 2.34619 109.211 2.34619Z",
    fill: "url(#paint98_linear_4741_7283)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M109.237 2.26855C109.237 2.26855 109.237 2.29433 109.211 2.29433C109.185 2.26856 109.211 2.26855 109.237 2.26855Z",
    fill: "url(#paint99_linear_4741_7283)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M108.953 2.57812C108.953 2.57812 108.979 2.57812 109.005 2.57812C109.005 2.57812 108.953 2.6039 108.953 2.57812Z",
    fill: "url(#paint100_linear_4741_7283)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M108.953 2.57812C108.927 2.6039 108.979 2.62968 108.953 2.65546C108.901 2.65546 108.901 2.68124 108.875 2.70702C108.85 2.65546 108.875 2.6039 108.953 2.57812Z",
    fill: "url(#paint101_linear_4741_7283)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M108.281 2.80986C108.281 2.78408 108.281 2.78408 108.281 2.80986C108.333 2.78408 108.307 2.78408 108.307 2.80986C108.307 2.78408 108.307 2.80986 108.281 2.80986Z",
    fill: "url(#paint102_linear_4741_7283)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M108.204 2.78418C108.256 2.78418 108.178 2.83574 108.178 2.80996C108.152 2.78418 108.204 2.78418 108.204 2.78418Z",
    fill: "url(#paint103_linear_4741_7283)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M107.713 2.78418C107.687 2.78418 107.687 2.80996 107.713 2.78418V2.78418Z",
    fill: "url(#paint104_linear_4741_7283)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M106.061 3.09365L106.19 3.06787C106.164 3.09365 106.138 3.09365 106.061 3.09365C106.138 3.09365 106.035 3.11943 106.035 3.11943C106.061 3.11943 106.086 3.11943 106.112 3.11943L106.086 3.14521C106.009 3.17099 105.983 3.14521 105.906 3.17099C105.906 3.17099 105.931 3.17099 105.88 3.19676C105.802 3.19676 105.802 3.22254 105.751 3.22254C105.699 3.22254 105.647 3.22254 105.596 3.24832C105.518 3.24832 105.441 3.2741 105.389 3.2741H105.467C105.415 3.2741 105.415 3.2741 105.363 3.2741C105.363 3.2741 105.363 3.2741 105.389 3.2741C105.389 3.2741 105.338 3.2741 105.312 3.2741H105.234C105.183 3.2741 105.234 3.2741 105.234 3.24832C105.208 3.24832 105.157 3.24832 105.157 3.2741C105.157 3.2741 105.208 3.2741 105.183 3.2741H105.105C105.028 3.29988 105.157 3.2741 105.208 3.2741C105.131 3.29988 105.105 3.2741 105.028 3.29988C105.053 3.29988 105.053 3.29988 105.079 3.2741C105.079 3.2741 105.002 3.2741 104.95 3.29988H104.924C104.95 3.29988 105.002 3.2741 105.028 3.2741C105.002 3.29988 105.131 3.24832 105.183 3.24832H105.234H105.26C105.26 3.24832 105.26 3.24832 105.234 3.24832C105.26 3.24832 105.312 3.22254 105.312 3.24832L105.389 3.22254L105.467 3.19676L105.622 3.17099C105.622 3.17099 105.622 3.17099 105.647 3.17099L105.828 3.14521C105.828 3.14521 105.854 3.14521 105.88 3.14521L106.035 3.11943C106.035 3.09365 106.061 3.09365 106.061 3.09365Z",
    fill: "url(#paint105_linear_4741_7283)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M105.131 2.34617H105.079C105.105 2.32039 105.131 2.29462 105.131 2.34617Z",
    fill: "url(#paint106_linear_4741_7283)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M104.821 2.39746C104.795 2.39746 104.769 2.42324 104.769 2.39746C104.795 2.39746 104.821 2.39746 104.821 2.39746Z",
    fill: "url(#paint107_linear_4741_7283)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M104.743 3.35158C104.743 3.3258 104.769 3.3258 104.795 3.3258C104.795 3.3258 104.795 3.3258 104.769 3.3258C104.769 3.3258 104.769 3.3258 104.795 3.3258C104.795 3.35158 104.821 3.30002 104.821 3.3258C104.821 3.35158 104.769 3.3258 104.795 3.35158C104.769 3.3258 104.769 3.3258 104.743 3.35158Z",
    fill: "url(#paint108_linear_4741_7283)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M104.769 3.30003C104.744 3.32581 104.718 3.32581 104.718 3.30003C104.744 3.30003 104.769 3.27425 104.769 3.30003Z",
    fill: "url(#paint109_linear_4741_7283)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M104.614 3.2998C104.588 3.2998 104.588 3.29981 104.563 3.32558C104.563 3.29981 104.537 3.32558 104.511 3.32558C104.537 3.32558 104.614 3.2998 104.614 3.2998Z",
    fill: "url(#paint110_linear_4741_7283)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M104.382 2.52675C104.382 2.50098 104.408 2.52676 104.46 2.50098C104.46 2.50098 104.382 2.50098 104.382 2.52675Z",
    fill: "url(#paint111_linear_4741_7283)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M104.382 2.55225C104.408 2.55225 104.408 2.55225 104.434 2.55225C104.408 2.55225 104.382 2.57802 104.382 2.55225Z",
    fill: "url(#paint112_linear_4741_7283)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M104.15 3.48037C104.15 3.45459 104.175 3.45459 104.227 3.45459C104.175 3.45459 104.15 3.48037 104.15 3.48037Z",
    fill: "url(#paint113_linear_4741_7283)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M102.807 3.14511C102.832 3.14511 102.832 3.11933 102.858 3.11933C102.884 3.11933 102.858 3.14511 102.884 3.11933C102.962 3.09355 103.013 3.06777 103.091 3.04199V3.06777C103.117 3.06777 103.142 3.04199 103.142 3.04199C103.117 3.04199 103.117 3.06777 103.091 3.06777C103.065 3.04199 103.013 3.04199 102.987 3.06777C102.962 3.09355 102.936 3.09355 102.91 3.11933C102.91 3.11933 102.91 3.11933 102.884 3.11933C102.858 3.11933 102.807 3.14511 102.807 3.14511Z",
    fill: "url(#paint114_linear_4741_7283)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M102.962 3.19658C102.91 3.22236 102.884 3.22236 102.807 3.22236C102.884 3.19658 102.936 3.22236 102.962 3.19658C102.962 3.1708 103.013 3.14502 103.039 3.14502C103.039 3.14502 103.039 3.1708 103.013 3.1708L102.962 3.19658Z",
    fill: "url(#paint115_linear_4741_7283)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M102.755 3.27431C102.781 3.27431 102.755 3.24854 102.781 3.24854C102.807 3.24854 102.781 3.24853 102.781 3.27431C102.781 3.27431 102.781 3.27431 102.755 3.27431Z",
    fill: "url(#paint116_linear_4741_7283)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M102.677 3.14541C102.703 3.14541 102.729 3.11963 102.755 3.11963C102.729 3.11963 102.677 3.14541 102.677 3.14541Z",
    fill: "url(#paint117_linear_4741_7283)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M102.419 3.24844C102.419 3.24844 102.471 3.22266 102.497 3.22266C102.471 3.22266 102.445 3.22266 102.419 3.24844Z",
    fill: "url(#paint118_linear_4741_7283)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 3.27422C102.471 3.27422 102.445 3.27422 102.419 3.27422C102.445 3.24844 102.497 3.24844 102.497 3.27422Z",
    fill: "url(#paint119_linear_4741_7283)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M102.342 3.2998C102.342 3.2998 102.342 3.29981 102.316 3.32558C102.29 3.32558 102.316 3.2998 102.342 3.2998Z",
    fill: "url(#paint120_linear_4741_7283)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M102.264 3.3515C102.239 3.3515 102.213 3.37728 102.187 3.37728C102.187 3.3515 102.239 3.32572 102.264 3.3515Z",
    fill: "url(#paint121_linear_4741_7283)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M102.213 3.32568C102.187 3.32568 102.161 3.35146 102.135 3.35146H102.109H102.161C102.161 3.37724 102.238 3.32568 102.213 3.32568Z",
    fill: "url(#paint122_linear_4741_7283)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M102.109 3.40322C102.135 3.40322 102.161 3.37744 102.187 3.37744C102.135 3.37744 102.109 3.40322 102.109 3.40322Z",
    fill: "url(#paint123_linear_4741_7283)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M102.084 3.40277C102.058 3.42855 102.006 3.45433 101.98 3.45433C101.98 3.45433 102.006 3.42855 102.032 3.42855C102.032 3.40277 102.084 3.37699 102.084 3.40277Z",
    fill: "url(#paint124_linear_4741_7283)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M101.799 3.60938C101.774 3.60938 101.774 3.63515 101.748 3.63515C101.748 3.63515 101.799 3.63515 101.799 3.60938Z",
    fill: "url(#paint125_linear_4741_7283)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M101.593 3.58323C101.593 3.58323 101.67 3.55746 101.645 3.58323C101.619 3.60901 101.593 3.60901 101.593 3.58323C101.593 3.60901 101.567 3.58323 101.593 3.58323Z",
    fill: "url(#paint126_linear_4741_7283)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M101.619 4.02187C101.645 4.02187 101.645 4.02187 101.671 3.99609V4.02187C101.645 4.02187 101.619 4.02187 101.619 4.02187Z",
    fill: "url(#paint127_linear_4741_7283)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M101.361 3.84111C101.361 3.81533 101.386 3.81533 101.412 3.78955C101.412 3.78955 101.386 3.81533 101.361 3.84111Z",
    fill: "url(#paint128_linear_4741_7283)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M101.335 3.58361C101.335 3.58361 101.309 3.58361 101.283 3.60939C101.283 3.58361 101.309 3.58361 101.335 3.58361C101.335 3.55783 101.309 3.60939 101.335 3.58361Z",
    fill: "url(#paint129_linear_4741_7283)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M101.386 3.84111C101.361 3.84111 101.36 3.86689 101.335 3.86689C101.309 3.86689 101.361 3.84111 101.386 3.84111C101.386 3.81533 101.361 3.84111 101.386 3.84111C101.386 3.81533 101.386 3.81533 101.386 3.84111Z",
    fill: "url(#paint130_linear_4741_7283)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M101.36 3.84105C101.335 3.84105 101.309 3.86683 101.309 3.84105C101.335 3.84105 101.283 3.84105 101.36 3.84105C101.335 3.84105 101.335 3.81527 101.36 3.84105Z",
    fill: "url(#paint131_linear_4741_7283)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M101.309 3.89297C101.309 3.86719 101.335 3.86719 101.309 3.89297C101.335 3.89297 101.36 3.86719 101.36 3.86719L101.309 3.89297Z",
    fill: "url(#paint132_linear_4741_7283)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M101.206 3.76406C101.231 3.76406 101.231 3.76406 101.257 3.73828C101.257 3.76406 101.206 3.76406 101.206 3.76406Z",
    fill: "url(#paint133_linear_4741_7283)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M101.283 3.84131C101.257 3.84131 101.283 3.86709 101.257 3.86709C101.257 3.86709 101.257 3.86709 101.283 3.84131C101.257 3.84131 101.257 3.86709 101.231 3.84131H101.283Z",
    fill: "url(#paint134_linear_4741_7283)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M101.128 3.66064C101.102 3.68642 101.051 3.7122 101.051 3.68642C101.076 3.68642 101.128 3.66064 101.128 3.66064Z",
    fill: "url(#paint135_linear_4741_7283)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M101.231 3.86719C101.231 3.86719 101.206 3.89297 101.18 3.89297C101.206 3.86719 101.206 3.86719 101.231 3.86719Z",
    fill: "url(#paint136_linear_4741_7283)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M101.18 3.81533C101.206 3.81533 101.206 3.78955 101.206 3.78955C101.206 3.81533 101.18 3.81533 101.18 3.81533Z",
    fill: "url(#paint137_linear_4741_7283)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M101.18 3.78978C101.154 3.78978 101.128 3.81556 101.128 3.78978C101.154 3.78978 101.18 3.764 101.18 3.78978Z",
    fill: "url(#paint138_linear_4741_7283)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M101.206 3.84143C101.18 3.8672 101.128 3.89298 101.102 3.89298C101.102 3.89298 101.128 3.89298 101.128 3.8672C101.128 3.8672 101.128 3.84143 101.102 3.84143C101.128 3.81565 101.128 3.8672 101.206 3.84143Z",
    fill: "url(#paint139_linear_4741_7283)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M101.051 3.7124C100.999 3.73818 100.973 3.76396 100.921 3.78974C100.921 3.76396 100.999 3.73818 101.051 3.7124C101.025 3.7124 101.025 3.7124 101.051 3.7124Z",
    fill: "url(#paint140_linear_4741_7283)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M100.921 4.07304C100.947 4.07304 100.973 4.04726 100.999 4.02148C100.973 4.02148 100.973 4.02148 100.947 4.04726C100.973 4.07304 100.921 4.09882 100.921 4.07304Z",
    fill: "url(#paint141_linear_4741_7283)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M100.973 4.09912C100.947 4.1249 100.922 4.1249 100.896 4.15068C100.947 4.1249 100.973 4.09912 100.973 4.09912Z",
    fill: "url(#paint142_linear_4741_7283)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M100.818 4.15039C100.818 4.12461 100.844 4.12461 100.818 4.15039C100.87 4.09883 100.87 4.12461 100.896 4.12461C100.896 4.12461 100.844 4.15039 100.87 4.15039C100.844 4.15039 100.87 4.12461 100.818 4.15039Z",
    fill: "url(#paint143_linear_4741_7283)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M100.637 3.99589C100.689 3.97011 100.715 3.94434 100.767 3.94434C100.741 3.94434 100.689 3.99589 100.637 3.99589Z",
    fill: "url(#paint144_linear_4741_7283)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M100.896 4.58905C100.947 4.56328 100.973 4.5375 101.051 4.51172C100.999 4.5375 100.947 4.56328 100.896 4.58905Z",
    fill: "url(#paint145_linear_4741_7283)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M100.818 4.09906C100.792 4.09906 100.767 4.12484 100.767 4.12484C100.818 4.09906 100.818 4.07328 100.818 4.09906Z",
    fill: "url(#paint146_linear_4741_7283)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M100.637 3.99609C100.612 3.99609 100.612 4.02187 100.586 4.02187C100.586 3.99609 100.612 3.99609 100.637 3.99609Z",
    fill: "url(#paint147_linear_4741_7283)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M100.767 4.45986C100.792 4.45986 100.818 4.43408 100.844 4.43408C100.818 4.45986 100.792 4.45986 100.767 4.45986Z",
    fill: "url(#paint148_linear_4741_7283)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M100.638 4.09912C100.638 4.1249 100.612 4.1249 100.56 4.15068C100.56 4.1249 100.638 4.1249 100.638 4.09912Z",
    fill: "url(#paint149_linear_4741_7283)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M100.586 4.15039C100.534 4.15039 100.508 4.20195 100.482 4.20195C100.508 4.20195 100.586 4.15039 100.586 4.15039Z",
    fill: "url(#paint150_linear_4741_7283)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M100.792 4.74355C100.818 4.71777 100.844 4.71777 100.87 4.71777C100.87 4.71777 100.818 4.71777 100.792 4.74355Z",
    fill: "url(#paint151_linear_4741_7283)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M100.56 4.20215C100.56 4.20215 100.534 4.22793 100.508 4.22793C100.534 4.22793 100.534 4.20215 100.56 4.20215Z",
    fill: "url(#paint152_linear_4741_7283)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M100.534 4.15039C100.508 4.15039 100.508 4.17617 100.534 4.15039V4.15039Z",
    fill: "url(#paint153_linear_4741_7283)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M100.302 4.20195C100.328 4.20195 100.353 4.17617 100.379 4.15039C100.379 4.15039 100.379 4.15039 100.405 4.15039C100.379 4.17617 100.353 4.20195 100.302 4.20195C100.302 4.22773 100.302 4.22773 100.302 4.20195Z",
    fill: "url(#paint154_linear_4741_7283)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M100.224 4.20195L100.302 4.15039C100.276 4.17617 100.25 4.17617 100.224 4.20195Z",
    fill: "url(#paint155_linear_4741_7283)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M100.276 4.20238C100.25 4.20238 100.328 4.1766 100.302 4.20238C100.302 4.1766 100.302 4.20238 100.276 4.20238Z",
    fill: "url(#paint156_linear_4741_7283)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M100.405 4.43398C100.353 4.48554 100.353 4.4082 100.302 4.45976C100.302 4.43398 100.405 4.4082 100.405 4.4082C100.379 4.43398 100.405 4.43398 100.405 4.43398Z",
    fill: "url(#paint157_linear_4741_7283)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M100.353 4.69208C100.405 4.6663 100.405 4.64052 100.457 4.61475C100.457 4.61475 100.457 4.61475 100.431 4.61475C100.379 4.64052 100.379 4.69208 100.353 4.69208Z",
    fill: "url(#paint158_linear_4741_7283)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M100.302 4.38281C100.276 4.38281 100.224 4.43437 100.224 4.43437C100.25 4.40859 100.276 4.38281 100.302 4.38281Z",
    fill: "url(#paint159_linear_4741_7283)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M100.224 4.51168C100.199 4.51168 100.276 4.46013 100.25 4.51168C100.25 4.48591 100.25 4.51168 100.224 4.51168Z",
    fill: "url(#paint160_linear_4741_7283)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M100.353 4.64014C100.353 4.64014 100.328 4.66592 100.302 4.66592V4.64014C100.328 4.66592 100.353 4.64014 100.353 4.64014Z",
    fill: "url(#paint161_linear_4741_7283)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M100.224 4.64052C100.224 4.64052 100.25 4.61475 100.276 4.61475H100.302C100.276 4.64052 100.25 4.64052 100.224 4.64052Z",
    fill: "url(#paint162_linear_4741_7283)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M100.147 4.79501C100.224 4.76923 100.276 4.71767 100.328 4.69189C100.328 4.69189 100.276 4.69189 100.302 4.69189C100.25 4.69189 100.199 4.74345 100.147 4.79501C100.173 4.76923 100.199 4.74345 100.224 4.71767C100.224 4.74345 100.147 4.76923 100.095 4.79501H100.147ZM100.224 4.71767L100.276 4.69189C100.276 4.69189 100.25 4.71767 100.224 4.71767Z",
    fill: "url(#paint163_linear_4741_7283)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9919 4.45986C100.018 4.45986 100.044 4.43408 100.069 4.43408C100.018 4.43408 99.9919 4.45986 99.9919 4.45986Z",
    fill: "url(#paint164_linear_4741_7283)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M99.966 4.33105C99.9143 4.33105 99.8885 4.38261 99.811 4.38261C99.8627 4.35683 99.9143 4.33105 99.966 4.33105Z",
    fill: "url(#paint165_linear_4741_7283)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M100.121 4.71767L100.147 4.69189C100.172 4.74345 100.147 4.71767 100.121 4.71767Z",
    fill: "url(#paint166_linear_4741_7283)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M100.147 4.79482C100.147 4.79482 100.173 4.76904 100.199 4.76904C100.147 4.79482 100.121 4.8206 100.147 4.79482Z",
    fill: "url(#paint167_linear_4741_7283)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M100.069 4.71767C100.069 4.71767 100.095 4.69189 100.121 4.69189C100.121 4.69189 100.069 4.74345 100.069 4.71767Z",
    fill: "url(#paint168_linear_4741_7283)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M100.018 4.66592C100.043 4.66592 100.043 4.66592 100.069 4.64014H100.095C100.069 4.66592 100.043 4.66592 100.018 4.66592C100.018 4.69169 99.9918 4.69169 100.018 4.66592Z",
    fill: "url(#paint169_linear_4741_7283)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M100.121 4.74339C100.095 4.74339 100.069 4.74339 100.095 4.74339C100.121 4.71761 100.095 4.74339 100.121 4.74339Z",
    fill: "url(#paint170_linear_4741_7283)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M100.018 4.64052C100.018 4.64052 99.9919 4.6663 99.9661 4.6663C99.9919 4.6663 99.9919 4.61474 100.018 4.64052Z",
    fill: "url(#paint171_linear_4741_7283)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M100.199 4.94971C100.173 4.97549 100.121 5.00126 100.095 5.00126C100.121 4.97549 100.173 4.94971 100.199 4.94971Z",
    fill: "url(#paint172_linear_4741_7283)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7852 4.56328C99.811 4.5375 99.8626 4.51172 99.9143 4.51172C99.8626 4.5375 99.8368 4.5375 99.7852 4.56328Z",
    fill: "url(#paint173_linear_4741_7283)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8886 4.58861C99.8886 4.58861 99.8886 4.58861 99.8628 4.61438C99.8628 4.56283 99.8628 4.58861 99.8886 4.58861Z",
    fill: "url(#paint174_linear_4741_7283)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8886 4.64052C99.8886 4.64052 99.8628 4.6663 99.8628 4.64052C99.8628 4.61475 99.8628 4.61475 99.8886 4.64052C99.8628 4.61475 99.8628 4.61475 99.8886 4.64052C99.8886 4.61475 99.8886 4.61475 99.8886 4.61475C99.8628 4.61475 99.9144 4.61475 99.8886 4.64052Z",
    fill: "url(#paint175_linear_4741_7283)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8112 4.61475C99.7854 4.64052 99.7853 4.64052 99.7595 4.64052C99.7595 4.64052 99.7595 4.61475 99.8112 4.61475Z",
    fill: "url(#paint176_linear_4741_7283)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M100.121 5.10443C100.095 5.10443 100.069 5.13021 100.069 5.13021C100.069 5.10443 100.095 5.07865 100.121 5.10443Z",
    fill: "url(#paint177_linear_4741_7283)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8627 4.76904C99.8627 4.76904 99.8369 4.79482 99.811 4.79482C99.811 4.76904 99.8369 4.76904 99.8627 4.76904Z",
    fill: "url(#paint178_linear_4741_7283)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8369 5.13017C99.8627 5.13017 99.8886 5.10439 99.9402 5.07861C99.9144 5.10439 99.8886 5.13017 99.8369 5.13017Z",
    fill: "url(#paint179_linear_4741_7283)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M99.527 4.5375C99.5012 4.5375 99.5528 4.51172 99.5528 4.51172C99.5528 4.5375 99.5528 4.5375 99.527 4.5375Z",
    fill: "url(#paint180_linear_4741_7283)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7595 5.18154C99.7853 5.15576 99.8112 5.15576 99.837 5.15576C99.8112 5.15576 99.7595 5.18154 99.7595 5.18154Z",
    fill: "url(#paint181_linear_4741_7283)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5269 4.79492C99.5011 4.8207 99.4495 4.84648 99.4753 4.8207C99.4753 4.84648 99.5011 4.79492 99.5269 4.79492Z",
    fill: "url(#paint182_linear_4741_7283)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3461 4.69189C99.2945 4.71767 99.2686 4.74345 99.1912 4.76923C99.2428 4.76923 99.3203 4.69189 99.3461 4.69189Z",
    fill: "url(#paint183_linear_4741_7283)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4495 5.00126C99.4753 5.00126 99.5011 4.94971 99.5269 4.94971C99.5011 4.97549 99.5011 5.00126 99.4495 5.00126Z",
    fill: "url(#paint184_linear_4741_7283)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3721 4.76904C99.3979 4.76904 99.3979 4.76904 99.3979 4.76904C99.3721 4.79482 99.3721 4.76904 99.3721 4.76904Z",
    fill: "url(#paint185_linear_4741_7283)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3462 5.05263C99.3462 5.05263 99.372 5.02686 99.3978 5.02686C99.372 5.05263 99.3462 5.05263 99.3462 5.05263Z",
    fill: "url(#paint186_linear_4741_7283)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2946 4.97559C99.2688 4.97559 99.2688 5.00136 99.2688 4.97559H99.2946Z",
    fill: "url(#paint187_linear_4741_7283)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2429 5.00126C99.2429 5.00126 99.2429 4.97549 99.2429 4.94971C99.2429 4.97549 99.2687 4.97549 99.2429 5.00126Z",
    fill: "url(#paint188_linear_4741_7283)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M99.527 5.33636C99.5012 5.33636 99.4753 5.36214 99.4753 5.36214C99.4753 5.33636 99.527 5.31058 99.527 5.33636Z",
    fill: "url(#paint189_linear_4741_7283)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2946 5.02728C99.2946 5.02728 99.2687 5.05306 99.2429 5.05306C99.2429 5.02728 99.2687 5.0015 99.2946 5.02728Z",
    fill: "url(#paint190_linear_4741_7283)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2429 5.07841C99.2687 5.07841 99.2946 5.02686 99.3204 5.02686C99.2687 5.07841 99.2429 5.07841 99.2429 5.07841Z",
    fill: "url(#paint191_linear_4741_7283)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0364 4.97529C99.088 4.94951 99.1138 4.92373 99.1397 4.89795C99.1138 4.92373 99.0622 4.97529 99.0364 4.97529Z",
    fill: "url(#paint192_linear_4741_7283)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2429 5.25908C99.2687 5.25908 99.3204 5.20752 99.3204 5.20752C99.2946 5.2333 99.2946 5.2333 99.2429 5.25908Z",
    fill: "url(#paint193_linear_4741_7283)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1138 5.10429C99.1396 5.10429 99.1912 5.07851 99.2171 5.05273C99.1912 5.07851 99.1396 5.13007 99.1138 5.10429Z",
    fill: "url(#paint194_linear_4741_7283)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3978 5.38818C99.372 5.38818 99.3461 5.41396 99.3203 5.41396C99.372 5.41396 99.372 5.38818 99.3978 5.38818Z",
    fill: "url(#paint195_linear_4741_7283)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0621 5.02708C99.0363 5.02708 99.0105 5.05286 99.0105 5.02708C99.0363 5.02708 99.0363 5.0013 99.0621 5.02708Z",
    fill: "url(#paint196_linear_4741_7283)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1397 5.18187C99.1655 5.15609 99.1655 5.18187 99.1397 5.18187V5.18187Z",
    fill: "url(#paint197_linear_4741_7283)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8814 4.92412C98.8556 4.92412 98.9331 4.87256 98.9589 4.87256C98.9331 4.89834 98.9072 4.92412 98.8814 4.92412Z",
    fill: "url(#paint198_linear_4741_7283)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9846 5.18183C99.0104 5.15605 99.0621 5.13027 99.1137 5.10449C99.0879 5.13027 99.0363 5.15605 98.9846 5.18183Z",
    fill: "url(#paint199_linear_4741_7283)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9588 5.00146C98.9588 5.00146 98.9846 5.00146 99.0105 5.00146C98.9846 5.00146 98.9588 5.02724 98.9588 5.00146C98.933 5.02724 98.933 5.02724 98.9588 5.00146Z",
    fill: "url(#paint200_linear_4741_7283)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0881 5.20775C99.0881 5.20775 99.1139 5.18197 99.1139 5.20775C99.0623 5.20775 99.0106 5.2593 99.0881 5.20775Z",
    fill: "url(#paint201_linear_4741_7283)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1395 5.28467C99.1654 5.28467 99.1654 5.31045 99.1395 5.28467V5.28467Z",
    fill: "url(#paint202_linear_4741_7283)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9847 5.07861C98.9589 5.07861 98.9589 5.10439 98.9331 5.10439H98.9072C98.9331 5.10439 98.9589 5.07861 98.9847 5.07861Z",
    fill: "url(#paint203_linear_4741_7283)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9072 5.15604C98.9072 5.15604 98.9847 5.10449 98.9589 5.13026C98.9331 5.13026 98.9331 5.15604 98.9072 5.15604Z",
    fill: "url(#paint204_linear_4741_7283)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0106 5.25921C98.9848 5.28499 98.9848 5.28499 98.959 5.28499C99.0106 5.25921 99.0106 5.23343 99.0106 5.25921Z",
    fill: "url(#paint205_linear_4741_7283)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2429 5.54248C99.1913 5.59404 99.1655 5.59404 99.1396 5.61982C99.1396 5.59404 99.2429 5.56826 99.2429 5.54248Z",
    fill: "url(#paint206_linear_4741_7283)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1654 5.46527L99.1138 5.49105C99.1396 5.46527 99.1654 5.43949 99.1654 5.46527Z",
    fill: "url(#paint207_linear_4741_7283)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0364 5.59404C99.0364 5.56826 99.1138 5.54248 99.1397 5.54248C99.088 5.56826 99.0622 5.59404 99.0364 5.59404Z",
    fill: "url(#paint208_linear_4741_7283)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9331 5.33643C98.9589 5.33643 98.9589 5.33643 98.9589 5.33643C98.9331 5.33643 98.9331 5.3622 98.9331 5.33643Z",
    fill: "url(#paint209_linear_4741_7283)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9329 5.43964C98.9071 5.43964 98.8555 5.4912 98.8555 5.4912C98.8813 5.46542 98.9329 5.41386 98.9329 5.43964Z",
    fill: "url(#paint210_linear_4741_7283)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6749 5.10439C98.6491 5.10439 98.5974 5.15594 98.5974 5.13017C98.6232 5.13017 98.6491 5.07861 98.6749 5.10439Z",
    fill: "url(#paint211_linear_4741_7283)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0879 5.69717C99.1137 5.69717 99.1395 5.67139 99.1395 5.67139C99.0879 5.69717 99.0879 5.69717 99.0879 5.69717Z",
    fill: "url(#paint212_linear_4741_7283)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M98.778 5.33633L98.8297 5.31055C98.8038 5.31055 98.8038 5.33632 98.7522 5.3621C98.7264 5.3621 98.8038 5.33633 98.778 5.33633Z",
    fill: "url(#paint213_linear_4741_7283)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8814 5.43939C98.8556 5.43939 98.8298 5.46517 98.804 5.46517C98.8298 5.43939 98.8556 5.41361 98.8814 5.43939Z",
    fill: "url(#paint214_linear_4741_7283)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5716 5.07861C98.5716 5.07861 98.5457 5.10439 98.5199 5.10439C98.4941 5.10439 98.5716 5.07861 98.5716 5.07861Z",
    fill: "url(#paint215_linear_4741_7283)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5973 5.25928C98.5973 5.25928 98.5457 5.31083 98.5457 5.28506C98.5457 5.28506 98.5715 5.25928 98.5973 5.25928Z",
    fill: "url(#paint216_linear_4741_7283)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7005 5.38818C98.6747 5.41396 98.6489 5.41396 98.623 5.43974C98.623 5.43974 98.6747 5.38818 98.7005 5.38818Z",
    fill: "url(#paint217_linear_4741_7283)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M98.494 5.18193C98.4682 5.18193 98.4424 5.18193 98.4682 5.18193C98.4682 5.15615 98.494 5.15615 98.494 5.18193Z",
    fill: "url(#paint218_linear_4741_7283)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8555 5.64551C98.8297 5.64551 98.8039 5.69706 98.7781 5.67129C98.8039 5.67129 98.8297 5.64551 98.8555 5.64551Z",
    fill: "url(#paint219_linear_4741_7283)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8038 5.69727C98.8038 5.69727 98.778 5.72304 98.7522 5.72304C98.778 5.69727 98.8038 5.69727 98.8038 5.69727Z",
    fill: "url(#paint220_linear_4741_7283)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8555 5.80029C98.8297 5.80029 98.8039 5.85185 98.7781 5.82607C98.7781 5.82607 98.8297 5.80029 98.8555 5.80029Z",
    fill: "url(#paint221_linear_4741_7283)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7782 5.67139C98.7523 5.72294 98.7007 5.72294 98.7007 5.72294C98.7007 5.72294 98.7265 5.69717 98.7782 5.67139Z",
    fill: "url(#paint222_linear_4741_7283)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3132 5.28467C98.3391 5.28467 98.3649 5.28467 98.3907 5.28467L98.3649 5.31045C98.3391 5.28467 98.3132 5.28467 98.3132 5.28467Z",
    fill: "url(#paint223_linear_4741_7283)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8556 5.82617C98.8298 5.82617 98.8298 5.85195 98.804 5.85195C98.804 5.85195 98.8298 5.82617 98.8556 5.82617Z",
    fill: "url(#paint224_linear_4741_7283)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4941 5.54287L98.5458 5.51709C98.5458 5.51709 98.52 5.54287 98.4941 5.54287Z",
    fill: "url(#paint225_linear_4741_7283)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4166 5.38818C98.3133 5.43974 98.3133 5.46552 98.2358 5.4913C98.2875 5.43974 98.3391 5.41396 98.4166 5.38818Z",
    fill: "url(#paint226_linear_4741_7283)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6748 5.74902C98.6748 5.7748 98.6489 5.7748 98.6489 5.7748C98.6489 5.74902 98.6489 5.74902 98.6748 5.74902Z",
    fill: "url(#paint227_linear_4741_7283)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1841 5.67166C98.2616 5.6201 98.339 5.56855 98.4165 5.51699C98.4165 5.51699 98.3907 5.51699 98.4165 5.49121C98.4165 5.49121 98.4423 5.49121 98.4681 5.49121C98.3907 5.56855 98.2874 5.59433 98.1841 5.67166Z",
    fill: "url(#paint228_linear_4741_7283)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5715 5.80019C98.5715 5.77442 98.5974 5.80019 98.5715 5.80019C98.5974 5.77442 98.6232 5.77441 98.6232 5.77441C98.6232 5.77441 98.6232 5.80019 98.5715 5.80019Z",
    fill: "url(#paint229_linear_4741_7283)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0293 5.46513C98.0551 5.46513 98.0551 5.49091 98.0293 5.46513C98.0035 5.49091 98.0293 5.49091 98.0293 5.46513C98.0809 5.43935 98.0809 5.43935 98.1326 5.41357C98.1068 5.43935 98.0809 5.46513 98.0293 5.46513Z",
    fill: "url(#paint230_linear_4741_7283)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4683 5.85195L98.4941 5.82617C98.4941 5.85195 98.4683 5.87773 98.4683 5.85195Z",
    fill: "url(#paint231_linear_4741_7283)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0551 5.43935C98.0034 5.43935 98.0292 5.43935 98.0551 5.43935C98.0292 5.41357 98.0292 5.43935 98.0034 5.43935C98.0034 5.43935 98.0292 5.41357 98.0551 5.41357C98.0551 5.41357 98.0551 5.41357 98.0551 5.43935Z",
    fill: "url(#paint232_linear_4741_7283)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1324 5.56826C98.1066 5.56826 98.0808 5.61982 98.0549 5.59404C98.1066 5.56826 98.1066 5.54248 98.1324 5.54248C98.1582 5.54248 98.1324 5.54248 98.1324 5.56826Z",
    fill: "url(#paint233_linear_4741_7283)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3391 5.92949C98.3649 5.90371 98.4166 5.90371 98.4424 5.87793C98.4424 5.87793 98.4682 5.87793 98.4424 5.90371C98.3908 5.90371 98.3649 5.92949 98.3391 5.92949Z",
    fill: "url(#paint234_linear_4741_7283)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0551 5.54271C98.0293 5.54271 98.0293 5.54271 98.0293 5.54271C98.0293 5.54271 98.0551 5.51693 98.0551 5.54271Z",
    fill: "url(#paint235_linear_4741_7283)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1066 5.69717L98.1324 5.67139C98.0549 5.74872 98.0291 5.74872 98.1066 5.69717Z",
    fill: "url(#paint236_linear_4741_7283)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9776 5.51709C97.926 5.54287 97.926 5.56865 97.9001 5.56865C97.9518 5.54287 97.926 5.54287 97.926 5.51709C97.926 5.56865 97.9518 5.51709 97.9776 5.51709Z",
    fill: "url(#paint237_linear_4741_7283)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0293 5.67139C98.0809 5.67139 98.0809 5.67139 98.0293 5.67139C98.0293 5.69717 98.0551 5.69717 98.0293 5.67139Z",
    fill: "url(#paint238_linear_4741_7283)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8225 5.51699C97.8483 5.51699 97.8742 5.49121 97.9 5.49121C97.8742 5.51699 97.8483 5.51699 97.8225 5.51699Z",
    fill: "url(#paint239_linear_4741_7283)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0292 5.72304L98.0033 5.74882C97.9775 5.74882 98.0292 5.69726 98.0292 5.72304Z",
    fill: "url(#paint240_linear_4741_7283)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3391 6.13574C98.2616 6.13574 98.2874 6.1873 98.21 6.21308C98.21 6.23886 98.2358 6.21308 98.2616 6.21308C98.2616 6.21308 98.2358 6.21308 98.2358 6.23886C98.2874 6.1873 98.2874 6.16152 98.3391 6.13574Z",
    fill: "url(#paint241_linear_4741_7283)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7967 5.56836C97.7451 5.59414 97.7192 5.61992 97.7192 5.59414C97.7451 5.59414 97.7967 5.56836 97.7967 5.56836Z",
    fill: "url(#paint242_linear_4741_7283)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1841 6.13564C98.1841 6.13564 98.1841 6.13564 98.2099 6.10986C98.2357 6.10986 98.1841 6.10986 98.1841 6.13564Z",
    fill: "url(#paint243_linear_4741_7283)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1326 6.10976C98.1326 6.10976 98.1584 6.08398 98.1842 6.08398C98.1842 6.10976 98.1326 6.13554 98.1326 6.10976Z",
    fill: "url(#paint244_linear_4741_7283)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9517 6.10956C97.9775 6.08378 98.0291 6.05801 98.0808 6.03223C98.0291 6.05801 98.0033 6.08378 97.9517 6.10956Z",
    fill: "url(#paint245_linear_4741_7283)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1067 6.21279C98.1325 6.21279 98.1325 6.18701 98.1583 6.18701C98.1325 6.18701 98.1067 6.21279 98.1067 6.21279Z",
    fill: "url(#paint246_linear_4741_7283)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8226 5.90374L97.7968 5.92952C97.771 5.90375 97.8226 5.87797 97.8226 5.90374Z",
    fill: "url(#paint247_linear_4741_7283)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7194 5.85205C97.7194 5.85205 97.6935 5.87783 97.6677 5.87783C97.7194 5.85205 97.7194 5.85205 97.7194 5.85205Z",
    fill: "url(#paint248_linear_4741_7283)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7451 5.87793C97.6935 5.90371 97.7451 5.90371 97.7451 5.87793V5.87793Z",
    fill: "url(#paint249_linear_4741_7283)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0293 6.29043L98.0809 6.26465H98.1068C98.1068 6.26465 98.0809 6.29043 98.0293 6.29043C98.0551 6.31621 98.0293 6.31621 98.0293 6.29043C98.0293 6.31621 98.0293 6.31621 98.0293 6.29043Z",
    fill: "url(#paint250_linear_4741_7283)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5901 5.98075V5.95497C97.5901 5.92919 97.6159 5.98075 97.5901 5.98075Z",
    fill: "url(#paint251_linear_4741_7283)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5645 6.13554C97.5645 6.13554 97.6161 6.08398 97.6161 6.10976C97.6161 6.13554 97.5903 6.13554 97.5645 6.13554Z",
    fill: "url(#paint252_linear_4741_7283)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7453 6.41895C97.7194 6.41895 97.7194 6.44473 97.6936 6.44473C97.6936 6.41895 97.7453 6.41895 97.7453 6.41895Z",
    fill: "url(#paint253_linear_4741_7283)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3062 6.13564C97.3062 6.10986 97.3062 6.10986 97.3578 6.10986C97.332 6.10986 97.332 6.13564 97.3062 6.13564Z",
    fill: "url(#paint254_linear_4741_7283)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M97.616 6.49638C97.616 6.49638 97.6418 6.4706 97.6676 6.44482C97.6418 6.4706 97.6418 6.49638 97.616 6.49638Z",
    fill: "url(#paint255_linear_4741_7283)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6677 6.52228C97.616 6.54806 97.5902 6.57384 97.5386 6.59962C97.5644 6.57384 97.6419 6.4965 97.6677 6.52228Z",
    fill: "url(#paint256_linear_4741_7283)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6677 6.62539C97.6677 6.62539 97.6935 6.59961 97.7194 6.59961C97.6935 6.59961 97.6935 6.62539 97.6677 6.62539Z",
    fill: "url(#paint257_linear_4741_7283)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5126 6.67676C97.461 6.70254 97.4093 6.75409 97.3577 6.75409C97.4351 6.72832 97.461 6.67676 97.5126 6.67676Z",
    fill: "url(#paint258_linear_4741_7283)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M97.022 6.26455C97.022 6.26455 96.9962 6.26455 97.022 6.23877V6.26455Z",
    fill: "url(#paint259_linear_4741_7283)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9445 6.21287C96.9445 6.18709 96.9187 6.21287 96.9187 6.21287C96.9187 6.21287 96.9187 6.18709 96.9445 6.21287C96.9445 6.18709 96.9445 6.16131 96.9445 6.21287Z",
    fill: "url(#paint260_linear_4741_7283)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4352 6.67676L97.3835 6.70254C97.4094 6.72832 97.4352 6.67676 97.4352 6.67676Z",
    fill: "url(#paint261_linear_4741_7283)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9963 6.3416C96.9705 6.3416 96.9963 6.31582 96.9963 6.3416C96.9963 6.31582 97.0222 6.31582 96.9963 6.3416Z",
    fill: "url(#paint262_linear_4741_7283)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8156 6.31592C96.7897 6.3417 96.7897 6.31592 96.7639 6.31592C96.8156 6.31592 96.8156 6.31592 96.8156 6.31592Z",
    fill: "url(#paint263_linear_4741_7283)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7379 6.29004C96.7121 6.29004 96.6863 6.31582 96.6863 6.3416C96.6863 6.31582 96.7121 6.31582 96.7379 6.29004Z",
    fill: "url(#paint264_linear_4741_7283)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M105.441 3.197C105.441 3.197 105.363 3.22278 105.363 3.197C105.363 3.197 105.389 3.17123 105.389 3.197H105.363C105.389 3.197 105.467 3.197 105.441 3.197Z",
    fill: "url(#paint265_linear_4741_7283)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M104.924 3.32558C104.924 3.32558 104.976 3.32558 104.95 3.32558C104.95 3.29981 104.924 3.32558 104.924 3.32558C104.924 3.32558 104.898 3.32558 104.873 3.32558C104.898 3.32558 104.924 3.2998 104.95 3.2998C104.924 3.2998 104.924 3.29981 104.924 3.32558Z",
    fill: "url(#paint266_linear_4741_7283)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M104.692 2.42357C104.692 2.42357 104.769 2.39779 104.743 2.42357C104.743 2.42357 104.666 2.44935 104.692 2.42357Z",
    fill: "url(#paint267_linear_4741_7283)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M104.511 2.475C104.537 2.475 104.589 2.44922 104.563 2.475C104.589 2.475 104.589 2.44922 104.614 2.44922C104.64 2.44922 104.64 2.44922 104.666 2.44922C104.589 2.44922 104.537 2.475 104.511 2.475C104.537 2.475 104.485 2.50078 104.511 2.475Z",
    fill: "url(#paint268_linear_4741_7283)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M104.46 3.37738C104.434 3.37738 104.382 3.40316 104.382 3.40316C104.408 3.37738 104.46 3.3516 104.46 3.37738Z",
    fill: "url(#paint269_linear_4741_7283)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M104.33 3.40281C104.304 3.42859 104.279 3.42859 104.253 3.42859C104.227 3.42859 104.201 3.48015 104.175 3.45437C104.201 3.42859 104.227 3.42859 104.253 3.42859C104.253 3.42859 104.253 3.42859 104.279 3.42859H104.253C104.304 3.42859 104.356 3.40281 104.356 3.40281C104.356 3.35126 104.356 3.37703 104.33 3.40281C104.356 3.37703 104.33 3.37703 104.33 3.40281Z",
    fill: "url(#paint270_linear_4741_7283)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M103.091 3.11953C103.091 3.09375 103.091 3.09375 103.091 3.11953C103.065 3.09375 103.065 3.11953 103.065 3.11953L103.117 3.09375C103.117 3.09375 103.117 3.09375 103.091 3.11953C103.117 3.09375 103.091 3.09375 103.091 3.11953Z",
    fill: "url(#paint271_linear_4741_7283)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M102.988 3.11953C102.988 3.09375 103.065 3.09375 103.117 3.09375C103.091 3.09375 103.065 3.11953 103.039 3.14531C103.013 3.11953 103.039 3.09375 102.988 3.11953Z",
    fill: "url(#paint272_linear_4741_7283)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M102.832 3.17119L102.884 3.14541C102.884 3.17119 102.936 3.11963 102.962 3.11963C102.936 3.14541 102.936 3.14541 102.936 3.17119C102.91 3.17119 102.91 3.17119 102.936 3.14541C102.91 3.14541 102.884 3.14541 102.858 3.17119H102.884C102.858 3.17119 102.807 3.19696 102.832 3.17119C102.858 3.17119 102.807 3.17119 102.832 3.17119Z",
    fill: "url(#paint273_linear_4741_7283)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M102.858 2.99072C102.807 3.0165 102.781 3.04228 102.729 3.06806C102.729 3.04228 102.677 3.06806 102.652 3.09384C102.703 3.06806 102.729 3.04228 102.807 3.0165L102.755 3.04228C102.781 3.0165 102.807 2.99072 102.858 2.99072Z",
    fill: "url(#paint274_linear_4741_7283)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M102.858 3.45439C102.858 3.45439 102.832 3.45439 102.807 3.45439C102.832 3.45439 102.832 3.42861 102.858 3.45439C102.858 3.42861 102.858 3.42861 102.858 3.45439Z",
    fill: "url(#paint275_linear_4741_7283)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M102.548 3.35136C102.548 3.35136 102.548 3.32558 102.574 3.32558C102.574 3.32558 102.574 3.32558 102.548 3.35136C102.6 3.32558 102.626 3.32558 102.626 3.32558C102.652 3.32558 102.652 3.32558 102.703 3.2998C102.703 3.2998 102.729 3.32558 102.703 3.32558C102.652 3.32558 102.626 3.35136 102.548 3.35136C102.6 3.32558 102.574 3.35136 102.548 3.35136Z",
    fill: "url(#paint276_linear_4741_7283)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M102.574 3.19658C102.574 3.1708 102.548 3.19658 102.574 3.1708C102.574 3.1708 102.6 3.1708 102.626 3.1708C102.6 3.1708 102.574 3.1708 102.574 3.19658C102.6 3.1708 102.6 3.1708 102.626 3.1708C102.626 3.1708 102.652 3.1708 102.652 3.14502C102.678 3.1708 102.626 3.19658 102.574 3.19658Z",
    fill: "url(#paint277_linear_4741_7283)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M102.471 3.37718C102.445 3.37718 102.471 3.3514 102.471 3.37718V3.37718Z",
    fill: "url(#paint278_linear_4741_7283)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M102.393 3.27393C102.342 3.27393 102.419 3.27393 102.368 3.2997C102.342 3.2997 102.342 3.2997 102.316 3.2997C102.316 3.2997 102.316 3.2997 102.316 3.27393C102.342 3.27393 102.419 3.27393 102.393 3.27393Z",
    fill: "url(#paint279_linear_4741_7283)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M102.264 3.45439C102.342 3.42861 102.342 3.40283 102.419 3.40283C102.394 3.40283 102.419 3.42861 102.394 3.42861C102.342 3.42861 102.29 3.45439 102.264 3.45439Z",
    fill: "url(#paint280_linear_4741_7283)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M102.264 3.32568C102.316 3.32568 102.342 3.32568 102.342 3.32568L102.29 3.35146C102.29 3.35146 102.264 3.35146 102.264 3.32568C102.264 3.35146 102.264 3.35146 102.264 3.32568Z",
    fill: "url(#paint281_linear_4741_7283)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M101.722 3.55774C101.696 3.55774 101.696 3.58352 101.722 3.55774C101.696 3.53196 101.67 3.55774 101.67 3.55774L101.696 3.53197H101.67C101.696 3.50619 101.696 3.53197 101.722 3.53197C101.722 3.55774 101.696 3.55774 101.722 3.55774Z",
    fill: "url(#paint282_linear_4741_7283)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M101.645 3.7124C101.619 3.7124 101.619 3.7124 101.593 3.73818H101.567C101.593 3.7124 101.619 3.7124 101.645 3.7124Z",
    fill: "url(#paint283_linear_4741_7283)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M101.49 3.7124C101.49 3.73818 101.386 3.76396 101.361 3.76396C101.386 3.76396 101.386 3.73818 101.412 3.73818C101.412 3.73818 101.412 3.7124 101.438 3.7124C101.438 3.73818 101.516 3.7124 101.49 3.7124Z",
    fill: "url(#paint284_linear_4741_7283)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M101.386 3.68642C101.412 3.68642 101.412 3.68642 101.386 3.68642C101.361 3.68642 101.361 3.68642 101.386 3.68642C101.386 3.68642 101.412 3.66064 101.438 3.66064C101.438 3.66064 101.412 3.68642 101.386 3.68642Z",
    fill: "url(#paint285_linear_4741_7283)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M101.257 3.91875C101.283 3.91875 101.257 3.89297 101.283 3.86719C101.309 3.86719 101.283 3.91875 101.257 3.91875Z",
    fill: "url(#paint286_linear_4741_7283)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M101.257 3.81543C101.257 3.81543 101.257 3.84121 101.231 3.84121C101.283 3.84121 101.206 3.84121 101.257 3.81543C101.231 3.84121 101.231 3.84121 101.257 3.81543Z",
    fill: "url(#paint287_linear_4741_7283)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M101.128 3.78955C101.128 3.81533 101.154 3.84111 101.128 3.84111C101.128 3.81533 100.999 3.86689 100.973 3.86689C100.973 3.84111 101.051 3.78955 101.128 3.78955Z",
    fill: "url(#paint288_linear_4741_7283)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M101.025 3.89286C101.025 3.89286 101.077 3.8413 101.051 3.86708C101.051 3.89286 101.051 3.86708 101.025 3.89286Z",
    fill: "url(#paint289_linear_4741_7283)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M100.999 3.84131C100.999 3.84131 100.973 3.84131 100.973 3.86709C100.973 3.89287 101.025 3.84131 101.051 3.84131C100.973 3.89287 100.896 3.89287 100.896 3.91864C100.896 3.91864 100.87 3.91864 100.844 3.91864C100.741 3.99598 100.637 4.02176 100.534 4.07332C100.612 4.04754 100.663 3.99598 100.741 3.99598C100.741 3.99598 100.741 3.99598 100.767 3.9702C100.818 3.94442 100.896 3.86709 100.999 3.84131Z",
    fill: "url(#paint290_linear_4741_7283)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M100.818 3.99608C100.844 3.9703 100.87 3.94452 100.896 3.94452C100.87 3.94452 100.921 3.91875 100.921 3.91875C100.947 3.89297 100.973 3.86719 100.999 3.86719C100.999 3.89297 100.999 3.86719 101.025 3.86719C100.999 3.89297 100.999 3.86719 100.947 3.89297C100.973 3.89297 100.87 3.94452 100.87 3.94452C100.87 3.94452 100.87 3.94452 100.844 3.94452C100.844 3.99608 100.87 3.9703 100.818 3.99608Z",
    fill: "url(#paint291_linear_4741_7283)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M100.689 4.20195C100.663 4.22773 100.612 4.22773 100.612 4.2535C100.612 4.2535 100.612 4.2535 100.586 4.2535C100.483 4.2535 100.405 4.33084 100.302 4.3824C100.302 4.35662 100.328 4.35662 100.353 4.35662L100.483 4.27928C100.534 4.25351 100.56 4.22773 100.612 4.22773C100.586 4.22773 100.586 4.22773 100.586 4.20195C100.637 4.20195 100.663 4.17617 100.715 4.15039C100.715 4.15039 100.741 4.15039 100.715 4.17617C100.715 4.17617 100.612 4.20195 100.637 4.22773C100.663 4.22773 100.715 4.20195 100.767 4.17617C100.767 4.20195 100.767 4.20195 100.767 4.22773C100.741 4.17617 100.689 4.20195 100.689 4.20195Z",
    fill: "url(#paint292_linear_4741_7283)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M100.508 4.04726C100.534 4.04726 100.534 4.04726 100.56 4.02148C100.56 4.04726 100.483 4.07304 100.431 4.07304C100.483 4.04726 100.508 4.07304 100.508 4.04726Z",
    fill: "url(#paint293_linear_4741_7283)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M100.405 4.1248C100.457 4.1248 100.483 4.07324 100.508 4.07324C100.483 4.07324 100.483 4.09902 100.431 4.09902C100.457 4.09902 100.405 4.15058 100.405 4.1248Z",
    fill: "url(#paint294_linear_4741_7283)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M100.405 4.1248C100.457 4.09902 100.457 4.09902 100.483 4.07324C100.483 4.09902 100.405 4.1248 100.405 4.1248C100.379 4.1248 100.379 4.15058 100.379 4.15058C100.379 4.15058 100.379 4.15058 100.379 4.1248C100.353 4.1248 100.353 4.15058 100.328 4.1248C100.353 4.15058 100.379 4.1248 100.405 4.1248C100.379 4.1248 100.379 4.1248 100.405 4.1248C100.405 4.09902 100.379 4.15058 100.405 4.1248Z",
    fill: "url(#paint295_linear_4741_7283)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M100.25 4.20204C100.224 4.22782 100.25 4.22782 100.224 4.2536C100.224 4.2536 100.224 4.2536 100.25 4.2536C100.276 4.22782 100.276 4.22782 100.25 4.20204C100.25 4.2536 100.302 4.22782 100.25 4.27938C100.198 4.27938 100.173 4.33094 100.147 4.30516C100.224 4.2536 100.224 4.22782 100.224 4.22782C100.224 4.22782 100.25 4.17626 100.25 4.20204Z",
    fill: "url(#paint296_linear_4741_7283)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M100.069 4.30529C100.069 4.33107 100.095 4.27951 100.121 4.30529C100.095 4.30529 100.043 4.35685 100.018 4.35685C100.043 4.30529 100.043 4.30529 100.069 4.30529Z",
    fill: "url(#paint297_linear_4741_7283)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M100.069 4.33105C100.069 4.35683 100.121 4.33105 100.069 4.33105C100.069 4.35683 100.069 4.38261 100.069 4.33105C100.069 4.35683 100.069 4.35683 100.069 4.33105Z",
    fill: "url(#paint298_linear_4741_7283)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M99.656 4.5373C99.7335 4.51152 99.811 4.45996 99.8368 4.45996C99.8368 4.45996 99.8368 4.45996 99.811 4.45996C99.811 4.45996 99.811 4.45996 99.811 4.48574C99.811 4.48574 99.7851 4.51152 99.7593 4.51152C99.7335 4.51152 99.6302 4.56308 99.5786 4.58885C99.5527 4.58885 99.6044 4.58885 99.5786 4.56308C99.5786 4.56308 99.5786 4.56308 99.5527 4.56308C99.5786 4.58885 99.6044 4.56308 99.656 4.5373C99.6302 4.5373 99.6302 4.5373 99.656 4.5373Z",
    fill: "url(#paint299_linear_4741_7283)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6562 4.74344C99.6562 4.76922 99.6045 4.74344 99.6045 4.76922C99.6045 4.76922 99.6304 4.76922 99.6562 4.74344C99.6045 4.76922 99.5787 4.795 99.5529 4.795C99.6045 4.795 99.5787 4.76922 99.5529 4.76922C99.5787 4.74344 99.6562 4.74344 99.682 4.71766C99.6562 4.71766 99.6304 4.71766 99.6045 4.71766C99.6045 4.71766 99.6304 4.71766 99.6304 4.69188C99.6045 4.69188 99.5787 4.71766 99.5529 4.69188C99.5529 4.71766 99.5012 4.71766 99.4496 4.76922C99.3979 4.795 99.3463 4.84655 99.2947 4.84655C99.2688 4.87233 99.1397 4.92389 99.1139 4.97545C99.1139 4.97545 99.1139 4.97545 99.0881 4.97545C99.1139 4.94967 99.0364 5.00123 99.0622 4.97545C99.0881 4.97545 99.1139 4.94967 99.1397 4.92389C99.2172 4.92389 99.2947 4.82078 99.3463 4.82078C99.3721 4.82078 99.3979 4.795 99.4238 4.76922C99.4496 4.74344 99.4238 4.76922 99.4496 4.76922C99.4496 4.74344 99.4754 4.76922 99.5012 4.74344C99.5529 4.69188 99.6045 4.6661 99.682 4.64032C99.682 4.64032 99.682 4.64032 99.7078 4.61455C99.7337 4.61455 99.7853 4.61455 99.7595 4.61455C99.7595 4.61455 99.7595 4.61455 99.7337 4.61455C99.7337 4.61455 99.7078 4.61455 99.7337 4.64032C99.7337 4.64032 99.7853 4.61455 99.7853 4.64032C99.7853 4.64032 99.7595 4.64032 99.7595 4.6661C99.7853 4.6661 99.7853 4.6661 99.8111 4.64032C99.8111 4.61455 99.8628 4.61455 99.8886 4.56299H99.9144C99.8886 4.56299 99.8628 4.58877 99.8886 4.61455C99.7595 4.69188 99.7078 4.71766 99.6562 4.74344C99.682 4.74344 99.6304 4.76922 99.6562 4.74344Z",
    fill: "url(#paint300_linear_4741_7283)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5786 4.87235C99.6044 4.82079 99.7852 4.79501 99.7852 4.74345C99.8369 4.74345 99.8885 4.69189 99.9143 4.69189C99.8627 4.71767 99.811 4.74345 99.7594 4.76923C99.6819 4.79501 99.6303 4.84657 99.5786 4.87235Z",
    fill: "url(#paint301_linear_4741_7283)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5269 4.6662C99.5528 4.64043 99.5528 4.6662 99.5786 4.64042C99.5786 4.64042 99.6044 4.64042 99.6561 4.64042C99.6561 4.64042 99.6819 4.64043 99.7077 4.61465C99.7077 4.61465 99.7593 4.61465 99.7593 4.58887C99.7335 4.61465 99.6302 4.6662 99.5786 4.69198C99.6044 4.6662 99.5528 4.6662 99.5269 4.6662C99.5269 4.69198 99.5786 4.6662 99.5528 4.6662C99.5528 4.69198 99.5786 4.69198 99.5269 4.6662C99.5269 4.69198 99.5011 4.71776 99.4495 4.74354C99.4495 4.71776 99.5786 4.69198 99.5269 4.6662Z",
    fill: "url(#paint302_linear_4741_7283)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7595 4.61475C99.7336 4.61475 99.7336 4.64052 99.7336 4.64052L99.7595 4.61475H99.7336C99.7595 4.61475 99.7595 4.61475 99.7595 4.61475Z",
    fill: "url(#paint303_linear_4741_7283)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5271 4.61475C99.5012 4.64052 99.4496 4.6663 99.3979 4.6663C99.4496 4.64052 99.4754 4.61475 99.5271 4.61475Z",
    fill: "url(#paint304_linear_4741_7283)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0881 4.84668C99.0622 4.84668 99.0364 4.87246 99.0106 4.89824C99.0364 4.89824 99.0106 4.92402 99.0364 4.89824C99.0106 4.89824 98.9589 4.92402 99.0106 4.89824C99.0106 4.89824 98.9848 4.89824 98.9589 4.89824C98.9589 4.89824 98.9589 4.89824 98.9589 4.92402C98.9589 4.92402 99.0106 4.89824 98.9847 4.92402C98.9847 4.92402 98.9589 4.94979 98.9331 4.94979C98.9589 4.89824 99.0622 4.84668 99.0881 4.84668Z",
    fill: "url(#paint305_linear_4741_7283)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9848 5.07841H98.959C98.959 5.05263 98.9848 5.05263 99.0106 5.02686C99.0106 5.05263 98.9848 5.05263 98.9848 5.07841Z",
    fill: "url(#paint306_linear_4741_7283)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6748 5.23329C98.6748 5.23329 98.6748 5.23329 98.7006 5.20751C98.7781 5.18173 98.8297 5.13017 98.9072 5.07861H98.933C98.8556 5.13017 98.8039 5.15595 98.7264 5.18173C98.7264 5.20751 98.7006 5.20751 98.6748 5.23329Z",
    fill: "url(#paint307_linear_4741_7283)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M98.804 5.02704C98.8298 5.02704 98.8298 5.00126 98.8298 5.00126C98.8556 4.97549 98.9073 4.94971 98.9073 4.94971C98.8814 4.94971 98.8298 4.97549 98.8298 5.00126C98.8556 4.97549 98.8298 5.02704 98.8298 5.02704C98.8298 5.00126 98.804 5.02704 98.804 5.02704C98.804 5.00126 98.7781 5.02704 98.804 5.02704C98.8298 5.00126 98.7781 5.00126 98.804 5.02704Z",
    fill: "url(#paint308_linear_4741_7283)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9846 5.18164C98.933 5.20742 98.8813 5.2332 98.8297 5.25898C98.8038 5.25898 98.778 5.28475 98.7522 5.28475C98.7005 5.31053 98.6489 5.36209 98.5972 5.36209C98.5972 5.36209 98.5972 5.36209 98.6231 5.36209L98.5972 5.38787C98.5972 5.41365 98.5198 5.43943 98.5198 5.46521C98.5972 5.41365 98.6747 5.38787 98.7522 5.33631C98.8038 5.28476 98.9071 5.2332 98.9846 5.18164ZM98.6489 5.36209C98.6747 5.36209 98.6747 5.36209 98.6489 5.36209V5.36209Z",
    fill: "url(#paint309_linear_4741_7283)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7781 5.41396C98.8039 5.38818 98.8297 5.38818 98.8555 5.38818L98.8297 5.41396C98.8297 5.3624 98.8039 5.41396 98.7781 5.41396Z",
    fill: "url(#paint310_linear_4741_7283)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5714 5.07873C98.5456 5.10451 98.5972 5.05295 98.5714 5.07873H98.5972C98.6231 5.07873 98.5972 5.07873 98.5714 5.07873Z",
    fill: "url(#paint311_linear_4741_7283)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6233 5.31078C98.6749 5.25922 98.7266 5.25922 98.7007 5.285C98.6749 5.285 98.7007 5.285 98.6749 5.285C98.6749 5.285 98.6749 5.285 98.6491 5.31078C98.6233 5.36234 98.5458 5.36234 98.4941 5.38811C98.4941 5.38811 98.4941 5.38811 98.4941 5.36233C98.4941 5.38811 98.52 5.33656 98.4941 5.36233C98.4941 5.36233 98.4941 5.33656 98.52 5.33656C98.52 5.33656 98.52 5.33656 98.5458 5.33656C98.5716 5.33656 98.6491 5.31078 98.6233 5.31078C98.6491 5.31078 98.6491 5.285 98.6233 5.31078Z",
    fill: "url(#paint312_linear_4741_7283)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5456 5.31063C98.5198 5.31063 98.494 5.33641 98.494 5.33641C98.4681 5.33641 98.4165 5.38797 98.4165 5.36219C98.494 5.31063 98.5714 5.25908 98.6489 5.20752C98.6231 5.25908 98.5714 5.25908 98.5456 5.31063Z",
    fill: "url(#paint313_linear_4741_7283)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4681 5.20752C98.4681 5.20752 98.4423 5.2333 98.4165 5.20752C98.4682 5.20752 98.4681 5.20752 98.4681 5.20752Z",
    fill: "url(#paint314_linear_4741_7283)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5456 5.49118H98.5198C98.5198 5.49118 98.5456 5.43962 98.5456 5.49118C98.5714 5.4654 98.5198 5.49118 98.5456 5.49118Z",
    fill: "url(#paint315_linear_4741_7283)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M98.494 5.38818C98.494 5.38818 98.4682 5.41396 98.4423 5.43974C98.4682 5.43974 98.494 5.41396 98.494 5.38818C98.4681 5.41396 98.4681 5.43974 98.4681 5.43974C98.4681 5.43974 98.4423 5.43974 98.4165 5.43974C98.4423 5.43974 98.4681 5.38818 98.494 5.38818Z",
    fill: "url(#paint316_linear_4741_7283)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M98.623 5.9291C98.6489 5.9291 98.6489 5.9291 98.6489 5.90332C98.6747 5.90332 98.6489 5.90332 98.623 5.9291Z",
    fill: "url(#paint317_linear_4741_7283)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0809 5.62002C98.0809 5.62002 98.0809 5.59424 98.0551 5.62002C98.0292 5.6458 98.0034 5.67157 98.0034 5.6458C98.0292 5.62002 98.0551 5.62002 98.0809 5.59424C98.0551 5.62002 98.1067 5.59424 98.0809 5.62002Z",
    fill: "url(#paint318_linear_4741_7283)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3133 6.13572C98.2875 6.10995 98.3908 6.08417 98.3391 6.13572C98.3391 6.13572 98.3649 6.10995 98.3133 6.13572C98.3391 6.10995 98.3133 6.10995 98.3133 6.13572Z",
    fill: "url(#paint319_linear_4741_7283)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2099 6.16141C98.2615 6.16141 98.2874 6.10986 98.3132 6.13564C98.2874 6.16141 98.2616 6.13564 98.2874 6.16141C98.2616 6.16141 98.2357 6.18719 98.1841 6.21297C98.1841 6.18719 98.2357 6.16141 98.2099 6.16141Z",
    fill: "url(#paint320_linear_4741_7283)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4868 6.62549C97.4351 6.65127 97.4093 6.67705 97.3577 6.70283C97.3835 6.67705 97.4351 6.65127 97.4868 6.62549Z",
    fill: "url(#paint321_linear_4741_7283)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M97.332 6.67705C97.3579 6.65127 97.3579 6.65127 97.332 6.67705C97.332 6.65127 97.3579 6.67705 97.332 6.67705Z",
    fill: "url(#paint322_linear_4741_7283)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M109.082 2.60369H109.108C109.056 2.60369 109.056 2.60369 109.03 2.60369C109.056 2.57791 109.03 2.60369 109.03 2.57791C109.03 2.55213 109.108 2.50058 109.108 2.4748C109.108 2.44902 109.185 2.42324 109.134 2.39746C109.211 2.39746 109.185 2.42324 109.159 2.44902C109.159 2.44902 109.185 2.50058 109.159 2.50058H109.185C109.185 2.50058 109.134 2.50058 109.159 2.52635H109.134C109.108 2.57791 109.082 2.57791 109.082 2.60369Z",
    fill: "url(#paint323_linear_4741_7283)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M105.079 3.24833C105.105 3.24833 105.105 3.24833 105.131 3.24833C105.105 3.24833 105.053 3.24833 105.028 3.24833C105.053 3.24833 105.105 3.22256 105.131 3.22256C105.105 3.22256 105.105 3.22256 105.079 3.24833C105.105 3.24833 105.157 3.22256 105.157 3.19678C105.157 3.22256 105.183 3.19678 105.183 3.19678C105.183 3.19678 105.157 3.19678 105.131 3.22256C105.131 3.22256 105.131 3.22256 105.079 3.24833Z",
    fill: "url(#paint324_linear_4741_7283)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M104.795 3.27405C104.743 3.27405 104.692 3.29983 104.666 3.27405C104.692 3.27405 104.718 3.27405 104.743 3.24827C104.769 3.24827 104.821 3.22249 104.821 3.24827C104.795 3.27405 104.821 3.27405 104.795 3.27405Z",
    fill: "url(#paint325_linear_4741_7283)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M101.361 3.78974C101.361 3.78974 101.335 3.78974 101.309 3.78974C101.309 3.78974 101.335 3.78974 101.335 3.76396C101.309 3.76396 101.309 3.78974 101.283 3.76396C101.283 3.76396 101.309 3.76396 101.309 3.73818C101.283 3.73818 101.283 3.76396 101.257 3.73818C101.283 3.73818 101.309 3.7124 101.335 3.7124C101.309 3.78974 101.386 3.76396 101.361 3.78974Z",
    fill: "url(#paint326_linear_4741_7283)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M100.741 3.99599C100.767 3.99599 100.767 3.97021 100.792 3.97021C100.767 3.97021 100.767 3.99599 100.792 3.99599C100.767 3.99599 100.767 3.99599 100.767 4.02177C100.767 4.02177 100.741 4.02177 100.715 4.02177C100.715 4.04755 100.663 4.04755 100.663 4.04755C100.612 4.07333 100.56 4.09911 100.508 4.12489C100.508 4.12489 100.508 4.12489 100.508 4.15067C100.483 4.15067 100.431 4.17644 100.431 4.17644C100.483 4.17644 100.508 4.15067 100.56 4.09911C100.56 4.09911 100.56 4.09911 100.586 4.09911C100.586 4.12489 100.638 4.09911 100.663 4.07333H100.638C100.663 4.04755 100.741 4.04755 100.741 3.99599Z",
    fill: "url(#paint327_linear_4741_7283)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4424 5.46533C98.3907 5.51689 98.3391 5.51689 98.2874 5.56845C98.2874 5.59423 98.2358 5.59423 98.2099 5.62C98.1841 5.62 98.2099 5.64578 98.1841 5.64578C98.1583 5.64578 98.1325 5.67156 98.1066 5.67156C98.0808 5.67156 98.1066 5.64578 98.1325 5.62C98.1583 5.62 98.1325 5.62 98.1583 5.62C98.1583 5.62 98.2099 5.56845 98.1841 5.59423C98.2616 5.59423 98.2874 5.51689 98.3649 5.49111C98.3649 5.49111 98.3907 5.46533 98.4424 5.46533Z",
    fill: "url(#paint328_linear_4741_7283)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M110.838 2.0624C110.864 2.0624 110.838 2.0624 110.864 2.0624C110.838 2.0624 110.864 2.0624 110.864 2.03662C110.89 2.03662 110.864 2.0624 110.864 2.0624C110.838 2.08818 110.812 2.08818 110.838 2.0624Z",
    fill: "url(#paint329_linear_4741_7283)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M111.096 1.3667C111.122 1.3667 111.122 1.3667 111.096 1.39248V1.3667Z",
    fill: "url(#paint330_linear_4741_7283)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M110.89 1.80469C110.89 1.80469 110.941 1.80469 110.915 1.80469C110.89 1.83047 110.89 1.80469 110.89 1.80469Z",
    fill: "url(#paint331_linear_4741_7283)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M110.941 1.62431C110.941 1.59853 110.967 1.62431 110.967 1.59853C110.941 1.59853 110.941 1.59853 110.941 1.57275C110.967 1.57275 110.967 1.57275 110.993 1.57275C110.993 1.57275 110.967 1.59853 110.993 1.59853C110.967 1.65009 110.967 1.62431 110.941 1.62431Z",
    fill: "url(#paint332_linear_4741_7283)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M110.915 1.83057C110.915 1.83057 110.89 1.83057 110.864 1.85634C110.864 1.83057 110.89 1.83057 110.915 1.83057Z",
    fill: "url(#paint333_linear_4741_7283)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M110.941 1.75293C110.941 1.75293 110.941 1.77871 110.916 1.77871C110.916 1.77871 110.916 1.75293 110.941 1.75293Z",
    fill: "url(#paint334_linear_4741_7283)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M110.709 2.16582C110.683 2.16582 110.683 2.16582 110.709 2.16582C110.683 2.14004 110.709 2.14004 110.709 2.16582Z",
    fill: "url(#paint335_linear_4741_7283)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M110.709 2.06273C110.709 2.06273 110.657 2.08851 110.683 2.06273C110.709 2.03695 110.683 2.06273 110.709 2.06273Z",
    fill: "url(#paint336_linear_4741_7283)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M110.683 2.0625C110.657 2.08828 110.683 2.11406 110.683 2.13984C110.657 2.13984 110.631 2.16561 110.606 2.19139C110.58 2.13984 110.606 2.0625 110.683 2.0625Z",
    fill: "url(#paint337_linear_4741_7283)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M110.812 1.31491C110.838 1.28913 110.838 1.31491 110.812 1.31491C110.838 1.26335 110.838 1.31491 110.838 1.31491C110.838 1.31491 110.838 1.31491 110.812 1.31491Z",
    fill: "url(#paint338_linear_4741_7283)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M110.141 2.2429C110.193 2.21712 110.167 2.2429 110.167 2.2429H110.141Z",
    fill: "url(#paint339_linear_4741_7283)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M110.063 2.21729C110.063 2.26884 110.115 2.21729 110.063 2.21729V2.21729Z",
    fill: "url(#paint340_linear_4741_7283)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M105.131 2.29433C105.183 2.29433 105.157 2.29433 105.208 2.26855C105.208 2.29433 105.234 2.26855 105.208 2.26855C105.183 2.26855 105.131 2.32011 105.131 2.29433Z",
    fill: "url(#paint341_linear_4741_7283)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M104.64 1.95928C104.614 1.98505 104.563 1.98505 104.537 1.98505C104.563 1.95928 104.614 1.95928 104.64 1.95928C104.64 1.9335 104.64 1.9335 104.64 1.95928Z",
    fill: "url(#paint342_linear_4741_7283)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M104.304 2.114C104.356 2.114 104.382 2.08822 104.408 2.114C104.382 2.08822 104.33 2.114 104.304 2.114Z",
    fill: "url(#paint343_linear_4741_7283)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M104.253 2.114C104.253 2.114 104.305 2.08822 104.305 2.114C104.279 2.114 104.253 2.114 104.253 2.114Z",
    fill: "url(#paint344_linear_4741_7283)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M104.021 2.19163C104.021 2.19163 104.072 2.16585 104.072 2.19163C104.046 2.19163 104.046 2.19163 104.021 2.19163Z",
    fill: "url(#paint345_linear_4741_7283)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M103.969 2.24297C103.969 2.21719 104.02 2.21719 103.969 2.24297C103.995 2.21719 103.995 2.24297 103.969 2.24297Z",
    fill: "url(#paint346_linear_4741_7283)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M103.865 2.70703C103.865 2.73281 103.917 2.70703 103.865 2.70703C103.865 2.73281 103.891 2.73281 103.865 2.70703Z",
    fill: "url(#paint347_linear_4741_7283)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M103.685 2.78447C103.711 2.78447 103.711 2.78447 103.685 2.78447C103.762 2.78447 103.814 2.78447 103.866 2.73291C103.788 2.73291 103.762 2.75869 103.685 2.78447C103.736 2.78447 103.762 2.75869 103.788 2.73291C103.788 2.78447 103.711 2.78447 103.685 2.78447ZM103.84 2.75869H103.814C103.814 2.75869 103.84 2.73291 103.84 2.75869Z",
    fill: "url(#paint348_linear_4741_7283)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M103.736 2.26855C103.71 2.26855 103.71 2.26855 103.736 2.26855C103.685 2.26855 103.659 2.29433 103.607 2.29433C103.633 2.29433 103.736 2.26855 103.736 2.26855Z",
    fill: "url(#paint349_linear_4741_7283)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M103.71 2.73291H103.736C103.736 2.75869 103.736 2.73291 103.71 2.73291Z",
    fill: "url(#paint350_linear_4741_7283)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M103.375 2.37197L103.401 2.34619C103.375 2.37197 103.401 2.37197 103.375 2.37197Z",
    fill: "url(#paint351_linear_4741_7283)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M103.065 2.50088C103.091 2.50088 103.142 2.4751 103.194 2.4751C103.168 2.50088 103.091 2.52665 103.065 2.50088Z",
    fill: "url(#paint352_linear_4741_7283)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M102.988 2.6555C102.962 2.6555 102.91 2.68128 102.884 2.68128C102.936 2.6555 102.936 2.6555 102.988 2.6555Z",
    fill: "url(#paint353_linear_4741_7283)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M102.832 2.55225C102.807 2.55225 102.781 2.55225 102.781 2.57802L102.832 2.55225Z",
    fill: "url(#paint354_linear_4741_7283)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M102.781 2.70716C102.807 2.70716 102.781 2.70716 102.807 2.68138C102.832 2.6556 102.832 2.68138 102.832 2.68138C102.832 2.70716 102.807 2.70716 102.781 2.70716Z",
    fill: "url(#paint355_linear_4741_7283)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M102.781 2.78408C102.781 2.7583 102.807 2.7583 102.832 2.7583C102.781 2.7583 102.781 2.78408 102.781 2.78408Z",
    fill: "url(#paint356_linear_4741_7283)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M102.781 2.78408C102.832 2.78408 102.858 2.7583 102.884 2.7583L102.858 2.78408C102.832 2.78408 102.781 2.80986 102.781 2.78408C102.755 2.80986 102.755 2.80986 102.729 2.80986H102.703C102.703 2.80986 102.729 2.80986 102.729 2.78408C102.755 2.78408 102.781 2.78408 102.781 2.78408Z",
    fill: "url(#paint357_linear_4741_7283)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M102.832 3.197C102.832 3.197 102.807 3.22278 102.807 3.197C102.807 3.17123 102.832 3.197 102.832 3.197Z",
    fill: "url(#paint358_linear_4741_7283)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M102.781 3.22266L102.703 3.24844C102.703 3.24844 102.755 3.22266 102.781 3.22266Z",
    fill: "url(#paint359_linear_4741_7283)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M102.6 2.68115C102.574 2.68115 102.523 2.70693 102.549 2.68115C102.549 2.70693 102.574 2.68115 102.6 2.68115Z",
    fill: "url(#paint360_linear_4741_7283)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M102.574 3.09349C102.6 3.09349 102.626 3.06771 102.626 3.09349C102.626 3.09349 102.6 3.09349 102.574 3.09349Z",
    fill: "url(#paint361_linear_4741_7283)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 2.6555C102.497 2.6555 102.523 2.62972 102.523 2.6555C102.523 2.6555 102.497 2.68128 102.497 2.6555Z",
    fill: "url(#paint362_linear_4741_7283)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 2.83568C102.497 2.83568 102.445 2.86145 102.445 2.83568C102.471 2.83568 102.471 2.8099 102.497 2.83568Z",
    fill: "url(#paint363_linear_4741_7283)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M102.523 3.32568C102.523 3.32568 102.497 3.35146 102.497 3.32568H102.523Z",
    fill: "url(#paint364_linear_4741_7283)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 3.32568C102.471 3.35146 102.419 3.35146 102.419 3.32568C102.445 3.32568 102.471 3.32568 102.497 3.32568Z",
    fill: "url(#paint365_linear_4741_7283)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M102.342 2.78441C102.316 2.78441 102.29 2.78441 102.29 2.78441C102.316 2.75863 102.316 2.78441 102.342 2.78441Z",
    fill: "url(#paint366_linear_4741_7283)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M102.161 2.96464C102.213 2.96464 102.29 2.91309 102.316 2.91309C102.239 2.93886 102.213 2.96464 102.161 2.96464Z",
    fill: "url(#paint367_linear_4741_7283)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M102.368 3.35156H102.394C102.419 3.35156 102.419 3.35156 102.368 3.35156C102.394 3.37734 102.394 3.35156 102.368 3.35156Z",
    fill: "url(#paint368_linear_4741_7283)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M102.032 2.91337C102.058 2.88759 102.109 2.86182 102.135 2.86182C102.109 2.8876 102.058 2.91337 102.032 2.91337Z",
    fill: "url(#paint369_linear_4741_7283)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M102.058 2.83574C102.058 2.83574 102.032 2.86152 102.032 2.83574C102.032 2.80996 102.032 2.80996 102.058 2.83574C102.032 2.83574 102.006 2.86152 102.058 2.83574Z",
    fill: "url(#paint370_linear_4741_7283)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M102.109 2.99072L102.084 3.0165C102.058 3.0165 102.032 3.04228 102.032 3.0165C102.058 2.99072 102.084 2.99072 102.109 2.99072Z",
    fill: "url(#paint371_linear_4741_7283)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M102.187 3.40283C102.161 3.40283 102.109 3.42861 102.109 3.42861C102.109 3.40283 102.161 3.40283 102.187 3.40283Z",
    fill: "url(#paint372_linear_4741_7283)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M102.032 2.96458C102.006 2.96458 102.006 2.99036 102.032 2.96458C102.006 2.96458 102.032 2.9388 102.032 2.96458Z",
    fill: "url(#paint373_linear_4741_7283)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M101.954 2.93919C101.903 2.93919 101.903 2.96497 101.877 2.96497C101.903 2.96497 101.903 2.96497 101.903 2.93919C101.929 2.93919 101.954 2.91341 101.954 2.93919Z",
    fill: "url(#paint374_linear_4741_7283)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M101.98 3.11937C102.006 3.09359 102.006 3.11937 101.98 3.11937V3.11937Z",
    fill: "url(#paint375_linear_4741_7283)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M101.851 2.91309C101.825 2.91309 101.825 2.93886 101.851 2.91309C101.8 2.91309 101.774 2.93886 101.774 2.91309C101.8 2.93886 101.825 2.91309 101.851 2.91309Z",
    fill: "url(#paint376_linear_4741_7283)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M101.955 3.55784C101.955 3.55784 101.929 3.58362 101.929 3.55784C101.929 3.53207 101.955 3.55784 101.955 3.55784Z",
    fill: "url(#paint377_linear_4741_7283)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M101.903 3.45459C101.877 3.48037 101.825 3.50615 101.8 3.50615H101.825C101.851 3.50615 101.851 3.50615 101.877 3.48037L101.903 3.45459Z",
    fill: "url(#paint378_linear_4741_7283)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M101.722 3.1709C101.722 3.1709 101.696 3.19668 101.67 3.1709C101.696 3.19668 101.696 3.1709 101.722 3.1709Z",
    fill: "url(#paint379_linear_4741_7283)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M101.567 3.27431V3.24854C101.593 3.24854 101.593 3.27431 101.567 3.27431Z",
    fill: "url(#paint380_linear_4741_7283)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M101.567 3.76396C101.567 3.76396 101.541 3.78974 101.541 3.76396C101.541 3.73818 101.567 3.73818 101.567 3.76396Z",
    fill: "url(#paint381_linear_4741_7283)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M101.464 3.78945C101.464 3.78945 101.49 3.78945 101.516 3.76367C101.49 3.78945 101.49 3.81523 101.464 3.78945Z",
    fill: "url(#paint382_linear_4741_7283)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M101.051 3.2998C101.051 3.2998 101.025 3.32558 101.025 3.2998C100.999 3.2998 101.025 3.2998 101.051 3.2998Z",
    fill: "url(#paint383_linear_4741_7283)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M101.051 3.48027C101.025 3.45449 101.051 3.45449 101.051 3.48027C101.051 3.45449 101.076 3.45449 101.051 3.48027Z",
    fill: "url(#paint384_linear_4741_7283)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M100.87 3.37718C100.844 3.37718 100.818 3.40296 100.818 3.40296C100.818 3.37718 100.844 3.37718 100.87 3.37718C100.844 3.37718 100.844 3.3514 100.87 3.37718Z",
    fill: "url(#paint385_linear_4741_7283)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M110.838 1.80471C110.812 1.80471 110.812 1.77893 110.812 1.75315C110.838 1.75315 110.864 1.75315 110.89 1.75315C110.864 1.75315 110.89 1.72738 110.89 1.72738C110.915 1.7016 110.941 1.65004 110.941 1.59848C110.915 1.59848 110.915 1.59848 110.89 1.59848H110.864C110.864 1.5727 110.864 1.5727 110.89 1.54692C110.915 1.54692 110.915 1.54692 110.941 1.54692C110.941 1.49537 110.915 1.46959 110.915 1.44381C110.941 1.44381 110.941 1.44381 110.967 1.44381C110.993 1.44381 110.993 1.41803 111.019 1.41803C111.019 1.39225 111.019 1.41803 111.019 1.39225C110.993 1.39225 110.993 1.36647 110.967 1.3407C110.941 1.3407 110.941 1.3407 110.941 1.3407C110.915 1.3407 110.89 1.3407 110.864 1.3407C110.89 1.3407 110.838 1.31492 110.812 1.3407C110.838 1.31492 110.838 1.28914 110.89 1.28914C110.89 1.28914 110.89 1.28914 110.915 1.28914C110.915 1.28914 110.915 1.31492 110.941 1.31492C110.941 1.31492 110.967 1.31492 110.993 1.31492C110.993 1.28914 110.941 1.31492 110.967 1.28914H110.941C110.941 1.28914 110.915 1.28914 110.89 1.28914V1.26336C110.89 1.26336 110.89 1.28914 110.864 1.28914H110.838C110.812 1.28914 110.812 1.26336 110.786 1.23758C110.786 1.23758 110.786 1.23758 110.812 1.2118C110.786 1.2118 110.812 1.18602 110.812 1.16024C110.786 1.16024 110.786 1.16024 110.786 1.13447C110.76 1.13447 110.76 1.10869 110.735 1.10869V1.08291C110.709 1.08291 110.683 1.08291 110.683 1.08291C110.683 1.08291 110.683 1.08291 110.683 1.10869C110.657 1.13447 110.657 1.08291 110.631 1.10869V1.08291C110.657 1.08291 110.683 1.08291 110.709 1.08291C110.709 1.05713 110.58 1.08291 110.58 1.05713L110.502 1.08291C110.425 1.05713 110.347 1.05713 110.244 1.08291H110.27C110.218 1.08291 110.192 1.08291 110.141 1.08291C110.141 1.08291 110.141 1.08291 110.141 1.10869L110.115 1.13447C110.115 1.13447 110.115 1.13447 110.115 1.10869C110.089 1.10869 110.089 1.13447 110.089 1.10869C110.141 1.10869 110.141 1.05713 110.167 1.03135C110.089 0.979793 110.244 0.954015 110.218 0.876679C110.218 0.8509 110.192 0.8509 110.192 0.825121C110.115 0.799343 110.037 0.8509 109.934 0.8509C109.934 0.876678 109.96 0.902458 109.908 0.928236C109.908 0.928236 109.908 0.928236 109.882 0.928236C109.908 0.928236 109.857 0.954014 109.857 0.979793C109.831 0.979793 109.805 0.979793 109.779 0.979793C109.779 1.00557 109.857 1.00557 109.779 1.03135H109.728C109.728 1.05713 109.805 1.03135 109.805 1.08291H109.753C109.779 1.08291 109.831 1.05713 109.805 1.08291C109.779 1.08291 109.753 1.08291 109.728 1.10869H109.702V1.08291C109.676 1.10869 109.676 1.08291 109.624 1.08291C109.624 1.08291 109.624 1.08291 109.624 1.10869C109.573 1.10869 109.624 1.10869 109.598 1.08291C109.573 1.10869 109.547 1.10869 109.521 1.08291C109.547 1.08291 109.495 1.10869 109.469 1.08291C109.443 1.05713 109.495 1.08291 109.495 1.08291C109.521 1.08291 109.443 1.08291 109.443 1.08291H109.418C109.418 1.08291 109.418 1.05713 109.392 1.08291C109.392 1.08291 109.392 1.08291 109.392 1.10869C109.392 1.13447 109.392 1.10869 109.392 1.08291C109.34 1.08291 109.314 1.08291 109.263 1.08291C109.263 1.08291 109.263 1.08291 109.263 1.10869C109.185 1.10869 109.159 1.13447 109.108 1.13447C109.108 1.16024 109.082 1.13447 109.082 1.13447C109.056 1.13447 109.03 1.16024 109.004 1.16024C108.927 1.16024 108.875 1.16024 108.824 1.16024C108.798 1.16024 108.772 1.16024 108.746 1.16024C108.746 1.16024 108.746 1.16024 108.772 1.16024C108.746 1.16024 108.746 1.16024 108.72 1.16024C108.72 1.16024 108.72 1.16024 108.695 1.16024H108.669C108.669 1.16024 108.669 1.16024 108.695 1.16024C108.695 1.16024 108.695 1.16024 108.669 1.16024C108.695 1.16024 108.746 1.13447 108.746 1.08291V1.05713C108.824 1.05713 108.901 1.05713 109.004 1.03135C109.056 1.00557 109.108 1.00557 109.108 0.954015C109.134 0.928236 109.134 0.902458 109.108 0.876679C109.134 0.876679 109.185 0.876679 109.185 0.876679H109.134C109.159 0.902458 109.211 0.902457 109.263 0.902457C109.263 0.928236 109.237 0.928236 109.237 0.928236C109.314 0.928236 109.392 0.954015 109.495 0.902457C109.521 0.902457 109.573 0.876678 109.573 0.8509C109.598 0.825121 109.598 0.773564 109.573 0.747785C109.573 0.747785 109.573 0.747785 109.547 0.747785C109.495 0.747785 109.469 0.722007 109.418 0.747785C109.34 0.747785 109.263 0.773564 109.185 0.825121C109.082 0.8509 109.004 0.747786 108.875 0.799343C108.849 0.8509 108.798 0.8509 108.772 0.876679C108.746 0.876679 108.72 0.876678 108.695 0.902457C108.72 0.902457 108.798 0.876678 108.772 0.902457H108.695H108.746C108.746 0.928236 108.695 0.954015 108.669 0.954015C108.669 0.979794 108.72 0.954015 108.746 0.954015C108.746 0.979794 108.72 0.954015 108.695 1.00557C108.669 0.954015 108.591 0.954014 108.54 0.979793C108.514 1.00557 108.436 1.00557 108.436 1.05713C108.436 1.05713 108.436 1.05713 108.462 1.05713H108.385H108.359H108.488C108.488 1.05713 108.514 1.05713 108.488 1.08291C108.462 1.10869 108.41 1.13447 108.359 1.13447C108.307 1.13447 108.281 1.13447 108.23 1.13447C108.204 1.16024 108.307 1.13447 108.333 1.13447H108.281C108.307 1.13447 108.333 1.13447 108.333 1.13447C108.307 1.13447 108.307 1.13447 108.281 1.13447C108.281 1.13447 108.256 1.13447 108.23 1.13447C108.23 1.13447 108.23 1.13447 108.204 1.13447H108.126C108.152 1.13447 108.152 1.10869 108.178 1.10869C108.178 1.10869 108.178 1.10869 108.204 1.10869C108.178 1.10869 108.23 1.10869 108.23 1.10869C108.178 1.10869 108.126 1.10869 108.101 1.10869C108.049 1.10869 108.023 1.10869 107.997 1.10869C107.946 1.10869 107.894 1.10869 107.842 1.13447C107.791 1.13447 107.739 1.13447 107.713 1.13447C107.687 1.13447 107.558 1.18602 107.532 1.16024C107.558 1.16024 107.558 1.16024 107.584 1.16024C107.558 1.16024 107.532 1.16024 107.507 1.16024C107.584 1.13447 107.507 1.16024 107.532 1.16024C107.507 1.16024 107.481 1.16024 107.455 1.16024C107.507 1.16024 107.429 1.13447 107.507 1.13447C107.455 1.13447 107.403 1.13447 107.352 1.13447C107.352 1.13447 107.352 1.13447 107.326 1.16024C107.3 1.16024 107.378 1.16024 107.326 1.16024C107.274 1.16024 107.171 1.2118 107.145 1.16024C107.093 1.18602 107.223 1.16024 107.145 1.18602C107.171 1.18602 107.223 1.16024 107.248 1.18602C107.223 1.18602 107.248 1.18602 107.223 1.2118H107.197C107.119 1.2118 107.042 1.23758 106.939 1.26336C106.861 1.26336 106.809 1.26336 106.732 1.26336C106.758 1.26336 106.654 1.28914 106.706 1.28914C106.654 1.31492 106.629 1.31492 106.629 1.28914C106.629 1.28914 106.654 1.28914 106.68 1.28914C106.654 1.28914 106.629 1.28914 106.603 1.31492C106.551 1.31492 106.577 1.31492 106.551 1.31492L106.474 1.3407H106.422C106.448 1.3407 106.396 1.3407 106.37 1.36647H106.345H106.319C106.345 1.36647 106.293 1.39225 106.267 1.39225C106.19 1.41803 106.138 1.39225 106.06 1.44381C106.035 1.44381 106.009 1.44381 105.983 1.44381C105.957 1.44381 105.931 1.44381 105.906 1.44381C105.906 1.44381 105.931 1.44381 105.957 1.44381H105.983C105.957 1.44381 105.931 1.46959 105.906 1.46959C105.854 1.46959 105.828 1.46959 105.776 1.49537C105.828 1.46959 105.906 1.44381 105.957 1.41803L105.931 1.44381C105.957 1.44381 106.009 1.44381 106.035 1.41803C106.009 1.41803 105.983 1.44381 106.009 1.44381C106.009 1.44381 106.035 1.44381 106.06 1.44381C106.035 1.44381 106.009 1.44381 106.009 1.46959C106.009 1.46959 106.035 1.46959 106.06 1.46959C106.112 1.44381 106.138 1.44381 106.19 1.41803C106.19 1.44381 106.267 1.39225 106.267 1.41803H106.241C106.215 1.41803 106.19 1.44381 106.164 1.44381C106.164 1.44381 106.215 1.44381 106.215 1.41803C106.164 1.41803 106.138 1.44381 106.086 1.46959C106.112 1.46959 106.164 1.44381 106.164 1.46959C106.19 1.46959 106.241 1.44381 106.267 1.41803H106.293C106.345 1.39225 106.241 1.41803 106.319 1.39225C106.396 1.36647 106.396 1.39225 106.448 1.39225C106.422 1.39225 106.37 1.39225 106.345 1.39225H106.37C106.345 1.39225 106.293 1.39225 106.267 1.41803C106.319 1.41803 106.241 1.41803 106.215 1.44381C106.241 1.44381 106.267 1.44381 106.293 1.41803C106.19 1.44381 106.215 1.41803 106.112 1.44381C106.164 1.44381 106.112 1.46959 106.086 1.46959C106.086 1.46959 106.035 1.46959 106.009 1.46959V1.44381C105.957 1.44381 105.931 1.49537 105.88 1.49537C105.88 1.49537 105.931 1.46959 105.931 1.49537C105.854 1.49537 105.802 1.54693 105.751 1.5727C105.751 1.5727 105.751 1.5727 105.725 1.5727C105.725 1.5727 105.725 1.59848 105.751 1.5727C105.725 1.5727 105.699 1.5727 105.673 1.5727C105.725 1.54693 105.647 1.5727 105.647 1.5727C105.647 1.5727 105.647 1.5727 105.673 1.5727C105.647 1.5727 105.621 1.59848 105.621 1.59848C105.621 1.59848 105.673 1.59848 105.725 1.59848H105.699C105.699 1.59848 105.725 1.59848 105.751 1.59848C105.725 1.59848 105.725 1.62426 105.751 1.62426C105.776 1.62426 105.776 1.62426 105.776 1.62426C105.802 1.62426 105.751 1.65004 105.725 1.65004H105.699H105.596C105.57 1.65004 105.518 1.67582 105.492 1.7016C105.441 1.7016 105.415 1.72738 105.441 1.72738H105.389C105.467 1.72738 105.389 1.75315 105.415 1.75315H105.363C105.363 1.75315 105.363 1.75315 105.337 1.75315C105.337 1.75315 105.312 1.75315 105.312 1.77893C105.26 1.77893 105.208 1.80471 105.157 1.83049H105.131C105.182 1.80471 105.157 1.83049 105.157 1.80471C105.208 1.80471 105.234 1.77893 105.286 1.77893C105.286 1.77893 105.26 1.77893 105.234 1.77893C105.26 1.77893 105.312 1.77893 105.337 1.75315H105.363C105.337 1.75315 105.363 1.75315 105.312 1.75315C105.312 1.75315 105.363 1.75315 105.389 1.72738H105.415C105.415 1.72738 105.467 1.7016 105.415 1.7016H105.337H105.363H105.286C105.182 1.72738 105.26 1.72738 105.157 1.75315C105.105 1.75315 105.079 1.75315 105.028 1.77893C105.079 1.77893 105.028 1.77893 105.053 1.77893C105.028 1.77893 105.002 1.80471 104.976 1.77893C104.976 1.77893 104.95 1.80471 105.002 1.77893C105.002 1.77893 104.95 1.77893 104.95 1.80471C104.924 1.80471 104.898 1.80471 104.873 1.80471C104.847 1.80471 104.847 1.80471 104.821 1.80471C104.795 1.80471 104.743 1.80471 104.743 1.83049H104.718C104.666 1.83049 104.64 1.85627 104.563 1.88205C104.563 1.88205 104.563 1.88205 104.537 1.88205H104.511C104.485 1.88205 104.434 1.90783 104.382 1.90783H104.459L104.434 1.93361C104.382 1.95938 104.356 1.95938 104.304 1.98516C104.304 1.98516 104.33 1.95938 104.356 1.95938L104.304 1.98516C104.304 1.98516 104.279 1.98516 104.253 2.01094H104.227H104.201C104.227 2.01094 104.201 1.98516 104.227 1.98516H104.201C104.201 1.98516 104.201 2.03672 104.124 2.0625C104.124 2.0625 104.124 2.0625 104.098 2.0625H104.072H104.046C104.046 2.0625 103.995 2.08828 103.969 2.08828C103.943 2.08828 103.891 2.08828 103.891 2.11406C103.865 2.11406 103.84 2.11406 103.814 2.13984C103.814 2.13984 103.814 2.16561 103.814 2.19139H103.762C103.762 2.19139 103.788 2.19139 103.84 2.19139C103.814 2.19139 103.814 2.19139 103.788 2.21717C103.814 2.21717 103.84 2.21717 103.865 2.19139H103.814H103.84H103.762C103.814 2.19139 103.736 2.19139 103.71 2.21717C103.685 2.24295 103.685 2.21717 103.685 2.21717C103.71 2.21717 103.736 2.21717 103.762 2.19139C103.762 2.19139 103.762 2.19139 103.736 2.19139H103.71C103.71 2.19139 103.71 2.19139 103.685 2.19139H103.659C103.633 2.19139 103.633 2.19139 103.659 2.21717C103.659 2.21717 103.659 2.21717 103.633 2.21717C103.607 2.21717 103.607 2.21717 103.581 2.24295C103.581 2.26873 103.504 2.26873 103.504 2.29451C103.478 2.29451 103.426 2.32029 103.401 2.34607C103.401 2.34607 103.401 2.34607 103.426 2.34607L103.375 2.37184C103.323 2.37184 103.297 2.39762 103.271 2.4234H103.22H103.194H103.168H103.142H103.117H103.091C103.091 2.4234 103.117 2.4234 103.142 2.4234C103.168 2.4234 103.142 2.47496 103.22 2.4234C103.22 2.39762 103.297 2.39762 103.297 2.39762C103.297 2.39762 103.323 2.39762 103.297 2.4234C103.271 2.4234 103.246 2.4234 103.22 2.44918L103.168 2.47496C103.142 2.50074 103.117 2.50074 103.065 2.52652C103.039 2.52652 102.936 2.57807 102.962 2.52652C102.936 2.55229 102.884 2.55229 102.858 2.55229L102.91 2.52652C102.884 2.52652 102.832 2.52652 102.832 2.52652H102.807H102.781L102.729 2.55229H102.703C102.703 2.55229 102.677 2.55229 102.652 2.55229C102.626 2.55229 102.626 2.55229 102.626 2.55229H102.6L102.574 2.57807H102.548C102.471 2.60385 102.445 2.65541 102.393 2.62963C102.419 2.62963 102.368 2.65541 102.368 2.65541L102.342 2.68119C102.316 2.68119 102.316 2.70697 102.316 2.70697C102.342 2.70697 102.368 2.68119 102.393 2.68119H102.419C102.471 2.65541 102.471 2.68119 102.497 2.65541L102.471 2.68119H102.548C102.523 2.68119 102.497 2.70697 102.471 2.70697H102.497C102.497 2.70697 102.471 2.70697 102.445 2.70697C102.419 2.70697 102.419 2.70697 102.393 2.73275C102.342 2.73275 102.316 2.75852 102.29 2.7843H102.264C102.29 2.75852 102.238 2.75852 102.264 2.73275C102.213 2.75852 102.187 2.75852 102.187 2.7843C102.238 2.7843 102.238 2.7843 102.238 2.7843L102.161 2.81008C102.161 2.81008 102.161 2.81008 102.135 2.81008C102.084 2.83586 102.109 2.81008 102.058 2.83586L101.98 2.86164V2.83586C101.954 2.83586 101.98 2.86164 101.98 2.86164C101.98 2.86164 102.006 2.86164 102.032 2.86164L102.006 2.88742C101.98 2.88742 101.954 2.88742 101.929 2.88742C101.851 2.93898 101.774 2.9132 101.696 2.96475L101.825 2.93898L101.799 2.96475H101.851C101.825 2.99053 101.774 2.96475 101.774 2.99053H101.799C101.774 2.99053 101.774 2.99053 101.748 3.01631C101.774 3.01631 101.799 3.01631 101.825 3.01631C101.825 3.01631 101.799 3.01631 101.774 3.04209H101.748L101.722 3.06787C101.748 3.06787 101.774 3.04209 101.799 3.04209C101.825 3.04209 101.851 3.04209 101.877 3.04209C101.851 3.04209 101.825 3.06787 101.799 3.06787H101.825C101.877 3.04209 101.903 3.04209 101.954 3.01631C102.006 3.01631 102.032 2.96475 102.084 2.96475H102.058L102.213 2.93898H102.238L102.316 2.9132C102.316 2.9132 102.316 2.9132 102.29 2.93898C102.29 2.93898 102.213 2.96475 102.238 2.93898C102.213 2.96475 102.161 2.96475 102.161 2.96475C102.187 2.93898 102.135 2.96475 102.135 2.96475L102.084 2.99053C102.084 2.99053 102.084 2.99053 102.109 2.99053C102.135 2.99053 102.058 3.01631 102.109 3.01631C102.058 3.01631 101.98 3.06787 101.929 3.09365L101.954 3.06787C101.929 3.06787 101.903 3.09365 101.877 3.11943L101.954 3.09365L101.903 3.11943H101.825H101.851C101.799 3.11943 101.774 3.1452 101.722 3.17098C101.748 3.17098 101.799 3.14521 101.851 3.11943C101.903 3.11943 101.851 3.14521 101.877 3.11943C101.877 3.11943 101.851 3.11943 101.825 3.11943C101.851 3.11943 101.929 3.09365 101.98 3.09365C102.006 3.06787 102.058 3.06787 102.084 3.04209H102.058C102.058 3.04209 102.084 3.04209 102.109 3.04209C102.084 3.06787 102.109 3.04209 102.084 3.06787C102.109 3.06787 102.135 3.06787 102.161 3.04209C102.161 3.04209 102.187 3.04209 102.213 3.01631H102.238C102.187 3.04209 102.264 3.01631 102.264 3.01631C102.264 3.01631 102.29 3.01631 102.316 3.01631C102.29 3.01631 102.264 3.01631 102.29 3.01631C102.29 3.01631 102.316 3.01631 102.342 3.01631H102.316L102.393 2.99053C102.419 2.99053 102.419 2.99053 102.445 2.99053C102.445 2.99053 102.471 2.96475 102.497 2.96475H102.471C102.497 2.93898 102.548 2.93898 102.574 2.93898C102.6 2.93898 102.419 2.96475 102.574 2.9132C102.626 2.88742 102.626 2.9132 102.652 2.9132C102.677 2.9132 102.677 2.9132 102.703 2.9132C102.703 2.9132 102.677 2.9132 102.652 2.93898C102.652 2.93898 102.703 2.9132 102.729 2.9132C102.703 2.9132 102.781 2.88742 102.755 2.88742C102.807 2.86164 102.832 2.83586 102.884 2.83586C102.91 2.81008 102.936 2.81008 102.987 2.7843H102.962C102.936 2.7843 103.013 2.75852 102.962 2.75852H102.936L102.962 2.73275C102.987 2.73275 102.987 2.70697 103.013 2.70697H103.039C103.117 2.68119 103.194 2.65541 103.271 2.62963C103.271 2.62963 103.297 2.62963 103.323 2.62963H103.297V2.65541H103.323V2.62963H103.349L103.426 2.60385L103.297 2.88742L103.375 2.86164C103.426 2.83586 103.375 2.83586 103.452 2.81008C103.452 2.81008 103.452 2.81008 103.452 2.83586L103.504 2.81008H103.556C103.581 2.7843 103.504 2.81008 103.504 2.81008C103.504 2.81008 103.504 2.81008 103.53 2.7843C103.478 2.7843 103.452 2.81008 103.401 2.81008C103.401 2.81008 103.401 2.81008 103.401 2.7843C103.452 2.75852 103.504 2.75852 103.556 2.75852C103.581 2.75852 103.659 2.70697 103.607 2.70697C103.659 2.70697 103.659 2.73275 103.71 2.70697C103.633 2.73275 103.633 2.70697 103.556 2.73275C103.556 2.73275 103.53 2.75852 103.556 2.75852C103.581 2.75852 103.581 2.73275 103.607 2.73275C103.607 2.73275 103.53 2.75852 103.581 2.75852H103.53L103.581 2.73275C103.581 2.73275 103.581 2.73275 103.607 2.73275L103.814 2.65541C103.814 2.65541 103.84 2.65541 103.865 2.65541C103.865 2.65541 103.865 2.65541 103.891 2.65541L103.969 2.62963C103.969 2.62963 103.995 2.62963 104.02 2.62963H104.046L104.175 2.60385C104.175 2.60385 104.227 2.60385 104.253 2.60385C104.227 2.60385 104.227 2.60385 104.227 2.60385H104.253C104.279 2.60385 104.382 2.55229 104.356 2.57807C104.382 2.57807 104.408 2.55229 104.434 2.55229C104.408 2.55229 104.408 2.55229 104.408 2.55229C104.408 2.55229 104.434 2.55229 104.459 2.55229C104.485 2.55229 104.408 2.55229 104.408 2.55229C104.356 2.55229 104.33 2.57807 104.33 2.57807L104.356 2.55229C104.279 2.57807 104.279 2.55229 104.201 2.57807C104.227 2.57807 104.33 2.55229 104.279 2.57807H104.227C104.201 2.57807 104.227 2.57807 104.253 2.57807C104.227 2.57807 104.201 2.60385 104.175 2.60385C104.175 2.60385 104.227 2.57807 104.175 2.57807L104.046 2.60385C104.072 2.60385 104.072 2.60385 104.072 2.60385C104.046 2.60385 104.046 2.60385 103.995 2.60385H104.046C103.995 2.62963 103.943 2.62963 103.891 2.65541C103.865 2.65541 103.814 2.68119 103.788 2.68119C103.84 2.68119 103.891 2.65541 103.943 2.62963C103.917 2.62963 103.943 2.60385 103.995 2.57807H104.046C104.046 2.57807 104.02 2.60385 104.046 2.60385C104.046 2.60385 104.046 2.60385 104.046 2.57807C104.072 2.57807 104.098 2.57807 104.124 2.55229C104.149 2.55229 104.201 2.55229 104.227 2.52652H104.253C104.253 2.52652 104.279 2.52652 104.304 2.52652H104.356C104.382 2.52652 104.382 2.52652 104.382 2.52652L104.459 2.50074C104.408 2.52652 104.511 2.50074 104.434 2.52652C104.356 2.55229 104.356 2.52652 104.304 2.55229C104.33 2.55229 104.382 2.55229 104.408 2.55229H104.382C104.408 2.55229 104.459 2.55229 104.485 2.52652C104.434 2.52652 104.511 2.52652 104.537 2.50074C104.511 2.50074 104.485 2.52652 104.459 2.52652C104.563 2.50074 104.537 2.52652 104.64 2.50074C104.588 2.50074 104.64 2.47496 104.666 2.47496C104.666 2.47496 104.718 2.47496 104.743 2.47496V2.50074C104.769 2.50074 104.795 2.47496 104.821 2.47496H104.847C104.898 2.47496 104.95 2.44918 105.002 2.39762H105.028C105.028 2.39762 105.028 2.39762 105.053 2.39762H105.105H105.157C105.182 2.39762 105.157 2.39762 105.131 2.39762H105.157H105.182C105.182 2.39762 105.182 2.39762 105.208 2.39762H105.234H105.26H105.286C105.286 2.39762 105.312 2.39762 105.337 2.39762C105.363 2.39762 105.337 2.4234 105.363 2.4234H105.337C105.312 2.44918 105.286 2.44918 105.234 2.44918C105.234 2.44918 105.208 2.44918 105.234 2.47496C105.234 2.47496 105.234 2.47496 105.208 2.47496H105.157H105.182H105.208C105.157 2.47496 105.079 2.50074 105.028 2.52652C104.976 2.52652 105.002 2.55229 105.028 2.55229C105.028 2.55229 105.028 2.55229 105.002 2.55229V2.52652C104.976 2.55229 104.924 2.55229 104.898 2.57807C104.898 2.57807 104.898 2.57807 104.873 2.57807C104.847 2.57807 104.821 2.57807 104.795 2.57807H104.769C104.769 2.57807 104.769 2.57807 104.743 2.57807H104.769C104.769 2.57807 104.743 2.57807 104.718 2.57807C104.692 2.57807 104.666 2.60385 104.64 2.60385C104.614 2.60385 104.666 2.57807 104.64 2.55229C104.64 2.55229 104.614 2.57807 104.588 2.57807C104.563 2.57807 104.563 2.57807 104.537 2.60385C104.537 2.60385 104.537 2.60385 104.563 2.60385H104.537C104.537 2.60385 104.537 2.60385 104.511 2.60385C104.511 2.60385 104.511 2.60385 104.511 2.62963C104.511 2.62963 104.459 2.62963 104.485 2.62963H104.459C104.459 2.62963 104.434 2.65541 104.459 2.65541C104.459 2.65541 104.408 2.65541 104.434 2.68119C104.408 2.68119 104.382 2.68119 104.356 2.70697C104.356 2.70697 104.356 2.70697 104.382 2.70697C104.382 2.70697 104.356 2.73275 104.33 2.73275C104.33 2.73275 104.304 2.73275 104.279 2.73275C104.279 2.73275 104.279 2.73275 104.253 2.73275C104.227 2.73275 104.227 2.73275 104.201 2.75852C104.227 2.73275 104.149 2.75852 104.149 2.7843C104.098 2.7843 104.072 2.81008 104.072 2.83586C104.098 2.83586 104.098 2.83586 104.098 2.81008C104.098 2.7843 104.098 2.81008 104.124 2.81008C104.124 2.81008 104.098 2.81008 104.124 2.83586C104.072 2.83586 104.098 2.83586 104.072 2.83586L104.02 2.86164H103.969C103.969 2.86164 103.969 2.86164 103.995 2.86164C103.969 2.86164 103.917 2.88742 103.917 2.86164C103.943 2.86164 103.969 2.83586 103.995 2.83586C103.995 2.83586 103.995 2.83586 104.02 2.83586C103.969 2.83586 103.969 2.86164 103.917 2.88742C103.917 2.88742 103.917 2.88742 103.891 2.9132H103.917C103.943 2.9132 103.943 2.9132 103.969 2.88742L103.891 2.9132C103.865 2.9132 103.891 2.9132 103.865 2.88742C103.84 2.9132 103.84 2.88742 103.788 2.9132H103.814C103.814 2.9132 103.762 2.93897 103.762 2.9132C103.736 2.9132 103.788 2.9132 103.762 2.9132H103.788C103.762 2.9132 103.736 2.93898 103.71 2.93898C103.71 2.93898 103.736 2.93897 103.736 2.9132H103.71C103.685 2.9132 103.659 2.93898 103.659 2.93898H103.633C103.633 2.93898 103.581 2.99053 103.581 2.96475C103.53 2.96475 103.53 2.99053 103.504 2.99053C103.478 2.99053 103.504 2.99053 103.504 2.96475H103.478C103.504 2.99053 103.375 2.99053 103.349 3.04209C103.349 3.04209 103.349 3.04209 103.323 3.04209C103.297 3.04209 103.271 3.06787 103.246 3.06787C103.194 3.06787 103.142 3.09365 103.091 3.11943C103.117 3.11943 103.142 3.11943 103.168 3.09365V3.1452V3.17098C103.194 3.17098 103.168 3.19676 103.194 3.17098C103.194 3.17098 103.168 3.17098 103.142 3.19676C103.142 3.22254 103.22 3.17098 103.246 3.1452C103.246 3.1452 103.246 3.17098 103.271 3.17098C103.194 3.22254 103.142 3.19676 103.091 3.24832C103.065 3.24832 103.039 3.24832 103.039 3.24832H103.065C103.039 3.24832 103.065 3.24832 103.013 3.24832C102.987 3.24832 103.013 3.2741 102.987 3.2741H103.039C103.013 3.2741 103.013 3.29988 102.962 3.32566C103.013 3.32566 103.091 3.2741 103.065 3.32566H103.039C102.987 3.32566 102.91 3.32566 102.91 3.37721L102.858 3.40299C102.858 3.40299 102.858 3.40299 102.884 3.37721C102.858 3.37721 102.832 3.40299 102.807 3.40299C102.807 3.42877 102.807 3.42877 102.807 3.42877C102.781 3.42877 102.781 3.42877 102.755 3.45455C102.729 3.45455 102.677 3.48033 102.677 3.45455C102.677 3.45455 102.703 3.48033 102.652 3.48033L102.497 3.55766C102.497 3.55766 102.419 3.58344 102.419 3.55766C102.419 3.55766 102.419 3.55766 102.393 3.55766C102.393 3.55766 102.393 3.55766 102.368 3.55766C102.342 3.55766 102.316 3.55766 102.316 3.58344C102.342 3.58344 102.393 3.55766 102.393 3.53189C102.393 3.53189 102.419 3.53189 102.445 3.53189C102.471 3.53189 102.497 3.53189 102.523 3.50611C102.497 3.50611 102.471 3.50611 102.471 3.53189C102.523 3.53189 102.471 3.53189 102.445 3.53189H102.419C102.419 3.53189 102.393 3.53189 102.368 3.55766C102.342 3.58344 102.342 3.58344 102.29 3.60922V3.635H102.264C102.238 3.635 102.264 3.635 102.264 3.60922C102.29 3.60922 102.316 3.60922 102.342 3.58344H102.316C102.342 3.58344 102.393 3.58344 102.419 3.55766C102.445 3.55766 102.497 3.53189 102.497 3.53189C102.523 3.50611 102.574 3.50611 102.6 3.48033C102.6 3.48033 102.6 3.48033 102.574 3.48033C102.652 3.48033 102.703 3.45455 102.781 3.40299C102.755 3.40299 102.755 3.40299 102.781 3.40299C102.755 3.40299 102.807 3.40299 102.781 3.40299C102.755 3.40299 102.729 3.42877 102.703 3.45455C102.677 3.45455 102.703 3.45455 102.703 3.42877C102.677 3.42877 102.652 3.45455 102.626 3.45455C102.652 3.45455 102.677 3.45455 102.703 3.42877C102.677 3.42877 102.652 3.42877 102.626 3.45455C102.6 3.48033 102.574 3.48033 102.548 3.50611C102.523 3.53189 102.497 3.53189 102.445 3.55766H102.419C102.419 3.55766 102.342 3.58344 102.264 3.58344C102.213 3.60922 102.213 3.58344 102.135 3.60922C102.135 3.60922 102.135 3.60922 102.135 3.58344C102.109 3.58344 102.058 3.60922 102.058 3.60922C102.058 3.60922 102.058 3.60922 102.032 3.60922C102.032 3.635 102.032 3.635 102.058 3.66078C102.032 3.66078 102.058 3.66078 102.006 3.66078C102.006 3.66078 102.006 3.66078 102.006 3.635C101.98 3.66078 101.98 3.635 101.954 3.635C101.954 3.66078 101.929 3.635 101.929 3.66078C101.929 3.68656 101.929 3.66078 101.903 3.68656C101.877 3.71234 101.929 3.68656 101.903 3.66078C101.877 3.635 101.851 3.68656 101.877 3.66078C101.851 3.66078 101.825 3.66078 101.799 3.66078C101.851 3.635 101.903 3.60922 101.954 3.58344C101.954 3.58344 101.954 3.58344 101.954 3.55766C101.954 3.53189 101.98 3.55766 101.98 3.55766C101.98 3.55766 102.006 3.53189 102.032 3.53189C102.032 3.55766 102.084 3.53189 102.109 3.53189C102.135 3.53189 102.084 3.53189 102.058 3.53189C102.084 3.53189 102.109 3.50611 102.109 3.53189C102.109 3.53189 102.135 3.53189 102.161 3.53189C102.161 3.53189 102.161 3.53189 102.135 3.53189L102.213 3.50611C102.213 3.50611 102.238 3.50611 102.238 3.48033C102.238 3.48033 102.238 3.48033 102.213 3.48033C102.238 3.48033 102.264 3.45455 102.29 3.45455C102.368 3.45455 102.445 3.42877 102.497 3.37721C102.548 3.35143 102.574 3.35143 102.6 3.32566H102.652C102.652 3.32566 102.6 3.32566 102.574 3.32566C102.548 3.35143 102.497 3.35143 102.471 3.37721C102.471 3.37721 102.497 3.37721 102.497 3.35143C102.497 3.32566 102.471 3.37721 102.471 3.35143H102.523C102.548 3.35143 102.6 3.32566 102.6 3.32566C102.626 3.32566 102.6 3.29988 102.626 3.29988C102.626 3.29988 102.574 3.29988 102.6 3.29988C102.6 3.29988 102.6 3.29988 102.574 3.29988C102.574 3.32566 102.548 3.32566 102.523 3.32566H102.471C102.471 3.32566 102.471 3.32566 102.445 3.32566C102.393 3.35143 102.368 3.35143 102.316 3.37721C102.316 3.37721 102.368 3.37721 102.342 3.37721C102.342 3.37721 102.368 3.37721 102.393 3.37721C102.342 3.40299 102.445 3.35143 102.471 3.37721C102.445 3.37721 102.393 3.40299 102.445 3.40299C102.419 3.40299 102.419 3.40299 102.419 3.40299C102.368 3.45455 102.29 3.45455 102.264 3.48033C102.264 3.48033 102.238 3.48033 102.238 3.50611C102.187 3.50611 102.187 3.53189 102.135 3.55766C102.161 3.53189 102.135 3.53189 102.109 3.53189C102.109 3.53189 102.109 3.53189 102.084 3.55766C102.109 3.55766 102.109 3.55766 102.109 3.58344C102.084 3.58344 102.084 3.58344 102.058 3.58344H102.006H101.98C101.954 3.60922 101.929 3.60922 101.903 3.60922C101.877 3.60922 101.877 3.635 101.851 3.66078C101.825 3.66078 101.825 3.68656 101.799 3.68656C101.799 3.68656 101.774 3.68656 101.748 3.71234C101.748 3.71234 101.774 3.73812 101.799 3.71234C101.748 3.71234 101.722 3.71234 101.722 3.71234C101.696 3.71234 101.722 3.73812 101.696 3.73812C101.696 3.73812 101.696 3.71234 101.645 3.73812H101.619C101.567 3.76389 101.541 3.78967 101.49 3.78967C101.464 3.78967 101.464 3.78967 101.438 3.78967C101.412 3.78967 101.386 3.81545 101.386 3.84123C101.386 3.84123 101.386 3.84123 101.412 3.84123C101.438 3.81545 101.541 3.81545 101.567 3.76389C101.619 3.76389 101.67 3.73812 101.722 3.71234H101.748C101.748 3.71234 101.696 3.73812 101.722 3.76389C101.748 3.76389 101.748 3.76389 101.774 3.73812C101.696 3.78967 101.645 3.81545 101.567 3.84123C101.567 3.84123 101.619 3.81545 101.645 3.81545C101.619 3.81545 101.645 3.81545 101.645 3.84123H101.67C101.67 3.84123 101.67 3.81545 101.645 3.84123C101.645 3.84123 101.696 3.81545 101.67 3.81545C101.696 3.78967 101.696 3.81545 101.748 3.78967C101.748 3.78967 101.774 3.78967 101.774 3.81545C101.774 3.81545 101.774 3.84123 101.722 3.86701C101.645 3.86701 101.567 3.94434 101.464 3.97012C101.412 4.02168 101.36 4.02168 101.309 4.04746C101.309 4.04746 101.309 4.02168 101.335 4.02168H101.386C101.36 4.02168 101.309 4.04746 101.283 4.04746C101.283 4.04746 101.309 4.04746 101.335 4.04746H101.309C101.309 4.07324 101.335 4.07324 101.309 4.09902L101.257 4.1248C101.309 4.09902 101.335 4.09902 101.335 4.07324C101.335 4.07324 101.36 4.07324 101.386 4.07324C101.36 4.09902 101.283 4.1248 101.231 4.15057H101.206C101.231 4.15057 101.231 4.1248 101.257 4.1248C101.231 4.1248 101.206 4.1248 101.18 4.15057C101.18 4.15057 101.206 4.15057 101.18 4.1248H101.206L101.18 4.15057H101.206C101.18 4.15057 101.18 4.17635 101.154 4.17635C101.154 4.17635 101.154 4.17635 101.128 4.17635C101.102 4.20213 101.076 4.25369 101.025 4.25369C101.025 4.25369 101.051 4.22791 101.076 4.22791H101.025C101.025 4.22791 101.025 4.22791 101.025 4.25369C101.025 4.27947 101.025 4.25369 100.999 4.25369C100.999 4.25369 100.973 4.27947 100.947 4.27947C100.947 4.27947 100.921 4.30525 100.896 4.30525C100.87 4.30525 100.921 4.27947 100.896 4.30525C100.896 4.33103 100.896 4.33103 100.844 4.3568C100.792 4.38258 100.766 4.40836 100.715 4.40836C100.637 4.43414 100.534 4.4857 100.457 4.53726H100.431C100.405 4.53726 100.431 4.51148 100.405 4.53726C100.379 4.53726 100.379 4.53726 100.379 4.56303C100.379 4.58881 100.431 4.53726 100.457 4.53726C100.457 4.53726 100.508 4.51148 100.534 4.51148H100.508C100.508 4.4857 100.534 4.4857 100.56 4.4857C100.56 4.4857 100.56 4.4857 100.56 4.51148C100.586 4.51148 100.586 4.4857 100.612 4.4857C100.612 4.4857 100.612 4.4857 100.612 4.51148C100.612 4.51148 100.586 4.53725 100.56 4.51148C100.56 4.53725 100.637 4.4857 100.663 4.45992C100.663 4.45992 100.637 4.45992 100.612 4.45992C100.612 4.45992 100.663 4.45992 100.637 4.43414H100.663L100.87 4.3568C100.87 4.3568 100.87 4.3568 100.87 4.33103C100.896 4.33103 100.896 4.33103 100.896 4.33103C100.921 4.30525 100.921 4.33103 100.947 4.33103H100.921C100.947 4.33103 100.947 4.33103 100.947 4.33103C101.076 4.27947 101.257 4.20213 101.412 4.1248C101.412 4.1248 101.464 4.1248 101.49 4.1248C101.49 4.1248 101.464 4.1248 101.438 4.15057H101.464C101.464 4.15057 101.464 4.15057 101.438 4.17635C101.412 4.17635 101.386 4.20213 101.36 4.20213H101.386C101.36 4.22791 101.309 4.22791 101.257 4.25369H101.283C101.283 4.25369 101.257 4.27947 101.231 4.27947C101.206 4.27947 101.154 4.30525 101.18 4.27947L101.128 4.30525C101.102 4.33103 101.025 4.38258 101.025 4.38258C101.051 4.38258 101.102 4.38258 101.128 4.3568C101.206 4.30525 101.283 4.27947 101.36 4.22791C101.386 4.22791 101.412 4.22791 101.438 4.20213C101.412 4.20213 101.335 4.25369 101.36 4.20213C101.386 4.20213 101.412 4.17635 101.438 4.15057H101.464C101.412 4.17635 101.515 4.15057 101.386 4.20213C101.412 4.20213 101.438 4.20213 101.49 4.17635C101.567 4.1248 101.335 4.22791 101.515 4.1248H101.541L101.645 4.07324C101.593 4.09902 101.567 4.09902 101.515 4.1248C101.593 4.09902 101.645 4.04746 101.696 4.02168H101.748H101.722C101.722 4.02168 101.722 4.02168 101.748 4.02168H101.722L101.774 3.9959C101.774 3.9959 101.799 3.9959 101.825 3.97012H101.851C101.825 3.97012 101.825 3.9959 101.799 3.9959C101.851 3.9959 101.903 3.97012 101.954 3.94434H101.98C101.954 3.94434 101.954 3.94434 101.929 3.94434C101.98 3.94434 101.929 3.97012 101.954 3.9959C101.954 3.9959 101.954 3.97012 101.929 3.9959L101.851 4.02168H101.877C101.954 3.9959 101.929 3.9959 101.903 3.9959C101.903 3.9959 101.903 3.9959 101.877 3.9959C101.877 3.9959 101.877 3.9959 101.851 3.9959C101.825 3.9959 101.799 4.02168 101.774 4.02168C101.722 4.02168 101.696 4.04746 101.645 4.07324L101.619 4.09902L101.464 4.17635C101.464 4.17635 101.464 4.17635 101.438 4.17635L101.386 4.20213H101.412C101.335 4.25369 101.36 4.20213 101.309 4.22791C101.309 4.22791 101.309 4.22791 101.283 4.22791L101.206 4.25369C101.206 4.25369 101.257 4.25369 101.309 4.22791C101.335 4.22791 101.335 4.22791 101.36 4.20213C101.386 4.20213 101.412 4.17635 101.438 4.15057C101.464 4.15057 101.464 4.15057 101.464 4.1248H101.49C101.515 4.09902 101.541 4.09902 101.567 4.07324C101.567 4.07324 101.645 4.04746 101.696 4.02168C101.696 4.02168 101.645 4.04746 101.619 4.04746C101.645 4.04746 101.67 4.02168 101.67 4.04746C101.696 4.04746 101.696 4.02168 101.722 4.02168H101.748H101.774C101.774 4.02168 101.748 4.02168 101.748 4.04746C101.748 4.04746 101.722 4.04746 101.696 4.04746H101.722C101.696 4.04746 101.696 4.04746 101.67 4.04746C101.541 4.09902 101.49 4.1248 101.386 4.17635C101.386 4.20213 101.36 4.22791 101.335 4.22791H101.309C101.309 4.22791 101.283 4.22791 101.257 4.22791C101.231 4.22791 101.231 4.22791 101.206 4.22791C101.283 4.17635 101.283 4.20213 101.309 4.17635C101.36 4.15057 101.309 4.17635 101.36 4.1248C101.335 4.15057 101.18 4.20213 101.154 4.22791C101.076 4.27947 101.102 4.30525 100.973 4.33103L100.921 4.3568C100.87 4.38258 100.818 4.43414 100.766 4.43414C100.715 4.45992 100.663 4.4857 100.612 4.51148C100.586 4.53725 100.612 4.51148 100.637 4.51148C100.56 4.56303 100.457 4.58881 100.353 4.61459L100.302 4.66615C100.327 4.66615 100.379 4.64037 100.379 4.64037C100.353 4.64037 100.327 4.66615 100.302 4.66615C100.327 4.66615 100.327 4.66615 100.353 4.66615H100.327C100.276 4.69193 100.302 4.64037 100.25 4.69193C100.224 4.69193 100.198 4.71771 100.173 4.69193L100.121 4.74348C100.095 4.74348 100.043 4.76926 100.018 4.76926H100.043C100.018 4.76926 99.9659 4.76926 99.9659 4.79504C99.9659 4.82082 99.8368 4.87238 99.811 4.89816C99.656 4.97549 99.4753 5.05283 99.372 5.10439C99.3462 5.13017 99.2945 5.15594 99.3203 5.15594C99.217 5.2075 99.1396 5.23328 99.0363 5.31062L99.0879 5.28484C99.0104 5.31062 98.9588 5.36217 98.8555 5.41373H98.8813C98.8813 5.41373 98.8297 5.43951 98.8038 5.43951C98.778 5.43951 98.8297 5.43951 98.8038 5.43951C98.5973 5.5684 98.4165 5.64574 98.2099 5.74885C98.2874 5.72308 98.2874 5.72308 98.3132 5.72308L98.2615 5.74885C98.2357 5.74885 98.1841 5.77463 98.1582 5.80041C98.0549 5.87775 97.9516 5.87775 97.8225 5.95508L98.0291 5.87775L98.0033 5.90353L98.0808 5.87775C98.0291 5.90353 98.0033 5.92931 98.0033 5.92931H98.0291C98.0033 5.95509 97.9775 5.95508 97.9516 5.98086C98.0549 5.92931 98.1841 5.90353 98.2874 5.82619L98.2615 5.85197C98.2874 5.82619 98.339 5.80041 98.3648 5.77463H98.339H98.2874C98.3132 5.74885 98.339 5.72308 98.3907 5.6973C98.4423 5.67152 98.3648 5.72308 98.339 5.72308C98.339 5.72308 98.3648 5.72308 98.3907 5.72308C98.3907 5.72308 98.5456 5.64574 98.5456 5.61996C98.7006 5.54262 98.5456 5.64574 98.6747 5.5684L98.7006 5.54262C98.778 5.51685 98.8555 5.46529 98.933 5.43951L99.0104 5.38795H98.9846C99.0363 5.36217 99.0879 5.3364 99.1396 5.28484C99.217 5.25906 99.372 5.2075 99.4495 5.15594C99.4495 5.13017 99.3203 5.2075 99.2945 5.23328L99.372 5.18172C99.3462 5.2075 99.2945 5.2075 99.2687 5.23328C99.3203 5.2075 99.372 5.18172 99.4236 5.15594C99.4236 5.15594 99.4236 5.15594 99.4495 5.13017L99.5786 5.07861C99.5528 5.10439 99.5527 5.10439 99.5269 5.13017C99.5269 5.13017 99.5011 5.13017 99.4753 5.15594C99.5011 5.15594 99.4495 5.18172 99.4495 5.18172C99.5269 5.15594 99.6044 5.10439 99.6302 5.07861C99.6819 5.05283 99.7593 5.00127 99.7852 5.00127C99.8626 4.94971 99.9401 4.92394 99.9918 4.89816C100.069 4.87238 100.147 4.8466 100.198 4.82082C100.224 4.82082 100.379 4.71771 100.457 4.69193C100.457 4.69193 100.405 4.71771 100.379 4.71771C100.431 4.69193 100.457 4.69193 100.482 4.66615C100.379 4.71771 100.482 4.66615 100.431 4.66615C100.482 4.64037 100.508 4.61459 100.56 4.61459C100.482 4.66615 100.612 4.61459 100.508 4.66615C100.56 4.66615 100.586 4.64037 100.637 4.61459H100.663L100.741 4.58881C100.741 4.58881 100.741 4.58881 100.766 4.56303H100.792C100.715 4.58881 100.818 4.53726 100.792 4.56303C100.844 4.53726 100.947 4.4857 100.999 4.45992C100.999 4.45992 101.025 4.45992 101.051 4.45992C101.076 4.43414 101.051 4.45992 101.025 4.45992L101.076 4.40836C101.076 4.40836 101.051 4.40836 101.025 4.40836C100.973 4.40836 100.896 4.4857 100.87 4.45992C100.921 4.43414 100.87 4.43414 100.921 4.43414L100.973 4.40836C101.076 4.38258 101.206 4.30525 101.335 4.22791H101.36C101.335 4.22791 101.309 4.25369 101.257 4.27947C101.257 4.27947 101.309 4.27947 101.309 4.25369H101.335C101.36 4.22791 101.386 4.25369 101.438 4.20213H101.464H101.49C101.49 4.20213 101.515 4.20213 101.541 4.17635L101.515 4.20213H101.49L101.464 4.22791H101.49C101.438 4.25369 101.386 4.27947 101.335 4.30525L101.257 4.3568C101.257 4.3568 101.283 4.33103 101.335 4.30525C101.257 4.33103 101.231 4.3568 101.18 4.38258H101.154L101.102 4.40836C101.102 4.40836 101.128 4.40836 101.154 4.40836C101.128 4.40836 101.102 4.40836 101.076 4.43414C101.025 4.43414 100.999 4.4857 100.947 4.4857C100.973 4.45992 101.025 4.45992 101.051 4.43414H101.025C101.025 4.43414 100.999 4.43414 100.973 4.45992H101.025H100.999C100.973 4.45992 100.973 4.4857 100.973 4.4857C100.947 4.4857 100.896 4.51148 100.896 4.53726C100.87 4.53726 100.818 4.56303 100.792 4.58881V4.61459H100.818H100.844L100.792 4.64037C100.766 4.64037 100.741 4.64037 100.715 4.64037C100.663 4.66615 100.637 4.69193 100.586 4.71771L100.534 4.74348C100.457 4.79504 100.379 4.82082 100.302 4.87238C100.327 4.8466 100.353 4.8466 100.379 4.82082C100.353 4.8466 100.405 4.82082 100.379 4.82082L100.302 4.8466L100.25 4.87238C100.302 4.87238 100.327 4.8466 100.379 4.82082C100.327 4.8466 100.276 4.87238 100.224 4.89816L100.276 4.87238H100.224C100.147 4.89816 100.069 4.92394 100.018 4.97549C100.043 4.97549 100.043 4.97549 100.018 4.97549C99.9401 5.02705 99.8626 5.07861 99.7852 5.13017C99.8368 5.10439 99.8368 5.07861 99.8368 5.07861L99.7852 5.10439V5.2075H99.7593C99.7593 5.2075 99.7593 5.2075 99.7852 5.2075C99.7593 5.23328 99.7077 5.23328 99.7077 5.25906C99.7335 5.25906 99.7593 5.25906 99.7335 5.28484C99.7593 5.25906 99.8626 5.2075 99.9143 5.18172C99.8626 5.18172 99.811 5.2075 99.7593 5.23328C99.7593 5.18172 99.9143 5.15594 99.9143 5.13017C99.9401 5.13017 99.9659 5.10439 99.9918 5.07861C99.9918 5.07861 100.018 5.07861 100.043 5.05283C100.095 5.05283 100.147 5.02705 100.198 4.97549H100.25C100.173 5.02705 100.095 5.07861 99.9918 5.13017H100.018C99.9659 5.15594 99.9401 5.18172 99.8885 5.2075C99.811 5.23328 99.8368 5.23328 99.811 5.28484C99.7593 5.31062 99.7335 5.33639 99.6819 5.36217H99.7077L99.6819 5.38795C99.6819 5.38795 99.656 5.38795 99.656 5.41373C99.6302 5.43951 99.6044 5.43951 99.5786 5.46529L99.6819 5.38795C99.6302 5.41373 99.6561 5.38795 99.6044 5.41373C99.6819 5.38795 99.5528 5.43951 99.5528 5.46529L99.5011 5.49107C99.4753 5.51685 99.4495 5.51685 99.4236 5.54262C99.4753 5.51685 99.5011 5.46529 99.5786 5.46529C99.5269 5.49107 99.4236 5.54262 99.4236 5.54262C99.372 5.5684 99.3462 5.59418 99.2945 5.61996C99.372 5.5684 99.2945 5.67152 99.4495 5.5684C99.4495 5.5684 99.4495 5.5684 99.4236 5.5684C99.4236 5.54263 99.5269 5.51685 99.5786 5.49107L99.5528 5.51685C99.5786 5.49107 99.4753 5.51685 99.4236 5.5684H99.4495L99.372 5.61996C99.3203 5.64574 99.2687 5.6973 99.217 5.72308C99.1654 5.74885 98.9846 5.85197 99.0621 5.80041C99.0104 5.82619 98.9588 5.87775 98.9071 5.90353L98.9846 5.85197C98.933 5.87775 98.8813 5.90353 98.8297 5.92931C98.7006 6.00664 98.5972 6.08398 98.4681 6.16131C98.4423 6.18709 98.4165 6.18709 98.3907 6.21287C98.3648 6.21287 98.3648 6.23865 98.339 6.23865C98.339 6.23865 98.339 6.23865 98.3648 6.23865C98.339 6.26443 98.3132 6.26443 98.2874 6.29021C98.2615 6.29021 98.2874 6.26443 98.2099 6.31599C98.1841 6.31599 98.1324 6.34176 98.1066 6.36754C98.1066 6.36754 98.0808 6.36754 98.0549 6.39332C98.0291 6.4191 97.9775 6.44488 97.9775 6.44488C97.9516 6.47066 97.8742 6.52222 97.9 6.52222C97.9516 6.47066 98.0033 6.44488 98.0808 6.4191H98.1066C98.1066 6.4191 98.1324 6.4191 98.1324 6.39332C98.1582 6.36754 98.2099 6.34177 98.2357 6.31599C98.2357 6.31599 98.2099 6.36754 98.1841 6.36754C98.1841 6.36754 98.3648 6.26443 98.3132 6.31599C98.2099 6.39332 98.1582 6.36754 98.0808 6.44488C98.1324 6.4191 98.1582 6.39332 98.2357 6.36754L98.1582 6.4191L98.1066 6.44488C98.0033 6.52222 97.9775 6.49644 97.8742 6.57377C97.9258 6.52222 97.8483 6.57377 97.8742 6.52222V6.49644C97.8742 6.49644 97.7192 6.57377 97.745 6.57377C97.7709 6.548 97.8225 6.52222 97.8742 6.49644C97.8225 6.52222 97.7967 6.54799 97.8225 6.54799C97.9775 6.47066 97.8483 6.548 97.9775 6.47066C97.9516 6.49644 98.0291 6.47066 97.9516 6.52222C97.8742 6.57377 97.9516 6.49644 97.8742 6.54799C97.8225 6.57377 97.8225 6.57377 97.7709 6.59955C97.7192 6.65111 97.6934 6.62533 97.6676 6.67689C97.6676 6.65111 97.6159 6.67689 97.5901 6.70267C97.6418 6.65111 97.6934 6.62533 97.745 6.57377C97.7709 6.57377 97.7451 6.57377 97.7967 6.57377L97.7192 6.62533L97.7709 6.59955L97.8225 6.54799C97.745 6.59955 97.7709 6.548 97.7192 6.57377C97.6418 6.62533 97.6676 6.59955 97.6159 6.65111C97.6159 6.65111 97.4868 6.75422 97.4093 6.80578L97.4352 6.78C97.5126 6.75422 97.4093 6.80578 97.4093 6.83156L97.3577 6.85734C97.306 6.88312 97.2802 6.88312 97.2286 6.93467C97.2286 6.93467 97.2802 6.93467 97.2544 6.93467C97.2286 6.98623 97.1769 7.01201 97.1511 7.03779C97.1253 7.03779 97.1253 7.06357 97.0994 7.06357L97.0478 7.11513C97.0994 7.08935 97.1253 7.03779 97.1769 7.03779C97.2027 7.01201 97.2544 6.98623 97.2802 6.98623C97.2286 7.01201 97.2027 7.03779 97.1511 7.06357H97.2027H97.1769C97.2544 7.01201 97.306 6.98623 97.3835 6.93467C97.461 6.9089 97.5126 6.83156 97.6159 6.80578H97.5901L97.8483 6.67689C97.8483 6.67689 97.8742 6.67689 97.9 6.65111L98.0291 6.57377L98.0033 6.59955C97.9775 6.59955 97.9 6.67689 97.9 6.65111C97.8742 6.67689 97.7967 6.72845 97.7709 6.72845C97.8225 6.67689 97.7192 6.72845 97.7192 6.72845L97.6418 6.78C97.6418 6.78 97.6676 6.75422 97.6934 6.75422C97.7709 6.72845 97.6159 6.83156 97.6676 6.78C97.5901 6.83156 97.461 6.9089 97.3577 6.96045L97.4093 6.93467C97.3835 6.96045 97.2802 7.01201 97.2802 7.03779C97.306 7.01201 97.3577 6.98623 97.3835 6.96045C97.3835 6.96045 97.306 7.01201 97.306 7.03779L97.2286 7.06357C97.1511 7.11513 97.0994 7.14091 97.022 7.21824C97.0994 7.19246 97.1511 7.14091 97.2027 7.08935C97.2544 7.06357 97.1769 7.11513 97.2286 7.08935C97.2027 7.11513 97.1769 7.11513 97.1511 7.1409H97.1253C97.1511 7.11513 97.2027 7.11513 97.2286 7.08935C97.2802 7.06357 97.306 7.03779 97.3577 7.01201H97.3319C97.3835 6.96045 97.4352 6.93467 97.4868 6.9089C97.4868 6.9089 97.461 6.93467 97.4352 6.93467C97.4352 6.93467 97.4868 6.9089 97.5126 6.9089C97.461 6.93467 97.5126 6.9089 97.4868 6.93467C97.5126 6.9089 97.5643 6.88312 97.5901 6.85734C97.5901 6.83156 97.5643 6.85734 97.5643 6.85734C97.6159 6.83156 97.6159 6.80578 97.6676 6.78C97.5901 6.83156 97.6934 6.78 97.745 6.78C97.7709 6.78 97.7967 6.75422 97.8225 6.72845C97.7967 6.75422 97.745 6.78 97.745 6.75422C97.7709 6.75422 97.7967 6.72845 97.8225 6.70267H97.7967L97.9 6.62533C97.9258 6.62533 97.9516 6.62533 97.9775 6.62533C98.0033 6.59955 98.0291 6.57377 98.0549 6.57377C98.1066 6.52222 98.1582 6.49644 98.2099 6.47066C98.2357 6.44488 97.9516 6.59955 98.1841 6.44488C98.2615 6.39332 98.2615 6.4191 98.3132 6.39332C98.339 6.39332 98.3648 6.36754 98.3907 6.34177C98.3648 6.36754 98.339 6.36754 98.3132 6.39332C98.339 6.39332 98.3907 6.34177 98.4423 6.31599C98.3907 6.31599 98.5198 6.26443 98.4681 6.26443C98.5456 6.21287 98.5973 6.18709 98.6747 6.13553C98.7264 6.08398 98.778 6.08398 98.8555 6.00664C98.8555 6.00664 98.8297 6.03242 98.8038 6.03242C98.7522 6.0582 98.8813 5.98086 98.8038 6.00664L98.7522 6.03242L98.8297 5.98086H98.8038L98.9071 5.90353C99.0363 5.82619 99.1912 5.74885 99.2945 5.67152C99.3462 5.67152 99.5786 5.51685 99.6819 5.49107C99.656 5.49107 99.6302 5.49107 99.6302 5.49107C99.6044 5.49107 99.5527 5.51685 99.5269 5.54262C99.5269 5.54262 99.4753 5.59418 99.5011 5.5684C99.372 5.64574 99.5011 5.54263 99.4753 5.5684C99.6302 5.49107 99.7077 5.46529 99.811 5.41373L99.8885 5.38795C99.8368 5.41373 99.8626 5.43951 99.9143 5.38795C99.9659 5.3364 100.043 5.31062 100.095 5.28484H100.147C100.173 5.28484 100.198 5.23328 100.224 5.2075C100.302 5.15594 100.379 5.13017 100.457 5.10439C100.482 5.07861 100.637 5.00127 100.534 5.02705C100.637 4.97549 100.637 5.02705 100.766 4.92394C100.766 4.92394 100.792 4.92394 100.792 4.89816L100.844 4.87238L100.973 4.82082L101.025 4.79504L101.102 4.76926C101.102 4.76926 101.128 4.76926 101.128 4.74348L101.154 4.71771C101.154 4.71771 101.18 4.69193 101.206 4.66615C101.154 4.69193 101.231 4.66615 101.257 4.66615C101.283 4.66615 101.283 4.66615 101.309 4.64037C101.283 4.64037 101.257 4.66615 101.257 4.64037C101.257 4.64037 101.283 4.64037 101.309 4.61459H101.283L101.36 4.56303C101.386 4.56303 101.283 4.61459 101.36 4.58881C101.36 4.58881 101.36 4.58881 101.386 4.53726H101.412C101.412 4.53726 101.438 4.51148 101.464 4.51148C101.464 4.51148 101.49 4.4857 101.515 4.4857C101.567 4.45992 101.645 4.43414 101.696 4.40836C101.696 4.40836 101.722 4.40836 101.722 4.38258C101.748 4.38258 101.799 4.3568 101.825 4.33103C101.825 4.33103 101.799 4.33103 101.748 4.3568L101.774 4.33103C101.825 4.30525 101.877 4.27947 101.929 4.27947C102.006 4.25369 102.058 4.22791 102.135 4.20213H102.084C102.161 4.15057 102.238 4.1248 102.342 4.07324C102.316 4.07324 102.29 4.09902 102.264 4.09902C102.316 4.07324 102.393 4.04746 102.445 4.02168L102.574 3.97012C102.574 3.97012 102.652 3.91857 102.6 3.94434C102.652 3.91857 102.729 3.89279 102.781 3.86701C102.858 3.81545 102.703 3.89279 102.677 3.89279C102.781 3.84123 102.884 3.78967 102.987 3.76389C102.962 3.76389 102.962 3.78967 102.962 3.78967C102.987 3.78967 103.013 3.76389 103.039 3.73812H103.065C103.091 3.71234 103.117 3.71234 103.065 3.73812C103.117 3.73812 103.168 3.71234 103.22 3.68656C103.142 3.71234 103.065 3.76389 103.013 3.76389C103.168 3.68656 103.168 3.68656 103.349 3.58344C103.426 3.55766 103.375 3.58344 103.401 3.58344C103.349 3.58344 103.323 3.635 103.271 3.66078H103.297L103.349 3.635H103.375C103.375 3.635 103.426 3.58344 103.478 3.55766C103.426 3.58344 103.452 3.58344 103.426 3.60922C103.504 3.58344 103.504 3.55766 103.581 3.53189C103.581 3.53189 103.504 3.55766 103.556 3.53189C103.633 3.50611 103.607 3.53189 103.633 3.50611C103.581 3.50611 103.607 3.50611 103.556 3.50611L103.426 3.55766L103.504 3.50611C103.426 3.53189 103.426 3.50611 103.426 3.50611C103.556 3.42877 103.53 3.48033 103.633 3.42877C103.556 3.45455 103.685 3.42877 103.633 3.42877C103.71 3.40299 103.659 3.42877 103.736 3.40299C103.762 3.40299 103.788 3.37721 103.814 3.37721C103.84 3.37721 103.788 3.42877 103.943 3.37721H103.969C104.124 3.29988 104.201 3.2741 104.356 3.22254C104.382 3.22254 104.382 3.22254 104.408 3.19676L104.485 3.17098C104.459 3.19676 104.537 3.1452 104.485 3.17098C104.485 3.17098 104.511 3.17098 104.511 3.1452C104.511 3.1452 104.485 3.1452 104.511 3.17098V3.1452H104.563C104.563 3.1452 104.588 3.14521 104.614 3.11943H104.64C104.666 3.11943 104.692 3.09365 104.718 3.09365C104.692 3.09365 104.718 3.09365 104.692 3.11943C104.692 3.11943 104.718 3.09365 104.743 3.09365C104.743 3.09365 104.743 3.06787 104.769 3.06787C104.795 3.06787 104.795 3.06787 104.795 3.04209C104.847 3.04209 104.795 3.06787 104.795 3.09365C104.847 3.09365 104.795 3.06787 104.847 3.06787C104.873 3.06787 104.847 3.09365 104.873 3.09365C104.873 3.09365 104.795 3.11943 104.795 3.1452C104.795 3.1452 104.847 3.14521 104.847 3.11943C104.873 3.11943 104.873 3.11943 104.924 3.11943C104.924 3.11943 104.924 3.11943 104.924 3.09365C104.95 3.09365 104.95 3.11943 104.976 3.11943C104.976 3.11943 104.95 3.11943 104.976 3.09365H104.95C104.95 3.09365 104.95 3.09365 104.95 3.06787C104.95 3.06787 104.976 3.06787 105.002 3.06787C104.976 3.06787 105.053 3.04209 105.028 3.04209C105.053 3.04209 105.053 3.04209 105.079 3.04209C105.053 3.06787 105.053 3.06787 105.053 3.09365H105.079C105.053 3.09365 105.079 3.09365 105.053 3.09365C105.053 3.09365 105.079 3.09365 105.105 3.09365C105.105 3.09365 105.105 3.09365 105.079 3.11943C105.079 3.11943 105.131 3.09365 105.157 3.11943C105.208 3.09365 105.234 3.09365 105.286 3.06787C105.286 3.06787 105.26 3.06787 105.234 3.06787C105.234 3.06787 105.286 3.06787 105.286 3.04209C105.286 3.04209 105.286 3.06787 105.286 3.09365C105.286 3.09365 105.337 3.06787 105.312 3.09365L105.337 3.06787C105.337 3.06787 105.337 3.06787 105.337 3.09365C105.363 3.09365 105.389 3.09365 105.415 3.09365C105.415 3.09365 105.441 3.09365 105.441 3.06787C105.441 3.06787 105.441 3.06787 105.415 3.06787C105.441 3.06787 105.441 3.06787 105.467 3.06787C105.467 3.09365 105.492 3.09365 105.544 3.06787C105.544 3.06787 105.518 3.06787 105.492 3.06787H105.518C105.518 3.06787 105.544 3.06787 105.518 3.04209C105.518 3.04209 105.544 3.04209 105.57 3.04209C105.57 3.04209 105.57 3.04209 105.57 3.06787C105.57 3.06787 105.57 3.06787 105.596 3.06787C105.596 3.06787 105.596 3.09365 105.621 3.09365C105.621 3.09365 105.57 3.09365 105.57 3.11943C105.57 3.11943 105.57 3.11943 105.544 3.11943C105.544 3.11943 105.57 3.11943 105.57 3.1452C105.596 3.1452 105.57 3.14521 105.57 3.11943C105.596 3.11943 105.621 3.11943 105.621 3.11943C105.647 3.11943 105.673 3.09365 105.699 3.09365H105.725C105.725 3.09365 105.725 3.09365 105.725 3.06787C105.751 3.06787 105.802 3.06787 105.828 3.04209C105.828 3.04209 105.828 3.06787 105.802 3.06787C105.802 3.06787 105.854 3.06787 105.828 3.04209C105.854 3.04209 105.854 3.04209 105.88 3.04209H105.854C105.906 3.04209 105.957 3.04209 106.009 3.01631C105.983 3.04209 106.035 3.01631 106.035 3.01631C106.035 3.01631 106.035 3.01631 106.06 2.99053C106.06 2.99053 106.06 2.99053 106.035 2.99053C106.035 2.99053 106.086 2.99053 106.112 2.99053H106.086C106.112 2.99053 106.138 2.99053 106.164 2.99053C106.164 2.99053 106.164 2.99053 106.164 2.96475C106.164 2.96475 106.138 2.96475 106.164 2.93898C106.19 2.93898 106.19 2.93898 106.215 2.96475C106.267 2.96475 106.319 2.96475 106.319 2.93898C106.345 2.93898 106.319 2.93898 106.319 2.96475C106.319 2.99053 106.37 2.93898 106.345 2.93898C106.37 2.93898 106.37 2.93898 106.37 2.93898C106.37 2.93898 106.37 2.93897 106.37 2.9132C106.396 2.9132 106.396 2.9132 106.396 2.93898C106.396 2.93898 106.396 2.93898 106.422 2.93898C106.448 2.93898 106.448 2.9132 106.474 2.9132C106.448 2.9132 106.448 2.93898 106.448 2.93898C106.422 2.93898 106.499 2.93898 106.525 2.93898H106.499C106.525 2.93898 106.551 2.93897 106.577 2.9132C106.603 2.9132 106.577 2.93898 106.577 2.93898C106.577 2.93898 106.603 2.9132 106.629 2.9132H106.654C106.706 2.88742 106.732 2.88742 106.784 2.88742C106.809 2.9132 106.938 2.88742 106.99 2.86164C106.99 2.86164 106.99 2.86164 107.016 2.86164C107.016 2.86164 107.016 2.86164 106.99 2.86164C107.016 2.86164 107.068 2.83586 107.093 2.86164C107.119 2.86164 107.145 2.83586 107.171 2.83586C107.248 2.81008 107.3 2.81008 107.378 2.81008C107.403 2.81008 107.403 2.81008 107.429 2.81008C107.455 2.81008 107.532 2.7843 107.584 2.7843V2.75852C107.61 2.75852 107.636 2.75852 107.636 2.75852C107.636 2.75852 107.636 2.75852 107.662 2.75852C107.662 2.75852 107.636 2.75852 107.662 2.7843C107.687 2.7843 107.687 2.7843 107.713 2.7843C107.687 2.75852 107.791 2.75852 107.817 2.75852C107.791 2.75852 107.817 2.7843 107.791 2.7843C107.791 2.7843 107.791 2.7843 107.817 2.7843C107.868 2.7843 107.868 2.7843 107.894 2.7843C107.92 2.7843 107.92 2.7843 107.946 2.75852C107.946 2.75852 107.971 2.75852 107.997 2.75852H108.023C108.023 2.75852 108.023 2.75852 108.049 2.75852C108.075 2.75852 108.023 2.75852 108.023 2.75852C108.023 2.7843 107.997 2.7843 107.997 2.81008C108.075 2.7843 108.101 2.73275 108.178 2.68119C108.204 2.68119 108.126 2.70697 108.178 2.70697C108.178 2.70697 108.152 2.70697 108.152 2.73275C108.126 2.73275 108.126 2.73275 108.126 2.73275H108.152C108.152 2.73275 108.126 2.75852 108.152 2.75852C108.152 2.75852 108.101 2.7843 108.126 2.7843C108.152 2.7843 108.178 2.7843 108.178 2.7843C108.178 2.75852 108.23 2.73275 108.23 2.70697C108.256 2.70697 108.256 2.68119 108.256 2.68119C108.281 2.68119 108.333 2.68119 108.333 2.68119C108.333 2.68119 108.307 2.68119 108.281 2.68119C108.256 2.68119 108.307 2.70697 108.281 2.73275C108.281 2.73275 108.307 2.73275 108.333 2.73275C108.333 2.70697 108.333 2.70697 108.385 2.68119C108.385 2.68119 108.385 2.68119 108.359 2.68119C108.385 2.68119 108.41 2.65541 108.436 2.65541C108.436 2.65541 108.436 2.65541 108.436 2.68119C108.436 2.70697 108.488 2.68119 108.488 2.68119C108.488 2.68119 108.462 2.68119 108.436 2.68119C108.385 2.70697 108.436 2.70697 108.41 2.73275C108.436 2.73275 108.436 2.73275 108.41 2.75852H108.436C108.436 2.75852 108.436 2.75852 108.462 2.75852C108.488 2.75852 108.488 2.75852 108.488 2.75852H108.462C108.488 2.73275 108.54 2.68119 108.565 2.70697C108.54 2.70697 108.565 2.73275 108.565 2.75852C108.54 2.75852 108.514 2.7843 108.54 2.81008C108.643 2.75852 108.617 2.68119 108.72 2.65541C108.746 2.65541 108.72 2.68119 108.746 2.68119C108.695 2.70697 108.695 2.75852 108.669 2.7843C108.72 2.7843 108.695 2.73275 108.746 2.73275C108.746 2.70697 108.798 2.68119 108.798 2.65541C108.798 2.65541 108.798 2.65541 108.824 2.65541C108.85 2.65541 108.875 2.62963 108.901 2.62963C108.901 2.65541 108.849 2.68119 108.875 2.70697C108.849 2.73275 108.849 2.73275 108.849 2.75852C108.927 2.73275 108.953 2.68119 108.927 2.65541H108.953C108.927 2.62963 109.004 2.57807 108.953 2.57807C108.979 2.57807 108.979 2.57807 108.953 2.55229C109.004 2.55229 109.03 2.50074 109.056 2.52652C109.056 2.52652 109.03 2.55229 109.056 2.55229C109.056 2.55229 109.056 2.55229 109.03 2.55229H109.056C109.082 2.55229 109.082 2.52652 109.108 2.50074C109.082 2.50074 109.108 2.50074 109.108 2.47496C109.108 2.47496 109.134 2.47496 109.159 2.47496C109.134 2.47496 109.159 2.44918 109.159 2.44918C109.159 2.44918 109.159 2.44918 109.185 2.44918C109.185 2.4234 109.211 2.37184 109.185 2.34607C109.185 2.34607 109.211 2.34606 109.211 2.32029C109.159 2.32029 109.185 2.29451 109.185 2.29451C109.211 2.29451 109.237 2.29451 109.263 2.29451C109.237 2.29451 109.263 2.26873 109.237 2.26873H109.263C109.289 2.26873 109.314 2.24295 109.34 2.26873C109.392 2.26873 109.443 2.24295 109.495 2.24295C109.495 2.24295 109.521 2.24295 109.547 2.24295C109.573 2.24295 109.624 2.21717 109.676 2.24295C109.676 2.24295 109.676 2.24295 109.676 2.21717C109.702 2.21717 109.702 2.21717 109.702 2.21717C109.702 2.21717 109.702 2.21717 109.728 2.21717C109.728 2.21717 109.702 2.21717 109.728 2.24295C109.753 2.24295 109.753 2.24295 109.753 2.24295C109.728 2.21717 109.805 2.21717 109.831 2.21717C109.831 2.21717 109.831 2.24295 109.805 2.24295C109.857 2.24295 109.831 2.24295 109.857 2.24295C109.882 2.24295 109.882 2.24295 109.908 2.24295C109.908 2.24295 109.934 2.26873 109.934 2.24295H109.96C109.96 2.24295 109.96 2.24295 109.986 2.24295C110.012 2.24295 109.96 2.24295 109.96 2.24295C109.96 2.26873 109.934 2.26873 109.934 2.29451C109.986 2.26873 110.037 2.21717 110.089 2.19139C110.115 2.19139 110.063 2.21717 110.089 2.21717C110.089 2.21717 110.063 2.21717 110.063 2.24295C110.063 2.24295 110.037 2.26873 110.063 2.26873C110.063 2.26873 110.012 2.29451 110.037 2.29451C110.037 2.29451 110.063 2.29451 110.089 2.29451C110.089 2.26873 110.141 2.26873 110.141 2.24295C110.141 2.24295 110.167 2.24295 110.167 2.21717C110.192 2.21717 110.218 2.21717 110.218 2.21717H110.192C110.192 2.21717 110.218 2.26873 110.192 2.26873C110.192 2.26873 110.192 2.26873 110.218 2.26873C110.218 2.24295 110.218 2.24295 110.244 2.21717C110.27 2.21717 110.27 2.19139 110.296 2.19139C110.296 2.19139 110.296 2.19139 110.296 2.21717C110.296 2.24295 110.321 2.21717 110.321 2.21717H110.296C110.27 2.24295 110.296 2.24295 110.27 2.26873C110.27 2.26873 110.296 2.26873 110.27 2.29451H110.296C110.321 2.26873 110.373 2.19139 110.399 2.21717C110.399 2.21717 110.373 2.24295 110.399 2.26873C110.399 2.26873 110.347 2.29451 110.373 2.32029C110.451 2.29451 110.451 2.19139 110.528 2.16561V2.19139C110.502 2.21717 110.476 2.26873 110.451 2.29451C110.502 2.29451 110.476 2.24295 110.528 2.24295C110.528 2.21717 110.58 2.19139 110.58 2.16561C110.58 2.16561 110.58 2.16561 110.606 2.16561C110.631 2.16561 110.657 2.13984 110.657 2.13984C110.657 2.16561 110.606 2.19139 110.631 2.21717C110.606 2.21717 110.606 2.24295 110.606 2.26873C110.657 2.26873 110.683 2.19139 110.683 2.16561C110.683 2.13984 110.709 2.16561 110.709 2.16561C110.709 2.13984 110.76 2.08828 110.735 2.08828C110.76 2.08828 110.76 2.08828 110.735 2.0625C110.76 2.0625 110.786 2.03672 110.812 2.03672C110.812 2.03672 110.786 2.0625 110.812 2.0625H110.786C110.786 2.0625 110.786 2.0625 110.761 2.0625C110.786 2.0625 110.786 2.03672 110.812 2.01094C110.812 2.01094 110.812 2.01094 110.812 1.98516H110.838V1.95938C110.838 1.95938 110.838 1.95938 110.864 1.95938C110.864 1.93361 110.89 1.88205 110.864 1.85627C110.812 1.80471 110.838 1.80471 110.838 1.80471ZM108.875 2.47496C108.901 2.47496 108.953 2.47496 108.953 2.47496H108.927C108.953 2.47496 108.979 2.47496 109.004 2.47496C109.004 2.47496 108.901 2.47496 108.875 2.47496ZM108.772 2.50074C108.798 2.50074 108.772 2.50074 108.824 2.47496H108.849C108.849 2.47496 108.875 2.47496 108.849 2.50074H108.824H108.798C108.824 2.50074 108.824 2.50074 108.849 2.50074C108.824 2.50074 108.798 2.50074 108.798 2.50074C108.798 2.50074 108.824 2.50074 108.824 2.52652C108.798 2.52652 108.772 2.52652 108.772 2.55229C108.746 2.55229 108.72 2.57807 108.695 2.55229C108.695 2.55229 108.72 2.55229 108.695 2.52652C108.72 2.52652 108.72 2.52652 108.72 2.52652C108.72 2.52652 108.72 2.52652 108.746 2.50074C108.772 2.55229 108.772 2.52652 108.772 2.50074C108.772 2.52652 108.772 2.52652 108.772 2.50074ZM108.798 2.47496C108.824 2.47496 108.849 2.44918 108.875 2.47496C108.849 2.47496 108.798 2.50074 108.798 2.47496ZM108.772 2.47496H108.798C108.772 2.47496 108.746 2.50074 108.72 2.47496C108.72 2.50074 108.746 2.47496 108.772 2.47496ZM101.851 3.91857C101.825 3.91857 101.825 3.91857 101.851 3.91857C101.825 3.91857 101.825 3.91857 101.825 3.91857H101.799C101.825 3.91857 101.851 3.89279 101.851 3.91857ZM102.006 3.86701C101.98 3.86701 101.954 3.89279 101.929 3.86701C101.954 3.86701 101.954 3.86701 102.006 3.86701ZM101.722 3.635C101.722 3.635 101.722 3.58344 101.774 3.58344C101.722 3.60922 101.748 3.60922 101.722 3.635ZM101.619 3.66078C101.593 3.68656 101.593 3.66078 101.567 3.66078H101.619ZM101.954 3.53189C101.954 3.53189 102.006 3.53189 101.98 3.50611C102.006 3.50611 102.032 3.48033 102.032 3.48033L102.006 3.50611C102.006 3.50611 102.006 3.50611 102.032 3.50611C102.032 3.50611 102.058 3.48033 102.058 3.50611C102.032 3.48033 101.954 3.53189 101.954 3.53189ZM104.149 2.65541C104.124 2.65541 104.098 2.65541 104.098 2.65541C104.124 2.65541 104.149 2.65541 104.149 2.65541ZM105.286 1.88205C105.26 1.88205 105.26 1.88205 105.286 1.88205V1.88205ZM105.699 1.72738H105.673C105.673 1.72738 105.673 1.72738 105.699 1.72738ZM109.366 1.05713C109.34 1.05713 109.34 1.05713 109.366 1.05713V1.05713ZM110.683 1.39225C110.683 1.41803 110.709 1.39225 110.709 1.39225C110.683 1.41803 110.631 1.39225 110.683 1.39225ZM103.71 2.39762C103.71 2.37184 103.71 2.37184 103.71 2.39762C103.736 2.34606 103.762 2.37184 103.762 2.37184C103.788 2.34607 103.762 2.37184 103.71 2.39762ZM103.995 2.26873C103.943 2.26873 103.891 2.32029 103.891 2.29451L103.865 2.32029C103.84 2.32029 103.865 2.34606 103.917 2.32029C103.917 2.32029 103.917 2.32029 103.943 2.32029H103.917C103.891 2.32029 103.891 2.32029 103.865 2.32029C103.84 2.32029 103.814 2.29451 103.788 2.29451C103.814 2.29451 103.84 2.26873 103.865 2.26873C103.865 2.26873 103.865 2.26873 103.891 2.26873C103.917 2.26873 103.917 2.26873 103.943 2.26873C103.943 2.26873 103.943 2.26873 103.995 2.26873C103.995 2.26873 103.969 2.26873 103.943 2.26873C103.969 2.29451 103.995 2.26873 103.995 2.26873ZM105.776 2.08828C105.776 2.08828 105.802 2.08828 105.828 2.08828C105.828 2.08828 105.802 2.08828 105.776 2.08828C105.802 2.08828 105.751 2.11406 105.776 2.08828ZM103.633 2.96475C103.633 2.99053 103.633 2.99053 103.633 2.96475C103.607 2.99053 103.607 2.96475 103.581 2.99053C103.581 2.99053 103.607 2.96475 103.556 2.99053C103.556 2.99053 103.581 2.99053 103.581 2.96475C103.607 2.96475 103.607 3.01631 103.633 2.96475ZM103.556 2.93898C103.556 2.96475 103.556 2.96475 103.556 2.93898L103.53 2.96475C103.53 2.96475 103.53 2.96475 103.504 2.96475C103.478 2.96475 103.478 2.96475 103.478 2.96475H103.504C103.504 2.99053 103.556 2.93898 103.581 2.93898C103.556 2.93898 103.556 2.93898 103.556 2.93898ZM103.22 3.09365C103.194 3.11943 103.142 3.11943 103.142 3.1452C103.142 3.1452 103.142 3.1452 103.168 3.1452C103.168 3.1452 103.168 3.1452 103.168 3.17098C103.168 3.19676 103.168 3.17098 103.142 3.17098C103.168 3.17098 103.142 3.17098 103.142 3.1452C103.168 3.1452 103.194 3.09365 103.22 3.09365ZM102.135 3.60922C102.135 3.60922 102.109 3.60922 102.084 3.60922C102.109 3.60922 102.109 3.60922 102.135 3.60922ZM101.851 3.71234C101.825 3.73812 101.825 3.73812 101.825 3.73812C101.825 3.71234 101.825 3.71234 101.851 3.71234ZM102.264 3.71234C102.316 3.68656 102.316 3.66078 102.264 3.68656C102.29 3.68656 102.316 3.66078 102.342 3.66078C102.342 3.66078 102.368 3.66078 102.393 3.66078C102.393 3.66078 102.393 3.66078 102.419 3.635H102.445H102.471H102.419H102.342C102.368 3.58344 102.419 3.60922 102.419 3.58344C102.445 3.58344 102.471 3.58344 102.497 3.55766C102.523 3.55766 102.548 3.53189 102.574 3.53189L102.6 3.50611C102.574 3.50611 102.523 3.50611 102.497 3.53189C102.523 3.53189 102.548 3.50611 102.574 3.50611C102.574 3.50611 102.574 3.50611 102.6 3.50611C102.626 3.50611 102.626 3.50611 102.626 3.48033C102.626 3.48033 102.626 3.48033 102.652 3.48033H102.677C102.652 3.48033 102.626 3.50611 102.6 3.50611H102.626C102.626 3.50611 102.626 3.50611 102.626 3.53189C102.652 3.50611 102.703 3.50611 102.755 3.48033C102.729 3.48033 102.729 3.48033 102.755 3.48033C102.781 3.48033 102.781 3.48033 102.832 3.45455C102.858 3.45455 102.832 3.48033 102.858 3.45455C102.858 3.45455 102.858 3.45455 102.884 3.42877H102.91C102.936 3.42877 102.936 3.42877 102.936 3.42877C102.962 3.42877 102.936 3.40299 102.962 3.42877C102.987 3.40299 102.936 3.42877 102.987 3.40299C103.039 3.37721 103.013 3.40299 103.039 3.40299C103.065 3.40299 103.065 3.42877 103.065 3.42877L103.039 3.45455H103.013C102.987 3.45455 102.987 3.45455 102.962 3.45455C102.987 3.45455 102.962 3.45455 102.962 3.48033H102.987L102.884 3.53189C102.858 3.55766 102.987 3.50611 102.987 3.50611L103.065 3.48033C103.065 3.48033 102.91 3.55766 102.987 3.50611L103.065 3.48033C103.142 3.45455 103.117 3.45455 103.142 3.45455C103.142 3.45455 103.142 3.45455 103.168 3.45455C103.168 3.45455 103.168 3.45455 103.142 3.45455C103.142 3.45455 103.142 3.45455 103.168 3.45455C103.117 3.45455 103.091 3.48033 103.065 3.50611C103.091 3.50611 103.117 3.48033 103.142 3.48033L102.936 3.58344L103.013 3.53189C102.987 3.55766 102.936 3.55766 102.91 3.58344H102.884H102.858L102.91 3.55766H102.884C102.884 3.55766 102.91 3.55766 102.91 3.53189H102.884C102.884 3.53189 102.884 3.53189 102.858 3.53189L102.677 3.60922H102.703C102.652 3.635 102.652 3.60922 102.6 3.635H102.574H102.548C102.548 3.635 102.548 3.635 102.574 3.635L102.729 3.60922C102.703 3.60922 102.729 3.58344 102.781 3.55766H102.755C102.781 3.55766 102.807 3.55766 102.832 3.53189C102.832 3.53189 102.832 3.53189 102.832 3.55766L102.781 3.58344H102.755L102.703 3.60922H102.677C102.652 3.60922 102.626 3.60922 102.6 3.635C102.6 3.635 102.574 3.635 102.548 3.635L102.497 3.66078C102.471 3.66078 102.419 3.68656 102.419 3.68656C102.419 3.68656 102.393 3.68656 102.368 3.68656C102.368 3.68656 102.393 3.68656 102.419 3.68656C102.445 3.68656 102.445 3.68656 102.445 3.68656L102.419 3.71234C102.419 3.71234 102.393 3.71234 102.393 3.73812H102.368C102.368 3.73812 102.419 3.73812 102.419 3.71234C102.393 3.73812 102.393 3.71234 102.393 3.71234C102.393 3.71234 102.419 3.71234 102.368 3.73812C102.264 3.71234 102.264 3.71234 102.264 3.71234ZM101.774 4.15057C101.748 4.15057 101.748 4.15057 101.774 4.15057C101.774 4.1248 101.774 4.15057 101.799 4.15057C101.825 4.15057 101.799 4.15057 101.774 4.15057C101.799 4.15057 101.825 4.15057 101.851 4.1248L101.774 4.15057ZM101.154 4.53726L101.18 4.51148C101.231 4.4857 101.231 4.4857 101.231 4.51148L101.154 4.53726C101.18 4.53726 101.18 4.53726 101.154 4.53726ZM100.612 4.92394L100.56 4.97549H100.508C100.56 4.94971 100.586 4.92394 100.663 4.89816C100.586 4.94971 100.689 4.89816 100.689 4.89816C100.663 4.92394 100.612 4.92394 100.663 4.89816L100.689 4.87238C100.741 4.8466 100.766 4.82082 100.818 4.79504C100.818 4.82082 100.766 4.8466 100.741 4.87238H100.715L100.689 4.89816C100.663 4.89816 100.663 4.92394 100.637 4.92394C100.663 4.92394 100.612 4.94972 100.612 4.92394C100.663 4.89816 100.637 4.92394 100.612 4.92394ZM100.637 4.94971L100.612 4.97549C100.689 4.94971 100.741 4.92394 100.792 4.89816C100.792 4.89816 100.792 4.89816 100.818 4.89816C100.818 4.89816 100.818 4.89816 100.844 4.89816C100.896 4.87238 100.87 4.87238 100.87 4.87238C100.896 4.87238 100.921 4.8466 100.947 4.8466C100.921 4.87238 100.896 4.87238 100.87 4.89816H100.896C100.921 4.87238 100.973 4.87238 101.025 4.82082C101.051 4.82082 100.973 4.8466 100.921 4.87238H100.973C100.999 4.8466 101.051 4.82082 101.076 4.82082C101.102 4.79504 101.128 4.76926 101.154 4.74348C101.154 4.74348 101.18 4.74348 101.18 4.71771C101.154 4.74348 101.102 4.76926 101.128 4.76926H101.102C101.102 4.76926 101.076 4.76926 101.076 4.79504L101.051 4.82082H101.025C100.999 4.82082 100.973 4.8466 100.947 4.8466L100.973 4.82082C100.947 4.82082 100.921 4.8466 100.896 4.87238C100.87 4.89816 100.844 4.89816 100.844 4.87238C100.792 4.89816 100.766 4.92394 100.715 4.94971C100.689 4.94971 100.715 4.92394 100.637 4.97549C100.56 5.05283 100.457 5.10439 100.353 5.13017L100.302 5.15594C100.302 5.15594 100.405 5.10439 100.379 5.10439L100.327 5.13017C100.302 5.13017 100.327 5.13017 100.353 5.10439C100.379 5.10439 100.353 5.10439 100.405 5.07861C100.405 5.07861 100.405 5.07861 100.431 5.05283H100.457C100.457 5.05283 100.431 5.07861 100.405 5.07861C100.405 5.07861 100.431 5.07861 100.457 5.05283H100.431C100.431 5.05283 100.457 5.02705 100.482 5.00127C100.612 4.97549 100.637 4.94971 100.637 4.94971ZM100.818 4.94971C100.818 4.94971 100.818 4.92394 100.87 4.92394H100.896C100.87 4.92394 100.844 4.92394 100.818 4.94971ZM101.102 4.82082C101.076 4.8466 101.051 4.8466 101.025 4.87238C101.051 4.8466 101.076 4.82082 101.102 4.82082C101.102 4.82082 101.102 4.82082 101.076 4.82082H101.102ZM100.921 4.87238L100.947 4.8466C100.947 4.8466 100.947 4.87238 100.921 4.87238ZM104.072 3.37721C104.098 3.37721 104.098 3.37721 104.098 3.37721C104.098 3.40299 104.098 3.37721 104.072 3.37721ZM103.917 2.34607C103.943 2.34607 103.969 2.34607 103.995 2.34607H104.02C104.02 2.34607 104.046 2.34607 104.072 2.34607H104.098L103.995 2.39762C103.969 2.39762 103.995 2.39762 103.943 2.39762C103.917 2.34606 103.917 2.34607 103.917 2.34607ZM105.983 2.03672C105.957 2.03672 105.957 2.03672 105.957 2.03672C105.931 2.01094 105.957 2.03672 105.983 2.03672ZM105.983 2.03672L106.035 2.01094C106.06 2.01094 106.06 2.01094 106.112 1.98516L106.06 2.01094C106.06 2.01094 106.086 2.01094 106.06 1.98516C106.035 2.01094 106.035 2.01094 105.983 2.03672ZM103.039 3.2741C103.039 3.2741 103.013 3.2741 102.987 3.2741H103.039ZM102.962 3.29988L102.91 3.32566C102.936 3.32566 102.962 3.29988 102.962 3.29988ZM102.677 3.48033C102.677 3.45455 102.703 3.45455 102.677 3.48033C102.703 3.48033 102.703 3.48033 102.729 3.48033C102.729 3.45455 102.729 3.48033 102.677 3.48033C102.677 3.50611 102.652 3.53189 102.626 3.53189L102.677 3.48033ZM102.858 3.40299C102.832 3.40299 102.832 3.42877 102.858 3.40299V3.40299ZM102.884 3.37721L102.832 3.40299C102.858 3.40299 102.884 3.37721 102.91 3.37721C102.884 3.37721 102.858 3.37721 102.832 3.40299C102.858 3.37721 102.884 3.35143 102.884 3.37721ZM102.807 3.40299C102.807 3.40299 102.781 3.40299 102.781 3.42877L102.807 3.40299ZM102.987 3.35143C102.962 3.35143 102.936 3.37721 102.91 3.37721L102.962 3.35143H102.936C102.962 3.35143 102.962 3.32566 102.962 3.32566C102.987 3.32566 102.987 3.32566 103.013 3.29988C102.987 3.32566 102.962 3.35143 102.987 3.35143ZM103.013 3.29988C103.013 3.32566 103.065 3.29988 103.013 3.29988L102.962 3.32566C102.987 3.32566 103.013 3.32566 103.013 3.29988ZM103.039 3.37721L103.013 3.40299C103.013 3.40299 103.013 3.40299 103.039 3.37721ZM103.168 3.35143C103.142 3.35143 103.142 3.37721 103.117 3.37721C103.117 3.37721 103.142 3.35143 103.168 3.35143ZM102.213 3.78967C102.187 3.76389 102.187 3.78967 102.213 3.78967V3.78967ZM101.799 4.1248C101.825 4.09902 101.877 4.07324 101.903 4.07324C101.851 4.09902 101.903 4.07324 101.851 4.09902C101.825 4.1248 101.799 4.15057 101.799 4.1248ZM100.792 4.87238C100.792 4.87238 100.818 4.8466 100.844 4.8466C100.844 4.8466 100.818 4.8466 100.792 4.87238ZM104.304 3.35143C104.304 3.32566 104.304 3.32566 104.304 3.35143V3.35143ZM104.149 2.26873C104.149 2.29451 104.124 2.29451 104.098 2.29451L104.149 2.26873ZM103.736 2.50074C103.71 2.52652 103.685 2.52652 103.659 2.52652L103.736 2.50074ZM105.57 2.08828C105.57 2.11406 105.596 2.08828 105.621 2.08828H105.596C105.621 2.08828 105.621 2.08828 105.621 2.08828H105.596C105.621 2.11406 105.596 2.11406 105.57 2.08828ZM106.138 1.98516H106.112C106.112 1.98516 106.138 1.98516 106.164 1.95938L106.138 1.98516C106.112 1.98516 106.112 1.98516 106.112 1.98516C106.112 1.95938 106.138 1.98516 106.138 1.98516ZM106.887 1.65004C106.887 1.67582 106.887 1.67582 106.887 1.65004C106.861 1.65004 106.861 1.65004 106.861 1.65004H106.887ZM106.319 1.75315C106.293 1.75315 106.319 1.77893 106.319 1.75315V1.75315ZM106.293 1.75315C106.293 1.77893 106.293 1.77893 106.293 1.75315C106.293 1.77893 106.293 1.80471 106.293 1.80471V1.83049H106.241C106.241 1.83049 106.241 1.83049 106.215 1.83049H106.19C106.19 1.83049 106.19 1.83049 106.215 1.83049C106.241 1.83049 106.164 1.83049 106.164 1.83049C106.19 1.83049 106.215 1.83049 106.215 1.83049C106.215 1.83049 106.241 1.83049 106.267 1.83049H106.241C106.241 1.83049 106.267 1.83049 106.267 1.80471C106.267 1.80471 106.241 1.80471 106.215 1.80471C106.241 1.77893 106.241 1.77893 106.293 1.75315ZM104.201 2.24295L104.175 2.26873C104.201 2.24295 104.201 2.21717 104.201 2.24295ZM104.279 2.24295C104.279 2.24295 104.253 2.24295 104.227 2.24295H104.279ZM103.84 2.44918C103.865 2.44918 103.865 2.44918 103.891 2.44918H103.865H103.84C103.865 2.44918 103.865 2.44918 103.84 2.44918ZM102.161 3.94434C102.161 3.94434 102.135 3.97012 102.109 3.97012L102.161 3.94434ZM102.006 4.02168C101.98 4.04746 101.98 4.07324 102.006 4.02168V4.02168ZM102.058 3.9959C102.084 3.9959 102.084 3.9959 102.084 3.9959H102.058C102.032 4.02168 102.032 4.02168 102.058 3.9959C102.084 3.9959 102.032 4.02168 102.058 3.9959ZM101.851 4.30525L101.929 4.25369H101.954C101.954 4.25369 101.954 4.25369 101.98 4.25369C101.98 4.25369 101.98 4.25369 101.954 4.27947C101.929 4.27947 101.929 4.27947 101.903 4.30525H101.851C101.877 4.30525 101.877 4.30525 101.851 4.30525ZM106.784 1.62426C106.784 1.65004 106.784 1.65004 106.784 1.62426V1.62426ZM106.112 1.80471H106.19C106.164 1.80471 106.164 1.80471 106.112 1.80471C106.164 1.80471 106.138 1.83049 106.112 1.85627H106.138C106.112 1.85627 106.06 1.88205 106.06 1.85627H106.035C106.06 1.83049 106.112 1.83049 106.138 1.83049L106.112 1.80471ZM105.441 1.95938C105.467 1.95938 105.467 1.95938 105.441 1.95938V1.95938ZM106.939 1.65004C106.964 1.65004 106.964 1.65004 106.964 1.65004C106.964 1.65004 106.939 1.67582 106.939 1.65004C106.964 1.65004 106.964 1.65004 106.939 1.65004ZM106.706 1.72738H106.654C106.654 1.72738 106.68 1.72738 106.706 1.72738ZM106.603 1.75315C106.603 1.75315 106.577 1.75315 106.551 1.75315H106.525C106.525 1.75315 106.525 1.75315 106.551 1.75315C106.525 1.77893 106.603 1.72738 106.603 1.75315ZM105.596 1.95938C105.621 1.95938 105.673 1.93361 105.699 1.93361C105.725 1.93361 105.776 1.93361 105.802 1.93361H105.776H105.751H105.725H105.699H105.673L105.596 1.95938H105.57L105.621 1.93361C105.647 1.93361 105.621 1.90783 105.647 1.90783C105.725 1.93361 105.725 1.90783 105.596 1.95938ZM105.854 1.88205H105.828C105.854 1.88205 105.854 1.88205 105.854 1.88205ZM106.112 1.83049H106.086C106.06 1.83049 106.086 1.83049 106.112 1.83049ZM102.703 3.71234C102.703 3.68656 102.729 3.68656 102.703 3.71234V3.71234ZM103.995 3.09365C103.995 3.09365 103.917 3.11943 103.943 3.09365C103.969 3.11943 103.995 3.09365 103.995 3.09365ZM103.013 3.635L103.065 3.60922C103.039 3.635 103.013 3.635 103.013 3.635ZM102.574 3.78967L102.548 3.81545C102.548 3.78967 102.548 3.78967 102.574 3.78967ZM102.6 3.73812C102.574 3.76389 102.6 3.76389 102.6 3.73812V3.73812ZM106.654 1.83049C106.654 1.80471 106.68 1.80471 106.654 1.83049V1.83049ZM102.832 3.81545L102.858 3.78967C102.858 3.81545 102.832 3.81545 102.832 3.81545ZM106.293 1.95938C106.319 1.95938 106.319 1.95938 106.293 1.95938V1.95938ZM105.492 1.98516L105.544 1.95938C105.544 1.95938 105.544 1.95938 105.518 1.95938L105.492 1.98516ZM105.931 1.85627C105.931 1.85627 105.957 1.85627 105.983 1.85627H106.009C105.983 1.85627 105.983 1.85627 105.957 1.88205L105.931 1.85627ZM106.035 1.80471C106.06 1.83049 106.06 1.83049 106.035 1.80471C106.009 1.83049 106.035 1.83049 106.035 1.80471ZM106.19 1.80471H106.164C106.19 1.80471 106.19 1.80471 106.19 1.80471ZM106.267 1.80471C106.241 1.80471 106.241 1.80471 106.267 1.80471V1.80471ZM106.732 1.7016C106.732 1.72738 106.758 1.72738 106.732 1.7016C106.706 1.72738 106.732 1.72738 106.732 1.7016ZM106.809 1.67582C106.835 1.67582 106.835 1.67582 106.835 1.67582C106.835 1.7016 106.835 1.7016 106.809 1.67582ZM107.223 1.5727C107.197 1.5727 107.197 1.5727 107.223 1.5727V1.5727ZM103.039 3.76389L103.065 3.73812H103.091L103.039 3.76389ZM102.058 4.04746H102.032C102.032 4.04746 102.032 4.04746 102.058 4.04746ZM106.241 1.93361C106.241 1.90783 106.241 1.90783 106.241 1.93361V1.93361ZM105.518 2.11406H105.492C105.492 2.11406 105.518 2.08828 105.518 2.11406ZM103.943 2.4234C103.943 2.44918 103.943 2.44918 103.943 2.4234V2.4234ZM104.434 2.26873C104.408 2.26873 104.408 2.29451 104.382 2.26873H104.434ZM103.917 2.4234H103.969V2.44918C103.943 2.4234 103.917 2.4234 103.917 2.4234C103.917 2.44918 103.917 2.44918 103.917 2.4234ZM105.88 1.83049C105.88 1.83049 105.906 1.83049 105.931 1.83049C105.931 1.83049 105.906 1.83049 105.88 1.83049ZM101.36 4.45992C101.36 4.43414 101.386 4.40836 101.412 4.40836H101.438C101.438 4.40836 101.438 4.40836 101.464 4.40836L101.541 4.38258C101.515 4.38258 101.464 4.40836 101.464 4.40836C101.438 4.40836 101.412 4.43414 101.412 4.43414H101.438C101.412 4.43414 101.386 4.43414 101.36 4.45992ZM101.903 4.07324C101.929 4.07324 101.929 4.07324 101.903 4.07324V4.07324ZM103.168 3.32566C103.194 3.32566 103.194 3.32566 103.168 3.32566V3.32566ZM103.607 3.04209C103.633 3.04209 103.685 3.01631 103.71 3.01631L103.659 3.04209C103.633 3.01631 103.607 3.04209 103.607 3.04209ZM105.983 2.0625C106.009 2.0625 106.009 2.0625 105.983 2.0625V2.0625ZM106.06 2.03672C106.035 2.03672 106.035 2.0625 106.06 2.03672V2.03672ZM106.164 1.98516C106.164 1.98516 106.19 1.95938 106.19 1.98516H106.164ZM106.112 1.95938C106.086 1.95938 106.086 1.95938 106.06 1.95938C106.112 1.95938 106.138 1.95938 106.19 1.95938C106.19 1.95938 106.164 1.98516 106.138 1.98516H106.19C106.215 1.98516 106.267 1.98516 106.241 2.01094C106.241 2.01094 106.241 2.01094 106.241 1.98516C106.164 1.95938 106.138 1.93361 106.112 1.95938ZM105.751 2.08828C105.725 2.08828 105.725 2.08828 105.699 2.08828C105.699 2.08828 105.725 2.08828 105.751 2.08828ZM105.725 2.0625C105.699 2.08828 105.673 2.0625 105.647 2.08828C105.647 2.0625 105.673 2.03672 105.725 2.0625C105.699 2.03672 105.699 2.03672 105.699 2.03672C105.699 2.03672 105.725 2.03672 105.751 2.0625H105.725ZM104.098 2.32029L104.175 2.29451H104.149C104.149 2.29451 104.149 2.29451 104.124 2.29451C104.124 2.29451 104.098 2.29451 104.098 2.32029ZM104.33 2.21717C104.304 2.21717 104.279 2.24295 104.279 2.24295C104.304 2.24295 104.33 2.24295 104.33 2.21717ZM105.002 2.0625C105.002 2.0625 105.028 2.0625 105.053 2.0625C105.002 2.08828 104.976 2.11406 105.002 2.11406H104.976H104.898H104.924C104.95 2.11406 104.95 2.11406 104.976 2.08828L105.002 2.0625ZM106.887 1.62426C106.913 1.62426 106.913 1.62426 106.939 1.62426C106.913 1.62426 106.887 1.62426 106.887 1.62426C106.887 1.65004 106.861 1.65004 106.887 1.62426ZM107.016 1.5727C107.042 1.5727 107.042 1.5727 107.016 1.5727C107.016 1.59848 107.042 1.5727 107.016 1.5727ZM103.323 3.66078C103.297 3.66078 103.22 3.68656 103.194 3.68656L103.297 3.66078H103.323C103.375 3.635 103.401 3.635 103.426 3.60922C103.452 3.635 103.349 3.66078 103.323 3.66078ZM102.393 4.04746C102.393 4.07324 102.393 4.07324 102.393 4.04746L102.368 4.07324C102.342 4.07324 102.393 4.07324 102.393 4.04746ZM101.877 4.33103C101.851 4.33103 101.851 4.33103 101.825 4.33103H101.877C101.903 4.30525 101.877 4.30525 101.877 4.33103ZM101.283 4.4857L101.309 4.45992L101.335 4.43414H101.36L101.283 4.4857ZM101.877 4.09902C101.851 4.09902 101.851 4.09902 101.851 4.09902H101.877C101.877 4.07324 101.877 4.07324 101.877 4.09902ZM103.065 3.32566C103.091 3.32566 103.117 3.32566 103.142 3.32566C103.091 3.32566 103.065 3.32566 103.065 3.32566ZM103.659 2.99053C103.685 2.99053 103.685 3.01631 103.659 2.99053C103.685 2.99053 103.685 2.99053 103.685 2.99053C103.659 3.01631 103.659 3.01631 103.659 2.99053ZM103.736 2.93898C103.736 2.96475 103.762 2.93898 103.736 2.93898C103.736 2.96475 103.736 2.96475 103.736 2.93898ZM106.035 2.03672C106.06 2.03672 106.086 2.03672 106.112 2.03672C106.06 2.03672 106.06 2.03672 106.035 2.03672ZM105.363 2.19139C105.363 2.16561 105.363 2.16561 105.363 2.19139C105.389 2.16561 105.389 2.16561 105.363 2.19139ZM105.131 2.21717C105.157 2.19139 105.157 2.19139 105.131 2.21717C105.157 2.21717 105.157 2.21717 105.131 2.21717ZM106.345 1.7016H106.319C106.319 1.7016 106.319 1.7016 106.345 1.7016ZM106.913 1.5727C106.939 1.5727 106.939 1.5727 106.913 1.5727C106.964 1.5727 106.99 1.5727 106.99 1.5727C106.99 1.5727 106.939 1.59848 106.964 1.5727C106.99 1.59848 106.939 1.59848 106.913 1.5727ZM105.828 3.01631C105.802 3.01631 105.776 3.04209 105.751 3.01631C105.802 3.01631 105.854 2.99053 105.828 3.01631ZM105.002 3.17098C104.976 3.17098 105.028 3.17098 105.002 3.17098V3.17098ZM104.149 3.37721C104.124 3.35143 104.149 3.35143 104.149 3.37721C104.149 3.32566 104.175 3.37721 104.149 3.37721ZM103.995 3.40299C103.969 3.40299 103.943 3.40299 103.943 3.40299C103.969 3.40299 103.969 3.40299 103.995 3.40299ZM102.497 4.04746C102.445 4.02168 102.471 4.04746 102.497 4.04746C102.497 4.02168 102.445 4.02168 102.445 4.04746H102.471L102.548 4.02168H102.6L102.548 4.04746C102.548 4.04746 102.574 4.04746 102.574 4.02168H102.6C102.574 4.02168 102.548 4.04746 102.497 4.04746ZM102.419 4.07324C102.445 4.07324 102.471 4.04746 102.497 4.04746L102.419 4.07324ZM102.264 4.15057C102.187 4.17635 102.135 4.20213 102.084 4.22791C102.109 4.20213 102.187 4.17635 102.264 4.15057C102.264 4.15057 102.316 4.1248 102.342 4.09902C102.316 4.15057 102.29 4.15057 102.264 4.15057ZM101.954 4.27947L101.98 4.25369C102.006 4.25369 102.032 4.22791 102.058 4.20213C102.032 4.25369 102.032 4.27947 101.954 4.27947ZM101.128 4.56303C101.128 4.56303 101.154 4.53726 101.18 4.53726L101.128 4.56303ZM102.161 3.78967C102.187 3.78967 102.187 3.78967 102.161 3.78967V3.78967ZM102.109 3.68656C102.084 3.66078 102.109 3.66078 102.109 3.68656V3.68656ZM102.006 3.71234C102.006 3.68656 102.006 3.66078 102.058 3.68656C102.032 3.68656 102.032 3.71234 102.006 3.71234ZM102.058 3.68656C102.058 3.68656 102.058 3.66078 102.084 3.66078C102.109 3.66078 102.084 3.68656 102.058 3.68656ZM101.799 3.76389C101.799 3.78967 101.825 3.78967 101.799 3.76389C101.799 3.78967 101.799 3.78967 101.799 3.76389ZM102.109 3.635C102.084 3.635 102.084 3.635 102.109 3.635V3.635ZM102.29 3.60922C102.29 3.635 102.264 3.635 102.238 3.66078C102.238 3.635 102.213 3.66078 102.187 3.66078C102.187 3.66078 102.213 3.66078 102.213 3.635C102.238 3.60922 102.264 3.635 102.29 3.60922C102.264 3.60922 102.238 3.60922 102.238 3.60922C102.264 3.58344 102.264 3.60922 102.29 3.60922ZM103.53 2.99053C103.452 3.01631 103.452 3.01631 103.53 2.99053V2.99053ZM103.375 3.04209C103.401 3.04209 103.426 3.04209 103.401 3.04209C103.401 3.04209 103.401 3.06787 103.375 3.04209ZM103.633 2.93898C103.685 2.93898 103.71 2.93898 103.71 2.93898C103.685 2.93898 103.633 2.93898 103.633 2.93898ZM103.84 2.9132C103.84 2.9132 103.865 2.9132 103.891 2.9132C103.865 2.9132 103.865 2.9132 103.84 2.9132ZM105.441 2.24295C105.441 2.24295 105.415 2.24295 105.389 2.24295C105.389 2.26873 105.415 2.24295 105.441 2.24295ZM105.596 2.21717L105.647 2.19139C105.621 2.21717 105.596 2.21717 105.596 2.21717ZM105.673 2.19139C105.699 2.19139 105.699 2.19139 105.673 2.19139V2.19139ZM105.88 2.08828C105.854 2.08828 105.828 2.08828 105.828 2.08828H105.88C105.88 2.0625 105.88 2.0625 105.88 2.0625C105.88 2.0625 105.906 2.0625 105.88 2.08828ZM105.699 2.11406C105.673 2.11406 105.647 2.11406 105.621 2.13984C105.621 2.11406 105.621 2.11406 105.699 2.11406ZM105.492 2.16561C105.518 2.13984 105.518 2.16561 105.544 2.16561C105.544 2.16561 105.544 2.16561 105.57 2.16561C105.518 2.13984 105.518 2.13984 105.492 2.16561ZM102.91 2.93898C102.91 2.93898 102.832 2.93898 102.807 2.93898H102.832H102.858H102.91C102.91 2.9132 102.858 2.93898 102.858 2.93898L102.807 2.96475H102.781C102.807 2.96475 102.858 2.93898 102.884 2.93898C102.91 2.93898 102.962 2.9132 102.987 2.88742L102.962 2.9132C102.884 2.9132 102.884 2.9132 102.91 2.93898C102.91 2.9132 102.91 2.9132 102.91 2.93898L102.987 2.9132C102.962 2.9132 102.936 2.9132 102.91 2.93898ZM104.485 2.11406C104.459 2.11406 104.459 2.11406 104.485 2.11406V2.11406ZM104.537 2.08828C104.537 2.08828 104.563 2.08828 104.614 2.08828L104.588 2.11406H104.614V2.13984H104.588C104.588 2.13984 104.563 2.13984 104.588 2.11406H104.563C104.537 2.11406 104.537 2.11406 104.537 2.08828ZM108.23 2.68119C108.204 2.68119 108.204 2.70697 108.23 2.68119V2.68119ZM108.772 2.4234C108.798 2.4234 108.798 2.44918 108.772 2.4234V2.4234ZM108.979 2.32029H109.03C109.004 2.32029 108.979 2.32029 108.979 2.32029ZM108.126 2.68119H108.152C108.101 2.68119 108.126 2.70697 108.101 2.70697C108.101 2.70697 108.126 2.70697 108.126 2.68119ZM108.953 2.29451C108.979 2.29451 108.979 2.29451 108.979 2.29451H109.004C108.979 2.29451 108.953 2.32029 108.953 2.29451C109.004 2.29451 108.927 2.32029 108.953 2.29451ZM107.842 2.75852C107.868 2.75852 107.894 2.75852 107.894 2.75852C107.868 2.75852 107.868 2.7843 107.842 2.75852ZM107.791 2.75852C107.842 2.75852 107.842 2.7843 107.791 2.75852C107.791 2.7843 107.791 2.7843 107.791 2.75852ZM107.817 2.70697C107.842 2.70697 107.868 2.68119 107.868 2.70697C107.842 2.70697 107.817 2.70697 107.817 2.70697C107.842 2.70697 107.868 2.70697 107.868 2.73275C107.842 2.73275 107.842 2.73275 107.817 2.70697C107.817 2.73275 107.817 2.73275 107.817 2.73275C107.791 2.75852 107.791 2.73275 107.817 2.70697ZM107.92 2.65541C107.92 2.65541 107.92 2.65541 107.946 2.65541C107.946 2.65541 107.92 2.68119 107.92 2.65541ZM107.868 2.68119C107.868 2.70697 107.868 2.70697 107.868 2.68119L107.817 2.70697C107.817 2.70697 107.842 2.70697 107.868 2.68119ZM107.481 2.81008C107.507 2.81008 107.558 2.7843 107.558 2.7843C107.532 2.7843 107.507 2.7843 107.507 2.81008C107.507 2.81008 107.481 2.83586 107.481 2.81008ZM107.791 2.68119C107.739 2.70697 107.765 2.68119 107.791 2.68119V2.68119ZM108.049 2.50074C108.049 2.50074 108.023 2.52652 107.997 2.52652C107.997 2.52652 108.023 2.52652 108.049 2.50074ZM107.946 2.52652C107.946 2.55229 107.997 2.52652 107.946 2.52652C107.946 2.55229 107.946 2.55229 107.946 2.52652C107.946 2.55229 107.92 2.55229 107.946 2.52652ZM107.92 2.4234C107.92 2.4234 107.946 2.4234 107.971 2.4234C107.971 2.4234 107.971 2.4234 107.92 2.4234C107.971 2.4234 107.946 2.4234 107.92 2.4234ZM106.551 2.96475H106.577C106.551 2.99053 106.577 2.96475 106.551 2.96475ZM106.215 3.01631H106.267C106.293 3.01631 106.164 3.04209 106.215 3.01631ZM106.267 2.99053H106.293C106.319 2.99053 106.267 3.01631 106.267 2.99053C106.293 2.99053 106.241 2.99053 106.267 2.99053ZM105.828 3.06787C105.854 3.06787 105.828 3.06787 105.88 3.06787C105.854 3.09365 105.88 3.09365 105.906 3.09365C105.931 3.09365 105.931 3.06787 105.983 3.06787C105.983 3.06787 105.983 3.09365 105.957 3.09365C105.957 3.06787 105.906 3.09365 105.88 3.09365C105.88 3.06787 105.828 3.09365 105.828 3.06787ZM105.673 3.09365C105.673 3.11943 105.699 3.11943 105.673 3.09365C105.673 3.09365 105.647 3.11943 105.647 3.09365C105.673 3.11943 105.673 3.09365 105.673 3.09365ZM105.647 3.09365H105.673C105.673 3.09365 105.647 3.14521 105.647 3.11943C105.673 3.09365 105.647 3.09365 105.647 3.09365ZM105.621 3.09365C105.596 3.09365 105.596 3.11943 105.621 3.09365V3.09365ZM105.157 3.17098H105.182C105.182 3.17098 105.208 3.17098 105.157 3.17098C105.182 3.19676 105.131 3.17098 105.157 3.17098ZM105.079 3.17098C105.105 3.17098 105.105 3.1452 105.105 3.17098C105.079 3.17098 105.079 3.17098 105.079 3.17098ZM104.924 3.24832C104.95 3.24832 104.95 3.22254 104.976 3.22254C104.976 3.22254 104.95 3.24832 104.924 3.24832ZM104.898 3.22254H104.924C104.898 3.24832 104.924 3.24832 104.898 3.22254C104.898 3.24832 104.898 3.24832 104.898 3.22254ZM104.95 3.17098C104.924 3.19676 104.95 3.19676 104.95 3.17098C104.95 3.19676 104.976 3.19676 104.95 3.17098L104.924 3.19676C104.924 3.19676 104.95 3.19676 104.95 3.17098ZM104.873 3.19676C104.898 3.19676 104.898 3.19676 104.924 3.17098C104.924 3.19676 104.847 3.22254 104.898 3.22254H104.873C104.847 3.22254 104.873 3.19676 104.873 3.19676ZM104.769 3.19676C104.743 3.19676 104.743 3.22254 104.718 3.19676C104.743 3.22254 104.769 3.22254 104.769 3.19676ZM104.33 3.35143H104.356C104.356 3.35143 104.356 3.35143 104.33 3.35143ZM104.02 3.48033L104.072 3.45455C104.072 3.45455 104.046 3.48033 104.02 3.48033ZM103.814 3.48033C103.84 3.48033 103.865 3.48033 103.891 3.45455C103.84 3.45455 103.84 3.45455 103.814 3.48033H103.762H103.788C103.788 3.45455 103.788 3.45455 103.814 3.48033C103.814 3.42877 103.891 3.42877 103.943 3.40299H103.917C103.943 3.40299 103.917 3.40299 103.943 3.40299H103.969C103.969 3.40299 103.943 3.40299 103.943 3.42877C103.969 3.42877 103.995 3.42877 104.02 3.42877C104.02 3.42877 104.046 3.42877 104.02 3.40299C104.046 3.40299 104.046 3.40299 104.046 3.40299L104.175 3.37721C104.175 3.37721 104.175 3.37721 104.201 3.37721C104.175 3.37721 104.149 3.40299 104.124 3.42877C104.149 3.42877 104.175 3.40299 104.201 3.40299C104.201 3.40299 104.201 3.40299 104.227 3.40299H104.253C104.253 3.40299 104.253 3.40299 104.279 3.40299H104.304H104.33C104.304 3.40299 104.253 3.42877 104.227 3.45455H104.201H104.149C104.149 3.45455 104.149 3.45455 104.124 3.45455C104.098 3.45455 104.072 3.48033 104.046 3.48033C103.995 3.48033 104.02 3.50611 104.02 3.50611C103.995 3.50611 103.969 3.50611 103.943 3.53189L103.814 3.48033ZM102.109 4.27947L102.058 4.30525L102.006 4.33103C101.98 4.33103 101.954 4.3568 101.929 4.3568C101.929 4.3568 101.98 4.33103 101.929 4.33103H101.877L101.903 4.30525C102.006 4.30525 102.032 4.30525 102.109 4.27947ZM101.799 4.43414C101.799 4.43414 101.825 4.43414 101.851 4.40836L101.799 4.43414ZM101.593 4.56303C101.593 4.56303 101.567 4.56303 101.541 4.56303C101.619 4.51148 101.619 4.51148 101.593 4.51148C101.619 4.51148 101.619 4.51148 101.645 4.51148C101.67 4.51148 101.67 4.51148 101.696 4.4857L101.67 4.51148L101.593 4.56303ZM98.8038 5.98086C98.8555 5.95508 98.8813 5.9293 98.933 5.90353H98.9071L99.0879 5.80041C99.2429 5.72308 99.3978 5.64574 99.5528 5.5684C99.5011 5.61996 99.4753 5.64574 99.4236 5.67152H99.4753L99.5011 5.64574L99.5786 5.61996C99.5786 5.61996 99.5011 5.67152 99.4753 5.6973C99.4753 5.6973 99.3462 5.74885 99.3203 5.77463L99.3978 5.72308C99.372 5.72308 99.2429 5.80041 99.217 5.82619L99.2945 5.77463C99.2945 5.77463 99.217 5.82619 99.2687 5.77463C99.1912 5.82619 99.1137 5.85197 99.0363 5.92931C98.9846 5.98086 98.9846 5.92931 98.933 5.98086C99.0104 5.92931 98.933 6.00664 99.0104 5.95508C98.9846 5.98086 99.0104 5.95508 98.9588 6.00664C98.8813 6.03242 98.9071 6.0582 98.8297 6.08398C98.8038 6.10976 98.8813 6.08398 98.8038 6.10976C98.7264 6.16131 98.7264 6.13553 98.7006 6.13553C98.778 6.08398 98.778 6.10976 98.8555 6.0582L98.7264 6.10976C98.7264 6.10976 98.7522 6.08398 98.778 6.08398C98.7522 6.08398 98.7264 6.10976 98.7006 6.10976H98.6747C98.7264 6.08398 98.7522 6.0582 98.8038 6.03242C98.7522 6.00664 98.778 5.98086 98.8038 5.98086ZM100.095 5.2075L100.173 5.18172H100.147L100.276 5.10439L100.405 5.05283L100.379 5.07861C100.379 5.07861 100.379 5.07861 100.405 5.07861C100.379 5.07861 100.353 5.10439 100.327 5.13017L100.25 5.18172C100.25 5.18172 100.224 5.18172 100.224 5.2075H100.25C100.276 5.2075 100.327 5.15594 100.327 5.15594L100.276 5.18172H100.302C100.276 5.18172 100.25 5.2075 100.224 5.23328C100.25 5.23328 100.302 5.18172 100.302 5.2075C100.276 5.23328 100.25 5.23328 100.224 5.25906H100.25C100.224 5.28484 100.173 5.28484 100.147 5.31062C100.069 5.3364 100.224 5.25906 100.198 5.23328L99.9401 5.36217C99.9659 5.36217 99.9918 5.36217 99.9918 5.36217C99.9401 5.38795 99.9918 5.36217 99.9143 5.41373C99.9143 5.38795 99.811 5.46529 99.7593 5.49107C99.7335 5.51685 99.7335 5.51685 99.7852 5.49107C99.7852 5.49107 99.7077 5.54263 99.6819 5.5684L99.6044 5.59418C99.6302 5.5684 99.6044 5.5684 99.5528 5.59418C99.6302 5.54262 99.7077 5.49107 99.811 5.43951H99.7852C99.8626 5.36217 100.018 5.3364 100.043 5.28484C100.069 5.2075 100.095 5.2075 100.095 5.2075ZM100.457 5.00127L100.534 4.97549C100.534 4.97549 100.508 5.00127 100.482 5.00127H100.457C100.457 5.02705 100.457 5.02705 100.457 5.00127ZM100.198 5.00127L100.25 4.97549C100.224 5.00127 100.224 5.00127 100.198 5.00127ZM100.586 4.82082L100.689 4.76926C100.715 4.76926 100.741 4.74348 100.766 4.74348C100.87 4.71771 100.87 4.74348 100.818 4.74348C100.818 4.74348 100.663 4.82082 100.766 4.74348H100.741C100.715 4.74348 100.663 4.76926 100.663 4.79504C100.637 4.82082 100.586 4.8466 100.586 4.82082L100.482 4.89816H100.534L100.405 4.94971C100.482 4.92394 100.379 4.97549 100.327 5.00127C100.302 5.00127 100.25 5.02705 100.302 5.00127L100.353 4.97549H100.379L100.586 4.82082ZM100.586 4.79504L100.534 4.82082C100.56 4.82082 100.586 4.82082 100.586 4.79504ZM100.947 4.64037L101.025 4.58881H101.051L101.102 4.56303C101.128 4.56303 101.128 4.56303 101.154 4.53726C101.128 4.56303 101.128 4.56303 101.076 4.58881L100.973 4.64037H100.947ZM100.999 4.58881L100.973 4.61459C100.973 4.61459 100.973 4.61459 100.947 4.61459C100.973 4.58881 100.973 4.58881 100.999 4.58881ZM101.102 4.53726C101.102 4.53726 101.128 4.53725 101.128 4.51148C101.128 4.51148 101.128 4.53726 101.102 4.53726ZM101.102 4.51148C101.076 4.53725 101.076 4.53726 101.051 4.53726C101.051 4.53726 101.076 4.53725 101.102 4.51148ZM101.67 4.17635H101.696C101.722 4.17635 101.748 4.17635 101.748 4.15057L101.67 4.17635C101.67 4.20213 101.67 4.20213 101.67 4.17635ZM101.877 3.94434C101.851 3.97012 101.851 3.97012 101.877 3.94434V3.94434ZM101.877 3.91857C101.903 3.91857 101.903 3.91857 101.929 3.91857H101.903H101.877ZM102.109 3.78967C102.084 3.78967 102.058 3.81545 102.032 3.78967C102.058 3.81545 102.109 3.81545 102.109 3.78967ZM102.084 3.78967C102.109 3.78967 102.109 3.78967 102.109 3.78967H102.084ZM102.109 3.76389C102.135 3.76389 102.187 3.73812 102.213 3.71234C102.187 3.71234 102.135 3.73812 102.135 3.76389C102.135 3.76389 102.109 3.78967 102.109 3.76389ZM101.541 3.91857C101.567 3.91857 101.619 3.86701 101.619 3.89279C101.645 3.86701 101.619 3.89279 101.645 3.86701H101.67C101.619 3.89279 101.567 3.91857 101.515 3.94434C101.515 3.94434 101.541 3.94434 101.541 3.91857ZM101.025 4.15057L100.973 4.17635C100.999 4.15057 101.025 4.1248 101.025 4.15057ZM101.593 3.81545C101.593 3.78967 101.696 3.76389 101.722 3.73812C101.748 3.71234 101.774 3.71234 101.799 3.68656C101.799 3.68656 101.799 3.68656 101.774 3.68656H101.799C101.799 3.68656 101.799 3.71234 101.774 3.71234H101.748L101.722 3.73812H101.748C101.748 3.73812 101.722 3.73812 101.722 3.76389C101.722 3.76389 101.722 3.76389 101.748 3.76389C101.748 3.76389 101.722 3.76389 101.696 3.76389C101.67 3.76389 101.67 3.76389 101.67 3.78967H101.645C101.67 3.78967 101.67 3.78967 101.645 3.78967C101.619 3.78967 101.619 3.78967 101.619 3.78967H101.593C101.593 3.78967 101.593 3.78967 101.619 3.78967C101.619 3.78967 101.619 3.81545 101.593 3.81545C101.593 3.81545 101.593 3.81545 101.593 3.78967C101.593 3.78967 101.593 3.78967 101.567 3.81545C101.567 3.78967 101.619 3.76389 101.645 3.76389C101.619 3.76389 101.593 3.76389 101.567 3.76389C101.541 3.76389 101.515 3.78967 101.515 3.78967C101.49 3.78967 101.464 3.78967 101.438 3.81545C101.49 3.78967 101.541 3.78967 101.567 3.73812C101.567 3.84123 101.593 3.81545 101.593 3.81545ZM101.98 3.60922C101.98 3.635 101.98 3.635 101.98 3.60922V3.60922ZM101.877 3.635C101.877 3.635 101.903 3.635 101.929 3.635H101.877ZM102.084 3.55766C102.058 3.58344 102.032 3.60922 102.006 3.60922C102.006 3.60922 102.006 3.60922 102.032 3.60922C102.032 3.60922 102.032 3.60922 102.032 3.58344C102.006 3.58344 101.954 3.60922 101.954 3.60922C101.954 3.60922 101.954 3.60922 101.954 3.635C101.954 3.635 101.929 3.635 101.954 3.60922C101.954 3.60922 101.954 3.60922 101.98 3.60922C101.98 3.60922 101.98 3.60922 102.006 3.60922C102.032 3.58344 102.032 3.55766 102.084 3.55766ZM102.316 3.50611C102.29 3.50611 102.29 3.50611 102.264 3.50611C102.264 3.50611 102.264 3.50611 102.264 3.48033C102.264 3.48033 102.316 3.48033 102.316 3.50611ZM102.342 3.50611C102.316 3.50611 102.29 3.50611 102.264 3.53189C102.264 3.53189 102.29 3.53189 102.342 3.50611ZM102.368 3.55766H102.342C102.316 3.55766 102.419 3.53189 102.342 3.55766C102.393 3.53189 102.316 3.55766 102.316 3.53189H102.342C102.342 3.55766 102.342 3.53189 102.368 3.53189C102.368 3.53189 102.342 3.53189 102.342 3.55766C102.368 3.53189 102.342 3.55766 102.368 3.55766ZM103.039 3.24832H102.987C103.013 3.24832 103.013 3.24832 103.039 3.24832ZM103.246 3.1452C103.194 3.17098 103.22 3.1452 103.246 3.1452V3.1452ZM103.091 3.17098C103.091 3.17098 103.117 3.17098 103.142 3.19676C103.091 3.22254 103.091 3.19676 103.091 3.17098ZM103.091 3.17098C103.091 3.17098 103.039 3.19676 103.039 3.17098C103.065 3.17098 103.091 3.17098 103.091 3.17098ZM103.323 3.04209C103.323 3.06787 103.297 3.06787 103.271 3.09365C103.297 3.06787 103.323 3.04209 103.323 3.04209ZM103.401 2.99053C103.426 2.99053 103.426 3.01631 103.401 2.99053C103.401 2.99053 103.401 3.04209 103.375 3.01631C103.401 3.01631 103.375 3.01631 103.349 3.01631C103.349 3.01631 103.349 3.01631 103.349 2.99053C103.375 2.99053 103.401 2.99053 103.401 2.99053ZM103.168 3.06787C103.194 3.04209 103.117 3.06787 103.142 3.04209C103.168 3.04209 103.22 3.01631 103.271 3.01631C103.246 3.01631 103.22 3.04209 103.194 3.04209C103.194 3.01631 103.194 3.04209 103.168 3.06787C103.22 3.04209 103.168 3.04209 103.168 3.06787ZM103.607 2.86164L103.659 2.83586C103.659 2.86164 103.633 2.86164 103.607 2.86164ZM103.814 2.81008C103.788 2.81008 103.788 2.81008 103.788 2.81008C103.814 2.81008 103.814 2.7843 103.814 2.81008C103.814 2.7843 103.814 2.7843 103.814 2.81008ZM103.71 2.88742C103.71 2.88742 103.762 2.88742 103.736 2.88742C103.71 2.9132 103.71 2.9132 103.71 2.88742C103.71 2.9132 103.71 2.9132 103.71 2.88742C103.685 2.86164 103.685 2.86164 103.71 2.88742ZM103.891 2.7843C103.865 2.81008 103.865 2.81008 103.865 2.81008L103.891 2.7843ZM104.02 2.75852C103.995 2.75852 103.969 2.7843 103.943 2.7843C103.969 2.7843 103.995 2.7843 103.943 2.7843C103.969 2.75852 103.995 2.75852 104.02 2.75852C104.046 2.75852 104.046 2.75852 104.02 2.75852ZM104.33 2.62963C104.33 2.62963 104.304 2.62963 104.279 2.65541C104.279 2.62963 104.356 2.62963 104.33 2.62963ZM104.511 2.55229C104.511 2.55229 104.537 2.52652 104.563 2.52652C104.537 2.52652 104.537 2.55229 104.511 2.55229ZM103.943 2.83586H103.917C103.891 2.83586 103.943 2.81008 103.943 2.83586ZM103.84 2.86164H103.865C103.84 2.88742 103.814 2.88742 103.84 2.86164ZM103.762 2.93898H103.814C103.788 2.93898 103.736 2.93898 103.762 2.93898ZM104.072 2.7843C104.072 2.7843 104.046 2.7843 104.02 2.81008C103.995 2.81008 104.046 2.7843 104.072 2.7843ZM105.26 2.29451C105.286 2.29451 105.286 2.29451 105.312 2.26873C105.312 2.26873 105.312 2.26873 105.312 2.29451C105.286 2.29451 105.312 2.26873 105.26 2.29451C105.286 2.29451 105.286 2.29451 105.286 2.29451H105.26C105.286 2.29451 105.26 2.32029 105.26 2.29451ZM105.415 2.19139C105.441 2.21717 105.441 2.19139 105.467 2.19139C105.492 2.21717 105.518 2.16561 105.544 2.19139C105.596 2.16561 105.621 2.19139 105.621 2.16561C105.647 2.16561 105.699 2.16561 105.725 2.13984L105.751 2.11406H105.776C105.776 2.11406 105.776 2.11406 105.802 2.11406C105.802 2.11406 105.802 2.11406 105.802 2.13984C105.802 2.13984 105.828 2.13984 105.854 2.13984H105.88C105.802 2.16561 105.673 2.21717 105.57 2.24295C105.544 2.24295 105.518 2.24295 105.492 2.24295C105.492 2.24295 105.492 2.24295 105.492 2.26873C105.467 2.26873 105.492 2.24295 105.467 2.26873C105.467 2.29451 105.415 2.26873 105.415 2.29451C105.389 2.29451 105.389 2.29451 105.363 2.29451C105.389 2.26873 105.389 2.29451 105.415 2.29451V2.26873V2.19139ZM104.924 2.34607C104.924 2.32029 104.924 2.32029 104.924 2.34607C104.924 2.32029 104.924 2.32029 104.95 2.32029C104.95 2.32029 105.028 2.29451 105.028 2.32029C105.053 2.32029 105.028 2.32029 105.053 2.29451C105.002 2.32029 104.95 2.32029 104.924 2.34607ZM104.769 2.34607H104.847C104.847 2.34607 104.873 2.34607 104.898 2.34607H104.873L104.795 2.37184C104.821 2.37184 104.847 2.34607 104.821 2.34607C104.795 2.34607 104.795 2.34607 104.769 2.34607ZM104.537 2.37184C104.614 2.37184 104.666 2.34606 104.743 2.32029C104.718 2.32029 104.666 2.34607 104.64 2.37184C104.64 2.34607 104.563 2.39762 104.563 2.37184H104.588H104.537ZM104.175 2.47496C104.201 2.47496 104.201 2.47496 104.201 2.44918C104.227 2.44918 104.227 2.47496 104.175 2.47496C104.201 2.47496 104.227 2.47496 104.227 2.47496H104.175C104.201 2.47496 104.201 2.47496 104.175 2.47496ZM103.917 2.57807C103.891 2.57807 103.84 2.60385 103.84 2.60385C103.788 2.62963 103.814 2.60385 103.762 2.60385C103.762 2.60385 103.762 2.60385 103.788 2.60385C103.814 2.60385 103.814 2.60385 103.84 2.60385H103.814C103.814 2.57807 103.891 2.57807 103.865 2.57807H103.891C103.891 2.57807 103.891 2.57807 103.917 2.57807L103.865 2.60385C103.865 2.57807 103.943 2.55229 103.917 2.57807ZM103.71 2.65541L103.788 2.62963C103.736 2.62963 103.762 2.65541 103.71 2.65541ZM103.168 2.86164C103.194 2.86164 103.194 2.86164 103.168 2.86164C103.271 2.81008 103.246 2.83586 103.323 2.81008C103.271 2.86164 103.22 2.86164 103.168 2.86164ZM102.936 2.9132C103.013 2.88742 103.065 2.88742 103.142 2.86164H103.194C103.194 2.86164 103.168 2.86164 103.168 2.88742C103.168 2.88742 103.142 2.88742 103.117 2.88742H103.065C103.039 2.88742 103.013 2.88742 102.987 2.88742C102.987 2.88742 102.962 2.9132 102.987 2.9132C102.884 2.93897 102.962 2.9132 102.936 2.9132ZM102.419 3.09365C102.471 3.06787 102.471 3.09365 102.497 3.06787L102.419 3.09365C102.445 3.06787 102.445 3.06787 102.471 3.06787C102.471 3.06787 102.445 3.06787 102.419 3.09365L102.497 3.04209H102.574C102.574 3.01631 102.497 3.04209 102.471 3.04209L102.523 3.01631C102.548 3.01631 102.548 3.01631 102.574 3.01631C102.574 3.01631 102.574 3.01631 102.6 3.01631H102.652H102.626H102.6C102.6 3.01631 102.574 3.01631 102.548 3.01631C102.6 2.99053 102.548 3.04209 102.574 3.01631C102.574 3.01631 102.574 3.01631 102.548 3.01631C102.548 3.01631 102.548 3.01631 102.574 3.01631H102.548C102.497 3.01631 102.523 3.04209 102.471 3.04209C102.445 3.04209 102.497 3.04209 102.471 3.06787C102.471 3.11943 102.445 3.09365 102.419 3.09365ZM101.851 3.17098H101.799C101.799 3.19676 101.825 3.17098 101.851 3.17098ZM103.117 2.65541C103.091 2.65541 103.091 2.65541 103.117 2.65541C103.117 2.65541 103.142 2.65541 103.168 2.62963C103.194 2.62963 103.22 2.60385 103.246 2.60385C103.271 2.60385 103.271 2.60385 103.297 2.60385H103.271C103.22 2.60385 103.246 2.62963 103.22 2.62963C103.194 2.62963 103.168 2.65541 103.168 2.62963L103.117 2.65541C103.091 2.68119 103.091 2.70697 103.065 2.70697L103.117 2.65541ZM102.962 2.70697C103.013 2.68119 103.039 2.68119 103.065 2.68119H103.039H103.013C103.013 2.70697 102.987 2.68119 102.962 2.70697ZM103.478 2.50074C103.452 2.52652 103.478 2.52652 103.478 2.50074H103.426C103.401 2.50074 103.426 2.50074 103.401 2.50074C103.349 2.50074 103.297 2.52652 103.246 2.55229C103.22 2.55229 103.194 2.55229 103.168 2.55229C103.194 2.52652 103.246 2.52652 103.246 2.50074C103.246 2.50074 103.271 2.50074 103.297 2.47496C103.323 2.47496 103.349 2.47496 103.401 2.44918C103.452 2.52652 103.478 2.50074 103.478 2.50074ZM103.685 2.4234C103.71 2.4234 103.762 2.39762 103.762 2.39762C103.788 2.39762 103.762 2.4234 103.762 2.4234C103.762 2.4234 103.659 2.44918 103.736 2.4234C103.736 2.4234 103.71 2.4234 103.685 2.4234ZM103.633 2.37184C103.659 2.37184 103.659 2.37184 103.685 2.37184H103.71C103.71 2.37184 103.685 2.37184 103.633 2.37184C103.659 2.37184 103.659 2.37184 103.633 2.37184ZM104.02 2.26873H103.995C103.995 2.26873 103.969 2.26873 103.943 2.26873C103.995 2.26873 104.02 2.26873 104.02 2.26873ZM104.537 2.0625H104.563C104.588 2.0625 104.614 2.0625 104.64 2.0625H104.588C104.588 2.0625 104.563 2.08828 104.537 2.0625ZM110.786 1.26336C110.812 1.26336 110.812 1.26336 110.786 1.26336V1.26336ZM110.761 1.39225C110.761 1.39225 110.761 1.39225 110.709 1.39225C110.709 1.36647 110.735 1.36647 110.761 1.39225C110.761 1.36647 110.735 1.39225 110.761 1.39225C110.786 1.36647 110.761 1.36647 110.761 1.39225ZM110.709 1.46959H110.683C110.709 1.44381 110.657 1.44381 110.683 1.39225C110.683 1.41803 110.683 1.44381 110.709 1.46959ZM109.934 1.83049C109.908 1.83049 109.96 1.80471 109.934 1.83049C109.908 1.83049 109.934 1.80471 109.934 1.83049ZM109.908 1.95938C109.908 1.93361 109.908 1.93361 109.908 1.95938C109.908 1.93361 109.96 1.93361 109.908 1.95938ZM109.986 1.93361C109.986 1.93361 109.96 1.95938 109.934 1.95938C109.96 1.93361 109.986 1.93361 109.986 1.93361ZM110.838 1.5727C110.864 1.54693 110.89 1.54693 110.838 1.5727C110.864 1.54693 110.864 1.5727 110.838 1.5727ZM109.469 2.19139C109.469 2.19139 109.443 2.21717 109.443 2.19139C109.469 2.21717 109.469 2.19139 109.469 2.19139ZM109.753 2.08828C109.779 2.08828 109.779 2.08828 109.753 2.08828V2.08828ZM109.547 2.19139H109.521C109.547 2.19139 109.573 2.16561 109.598 2.16561C109.573 2.19139 109.547 2.19139 109.547 2.19139ZM109.753 2.16561C109.779 2.13984 109.779 2.19139 109.753 2.16561V2.16561ZM109.805 2.11406C109.831 2.08828 109.831 2.11406 109.805 2.11406V2.11406ZM109.857 2.08828C109.857 2.08828 109.857 2.08828 109.882 2.08828C109.908 2.08828 109.882 2.08828 109.857 2.08828ZM109.805 2.16561C109.805 2.13984 109.779 2.16561 109.779 2.16561C109.779 2.16561 109.779 2.16561 109.779 2.13984C109.779 2.13984 109.805 2.11406 109.805 2.13984H109.779C109.805 2.13984 109.805 2.13984 109.805 2.16561ZM109.805 2.16561C109.831 2.16561 109.857 2.16561 109.857 2.16561C109.831 2.16561 109.805 2.16561 109.805 2.16561ZM110.631 1.95938C110.657 1.95938 110.683 1.95938 110.709 1.95938H110.683C110.709 1.95938 110.709 1.95938 110.735 1.95938C110.709 1.95938 110.657 1.93361 110.631 1.95938ZM110.502 2.0625C110.476 2.0625 110.476 2.0625 110.502 2.0625V2.0625ZM110.554 1.95938C110.58 1.95938 110.554 1.95938 110.606 1.95938H110.631C110.631 1.95938 110.631 1.95938 110.631 1.98516C110.631 1.98516 110.631 1.98516 110.606 1.98516C110.58 1.98516 110.58 1.95938 110.554 1.95938C110.58 1.95938 110.606 1.98516 110.606 1.98516C110.606 1.98516 110.58 1.98516 110.554 1.95938C110.58 1.98516 110.58 1.98516 110.606 2.01094C110.58 2.01094 110.58 2.01094 110.58 2.03672C110.554 2.03672 110.554 2.0625 110.528 2.03672C110.502 2.01094 110.528 2.03672 110.528 2.01094C110.528 1.98516 110.554 2.01094 110.554 2.01094C110.554 2.01094 110.554 2.01094 110.58 1.98516C110.554 1.98516 110.554 1.98516 110.554 1.98516C110.554 1.98516 110.554 1.98516 110.554 1.95938ZM110.58 1.95938C110.606 1.95938 110.631 1.93361 110.631 1.95938C110.606 1.93361 110.58 1.95938 110.58 1.95938ZM110.037 2.11406C110.012 2.11406 110.063 2.11406 110.037 2.11406V2.13984C110.037 2.13984 110.012 2.11406 110.037 2.11406ZM110.761 1.75315C110.735 1.77893 110.761 1.77893 110.761 1.75315L110.735 1.77893C110.709 1.77893 110.786 1.77893 110.735 1.77893C110.76 1.77893 110.735 1.75315 110.761 1.75315ZM110.812 1.72738C110.812 1.72738 110.838 1.72738 110.864 1.72738C110.838 1.75315 110.812 1.75315 110.812 1.72738ZM110.786 1.80471C110.76 1.80471 110.735 1.80471 110.735 1.83049C110.735 1.83049 110.735 1.83049 110.735 1.80471C110.735 1.80471 110.786 1.77893 110.786 1.80471ZM110.554 1.90783C110.58 1.88205 110.58 1.90783 110.554 1.90783V1.90783ZM110.115 2.13984H110.089C110.063 2.11406 110.063 2.11406 110.115 2.13984ZM110.554 1.93361C110.554 1.93361 110.528 1.95938 110.502 1.95938C110.528 1.95938 110.528 1.93361 110.554 1.93361Z",
    fill: "url(#paint386_linear_4741_7283)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M110.683 2.0623H110.631C110.657 2.03652 110.683 2.03652 110.683 2.0623C110.683 2.03652 110.683 2.03652 110.683 2.0623Z",
    fill: "url(#paint387_linear_4741_7283)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M104.175 2.13965C104.175 2.13965 104.201 2.13965 104.227 2.13965C104.227 2.16543 104.15 2.16543 104.124 2.16543C104.15 2.13965 104.175 2.16543 104.175 2.13965Z",
    fill: "url(#paint388_linear_4741_7283)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M104.175 2.19134C104.149 2.19134 104.149 2.19134 104.124 2.21712C104.124 2.19134 104.072 2.2429 104.098 2.21712C104.124 2.19134 104.149 2.16556 104.175 2.19134Z",
    fill: "url(#paint389_linear_4741_7283)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M104.072 2.19141C104.098 2.19141 104.072 2.19141 104.098 2.19141C104.124 2.19141 104.098 2.19141 104.124 2.19141C104.124 2.19141 104.149 2.19141 104.175 2.19141C104.149 2.19141 104.098 2.19141 104.072 2.19141V2.21719C104.046 2.24296 104.072 2.21718 104.072 2.19141C104.046 2.19141 104.046 2.21718 104.046 2.19141H104.072Z",
    fill: "url(#paint390_linear_4741_7283)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M103.788 2.26855C103.788 2.29433 103.814 2.26855 103.84 2.26855C103.814 2.26855 103.762 2.29433 103.762 2.26855C103.788 2.29433 103.788 2.29433 103.788 2.26855Z",
    fill: "url(#paint391_linear_4741_7283)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M103.556 2.3717C103.556 2.3717 103.556 2.3717 103.53 2.3717C103.53 2.3717 103.53 2.3717 103.53 2.39748H103.504C103.478 2.3717 103.401 2.39748 103.349 2.42326C103.349 2.42326 103.375 2.42326 103.349 2.39748C103.375 2.39748 103.401 2.39748 103.427 2.3717C103.427 2.3717 103.427 2.3717 103.452 2.3717C103.478 2.39748 103.556 2.34592 103.556 2.3717Z",
    fill: "url(#paint392_linear_4741_7283)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M103.246 2.44912C103.271 2.44912 103.323 2.42334 103.349 2.42334C103.297 2.44912 103.271 2.4749 103.246 2.44912Z",
    fill: "url(#paint393_linear_4741_7283)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M102.884 2.57792C102.884 2.6037 102.91 2.57792 102.884 2.57792C102.858 2.6037 102.884 2.6037 102.884 2.57792C102.858 2.57792 102.858 2.57792 102.832 2.57792H102.858C102.858 2.57792 102.832 2.57792 102.807 2.57792C102.832 2.55215 102.936 2.52637 102.936 2.52637C102.936 2.55215 102.91 2.57792 102.884 2.57792Z",
    fill: "url(#paint394_linear_4741_7283)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M102.832 2.70703L102.807 2.73281C102.807 2.73281 102.807 2.73281 102.781 2.73281C102.807 2.73281 102.832 2.70703 102.832 2.70703Z",
    fill: "url(#paint395_linear_4741_7283)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M102.574 2.81025C102.626 2.81025 102.703 2.75869 102.755 2.73291C102.755 2.73291 102.755 2.73291 102.781 2.73291C102.729 2.78447 102.677 2.78447 102.574 2.81025C102.6 2.83602 102.548 2.81025 102.548 2.83602C102.574 2.81025 102.574 2.81025 102.574 2.81025Z",
    fill: "url(#paint396_linear_4741_7283)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M102.729 2.62969C102.755 2.62969 102.729 2.65546 102.729 2.65546C102.729 2.65546 102.677 2.65546 102.652 2.65546C102.677 2.65546 102.703 2.65546 102.729 2.62969C102.729 2.65546 102.677 2.65546 102.677 2.65546C102.729 2.65546 102.729 2.62969 102.729 2.62969C102.729 2.62969 102.781 2.60391 102.807 2.62969C102.781 2.60391 102.755 2.60391 102.729 2.62969Z",
    fill: "url(#paint397_linear_4741_7283)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M102.419 2.88739C102.393 2.88739 102.342 2.91317 102.342 2.88739C102.419 2.86162 102.497 2.83584 102.574 2.81006C102.548 2.83584 102.497 2.81006 102.497 2.83584H102.471C102.471 2.83584 102.393 2.88739 102.419 2.88739Z",
    fill: "url(#paint398_linear_4741_7283)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M102.419 2.75859H102.394C102.419 2.73281 102.419 2.73281 102.419 2.75859C102.445 2.73281 102.419 2.73281 102.419 2.75859Z",
    fill: "url(#paint399_linear_4741_7283)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M102.032 3.01611C102.006 3.04189 102.058 3.04189 102.032 3.06767C102.032 3.06767 102.032 3.04189 102.006 3.06767C101.98 3.09345 101.955 3.09345 101.955 3.06767C101.955 3.01611 101.98 3.01611 102.032 3.01611Z",
    fill: "url(#paint400_linear_4741_7283)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M101.335 3.89258C101.309 3.91836 101.257 3.91836 101.206 3.94413C101.257 3.91836 101.309 3.89258 101.335 3.89258Z",
    fill: "url(#paint401_linear_4741_7283)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M101.206 3.89297C101.231 3.89297 101.206 3.89297 101.231 3.86719C101.231 3.89297 101.231 3.89297 101.206 3.89297C101.231 3.89297 101.231 3.89297 101.206 3.89297Z",
    fill: "url(#paint402_linear_4741_7283)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M110.786 2.11394C110.761 2.11394 110.735 2.11394 110.709 2.11394C110.735 2.08817 110.709 2.11394 110.735 2.08817C110.735 2.06239 110.812 2.03661 110.812 1.98505C110.838 1.95927 110.864 1.93349 110.864 1.90771C110.941 1.90771 110.89 1.93349 110.864 1.95927C110.864 1.95927 110.864 2.01083 110.838 2.01083H110.864C110.864 2.01083 110.812 2.01083 110.838 2.03661H110.812L110.786 2.06239C110.786 2.06239 110.786 2.08817 110.786 2.11394Z",
    fill: "url(#paint403_linear_4741_7283)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M109.134 1.16038C109.134 1.1346 109.16 1.16038 109.134 1.16038V1.16038Z",
    fill: "url(#paint404_linear_4741_7283)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M109.004 0.464229C108.953 0.464229 108.927 0.490008 108.901 0.515787C108.85 0.515787 108.798 0.490008 108.746 0.464229C108.695 0.438451 108.643 0.515787 108.591 0.464229C108.591 0.438451 108.617 0.438452 108.643 0.412673C108.669 0.412673 108.695 0.412673 108.72 0.412673C108.772 0.335337 108.875 0.309557 108.927 0.258C109.004 0.206443 109.082 0.180664 109.185 0.180664C109.237 0.180664 109.34 0.180664 109.34 0.206442C109.366 0.232221 109.34 0.258001 109.366 0.283779C109.34 0.309558 109.34 0.335337 109.289 0.361115C109.263 0.386894 109.211 0.438451 109.134 0.438451C109.082 0.46423 109.03 0.464229 109.004 0.464229Z",
    fill: "url(#paint405_linear_4741_7283)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M109.056 1.21181C109.056 1.21181 109.082 1.21181 109.134 1.18604C109.108 1.21181 109.082 1.21181 109.056 1.21181Z",
    fill: "url(#paint406_linear_4741_7283)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M109.986 0.180563C109.986 0.180563 110.012 0.180563 110.037 0.180563C110.063 0.180563 110.063 0.180564 110.063 0.154785H110.037H110.012C110.012 0.154785 110.037 0.154785 110.063 0.154785C110.089 0.154785 110.063 0.180563 110.037 0.206342C110.012 0.180563 109.986 0.180563 109.986 0.180563Z",
    fill: "url(#paint407_linear_4741_7283)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M110.451 0.0776367C110.425 0.0776367 110.451 0.103415 110.451 0.0776367C110.425 0.0776367 110.451 0.129194 110.451 0.0776367Z",
    fill: "url(#paint408_linear_4741_7283)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1956 15.4418C96.1956 11.1368 98.7263 6.75439 104.33 6.75439C110.141 6.75439 112 11.4203 112 15.1067C112 15.4934 111.974 15.8801 111.923 16.2667C111.897 16.4987 111.69 16.705 111.432 16.705H101.051C100.766 16.705 100.56 16.937 100.56 17.1948C100.56 17.2463 100.56 17.2721 100.56 17.3237C101.025 19.154 102.238 20.3398 104.588 20.3398C105.647 20.3398 106.629 20.1078 107.532 19.4891C108.204 19.0251 109.108 19.0508 109.727 19.5922L109.857 19.6953C110.58 20.3398 110.657 21.4483 110.012 22.1958C109.908 22.299 109.779 22.4278 109.676 22.5052C108.23 23.5106 106.525 24.0003 104.537 24.0003C98.8813 24.0003 96.1956 19.9015 96.1956 15.4418ZM107.507 13.792C107.791 13.792 107.997 13.56 107.997 13.2764C107.997 13.2506 107.997 13.2248 107.997 13.1991C107.971 13.0444 107.946 12.8897 107.894 12.7351C107.481 11.0337 106.06 10.1572 104.304 10.1572C102.161 10.1572 101.102 11.4203 100.637 13.1733C100.56 13.4311 100.715 13.7146 100.999 13.7662C101.051 13.7662 101.076 13.7662 101.128 13.7662L107.507 13.792Z",
    fill: "#66BDE4"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1899 20.3136V2.03652C88.1899 0.928034 89.1196 0 90.2301 0C91.3405 0 92.2702 0.928034 92.2702 2.03652V19.1794C92.2702 19.9527 92.7867 20.2878 93.613 20.2878C93.6905 20.2878 93.8713 20.2878 94.0779 20.2878C95.0592 20.2621 95.8598 21.0354 95.8856 22.015C95.8856 22.015 95.8856 22.0408 95.8856 22.0666C95.8856 22.9946 95.1883 23.7422 94.2587 23.8453C93.3032 23.9226 92.2444 23.9742 91.6504 23.9742C89.7652 23.9742 88.1899 23.2524 88.1899 20.3136Z",
    fill: "#66BDE4"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4471 23.9741C75.846 23.9741 74.4256 23.6132 73.1861 22.8656C71.9465 22.1438 70.9652 21.1127 70.2421 19.8237C69.519 18.5348 69.1575 17.0654 69.1575 15.4156C69.1575 13.7399 69.519 12.2706 70.2163 11.0074C70.9393 9.74425 71.9207 8.73888 73.1602 7.9913C74.4256 7.26949 75.846 6.88281 77.4471 6.88281C79.0224 6.88281 80.4427 7.24372 81.6823 7.9913C82.9218 8.7131 83.9032 9.71847 84.6262 11.0074C85.3493 12.2706 85.685 13.7399 85.685 15.4156C85.685 17.0654 85.3235 18.509 84.6262 19.7979C83.9032 21.0869 82.9476 22.0922 81.6823 22.8398C80.4427 23.6132 79.0224 23.9741 77.4471 23.9741ZM77.4471 20.3393C78.2993 20.3393 79.0224 20.1331 79.6421 19.7464C80.2619 19.3597 80.7268 18.7926 81.0366 18.045C81.3465 17.3232 81.5273 16.4467 81.5273 15.4156C81.5273 14.3844 81.3724 13.4822 81.0366 12.7604C80.7268 12.0386 80.2361 11.4972 79.6421 11.0847C79.0224 10.6981 78.2993 10.4918 77.4471 10.4918C76.569 10.4918 75.846 10.6981 75.2262 11.0847C74.6064 11.4714 74.1157 12.0386 73.8058 12.7604C73.4701 13.4822 73.3152 14.3586 73.3152 15.4156C73.3152 16.4467 73.4701 17.3232 73.8058 18.045C74.1416 18.7668 74.6064 19.3339 75.2262 19.7464C75.846 20.1588 76.5949 20.3393 77.4471 20.3393Z",
    fill: "#66BDE4"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9871 0.30957C57.0975 0.30957 58.0272 1.2376 58.0272 2.34609V12.6833C58.0272 12.9927 58.2855 13.2505 58.5953 13.2505C58.7503 13.2505 58.9052 13.1731 59.0085 13.07L63.786 7.83695C64.1476 7.45027 64.6641 7.21826 65.1805 7.21826C66.8591 7.21826 67.7113 9.229 66.5492 10.4406L63.7086 13.3794C63.5278 13.5598 63.502 13.8692 63.6569 14.1012L68.2536 20.881C68.8734 21.7832 68.6152 23.0206 67.7371 23.6393C67.4014 23.8455 67.0141 23.9744 66.6267 23.9744C65.9553 23.9744 65.3097 23.6135 64.9481 23.0464L61.0228 16.8595C60.8421 16.5759 60.5063 16.5244 60.2223 16.679C60.1706 16.7048 60.1448 16.7306 60.119 16.7822L58.1822 18.896C58.0789 18.9991 58.0272 19.128 58.0272 19.2827V21.9895C58.0272 23.0722 57.1492 23.9744 56.0387 23.9744H55.9096C54.825 23.9744 53.9211 23.0979 53.9211 21.9895V2.34609C53.947 1.21183 54.8766 0.30957 55.9871 0.30957Z",
    fill: "#66BDE4"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6447 7.24371H39.5887C39.8986 7.24371 40.1568 7.5015 40.1568 7.81085C40.1568 8.12019 40.4151 8.37798 40.725 8.37798C40.8541 8.37798 40.9832 8.32642 41.0865 8.24908C42.2228 7.34683 43.6173 6.88281 45.0635 6.88281C49.4536 6.88281 51.1838 10.4145 51.1838 13.8946V21.9634C51.1838 23.0461 50.3058 23.9483 49.1953 23.9483H49.0662C47.9816 23.9483 47.0778 23.0718 47.0778 21.9891V14.4618C47.0778 12.2706 45.9673 10.6723 43.8755 10.6723C41.5772 10.6723 40.131 11.9097 40.131 14.8227V21.9891C40.131 23.0718 39.253 23.9483 38.1684 23.9483H38.0393C36.9546 23.9483 36.0508 23.0718 36.0508 21.9634V7.81085C36.0766 7.5015 36.3348 7.24371 36.6447 7.24371Z",
    fill: "#66BDE4"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6347 8.66184C30.3693 7.52758 28.6132 6.96045 26.3407 6.96045C24.9462 6.96045 23.655 7.16668 22.4412 7.57914C21.744 7.81114 21.0467 8.14627 20.3753 8.55873C19.5489 9.0743 19.3423 10.1828 19.9104 10.9561L20.0137 11.085C20.5302 11.7811 21.4857 11.9615 22.2088 11.5233C22.5703 11.317 22.9577 11.1366 23.3709 10.9819C24.2747 10.6468 25.1528 10.4664 26.005 10.4664C27.0379 10.4664 27.8643 10.6984 28.4841 11.1882C29.1039 11.6522 29.388 12.3998 29.388 13.3536C29.388 13.5856 29.2072 13.7402 29.0006 13.7402H24.6879C23.9132 13.7402 23.1901 13.8176 22.5187 13.9465C21.8473 14.0754 21.2275 14.3074 20.6852 14.6425C20.0396 15.0034 19.5231 15.519 19.1357 16.1892C18.7483 16.8595 18.5417 17.6844 18.5417 18.6382C18.5417 19.6951 18.8 20.6489 19.3681 21.4481C19.9104 22.273 20.6593 22.8917 21.589 23.3299C22.5187 23.7682 23.6033 24.0002 24.7912 24.0002C25.6434 24.0002 26.4182 23.8455 27.1929 23.5104C27.9418 23.1753 28.6132 22.6597 29.2072 21.9379C29.3105 21.8348 29.388 21.7059 29.4654 21.577L29.6462 22.9948C29.6978 23.3815 30.0336 23.6651 30.4209 23.6651H32.7451C33.1841 23.6651 33.5198 23.3041 33.5198 22.8917V13.3536C33.5457 11.3428 32.9001 9.77033 31.6347 8.66184ZM28.8715 18.8444C28.5099 19.4116 28.0193 19.8498 27.3995 20.1591C26.7797 20.4685 26.1083 20.6489 25.3852 20.6489C24.5588 20.6489 23.9132 20.4685 23.4225 20.0818C22.9319 19.6951 22.6995 19.2053 22.6995 18.5866C22.6995 18.3031 22.7511 18.0453 22.8544 17.8133C22.9577 17.5813 23.1385 17.4008 23.3451 17.2204C23.5775 17.0141 23.8874 16.8852 24.2231 16.8337C24.5588 16.7821 24.9203 16.7564 25.2819 16.7564H29.4138V16.8853C29.4138 17.6328 29.233 18.2773 28.8715 18.8444Z",
    fill: "#66BDE4"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 9.22861C12.8347 7.73345 10.7429 6.90853 8.54784 6.90853H4.08024V2.37148C4.08024 1.26299 3.15057 0.334961 2.04012 0.334961C0.929675 0.334961 0 1.26299 0 2.37148V7.1921C0 7.24365 0 7.32099 0 7.37255C0 7.39833 0 7.44988 0 7.47566V15.4413C0 20.1588 3.84782 23.974 8.57367 23.974C8.75444 23.974 8.93521 23.974 9.1418 23.9483C13.377 23.6647 16.8116 20.2361 17.0957 16.0084C17.2506 13.4821 16.2693 11.0073 14.41 9.22861ZM12.783 15.9569C12.499 18.3027 10.3814 19.9783 8.03136 19.6948C5.88794 19.437 4.26101 17.6325 4.26101 15.4413V11.1878H8.54784C10.8979 11.1878 12.8347 13.1212 12.8347 15.4671C12.8089 15.6475 12.8089 15.8022 12.783 15.9569Z",
    fill: "#66BDE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4741_7283",
    x1: 98.0921,
    y1: 6.00342,
    x2: 98.0702,
    y2: 6.02539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4741_7283",
    x1: 102.532,
    y1: 3.66972,
    x2: 102.451,
    y2: 3.75041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4741_7283",
    x1: 99.3972,
    y1: 5.46075,
    x2: 99.3104,
    y2: 5.54769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4741_7283",
    x1: 99.4819,
    y1: 5.42467,
    x2: 99.4208,
    y2: 5.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4741_7283",
    x1: 99.9242,
    y1: 5.19869,
    x2: 99.8945,
    y2: 5.22845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4741_7283",
    x1: 101.343,
    y1: 4.17352,
    x2: 101.306,
    y2: 4.21034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4741_7283",
    x1: 101.005,
    y1: 4.27299,
    x2: 100.788,
    y2: 4.49077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4741_7283",
    x1: 100.983,
    y1: 4.27529,
    x2: 100.947,
    y2: 4.31053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4741_7283",
    x1: 100.484,
    y1: 4.70051,
    x2: 100.433,
    y2: 4.75143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4741_7283",
    x1: 99.5932,
    y1: 5.38626,
    x2: 99.5604,
    y2: 5.41914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4741_7283",
    x1: 97.9799,
    y1: 6.02759,
    x2: 97.8845,
    y2: 6.12318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4741_7283",
    x1: 104.345,
    y1: 2.58664,
    x2: 104.317,
    y2: 2.61484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4741_7283",
    x1: 101.429,
    y1: 3.38501,
    x2: 101.369,
    y2: 3.44532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4741_7283",
    x1: 101.023,
    y1: 3.61765,
    x2: 100.872,
    y2: 3.76884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4741_7283",
    x1: 101.216,
    y1: 3.54477,
    x2: 101.084,
    y2: 3.67715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4741_7283",
    x1: 105.348,
    y1: 1.86608,
    x2: 105.26,
    y2: 1.95382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4741_7283",
    x1: 102.707,
    y1: 2.92305,
    x2: 102.689,
    y2: 2.94028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4741_7283",
    x1: 101.342,
    y1: 3.44694,
    x2: 101.212,
    y2: 3.57698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4741_7283",
    x1: 101.371,
    y1: 3.53398,
    x2: 101.345,
    y2: 3.5606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4741_7283",
    x1: 101.327,
    y1: 3.64341,
    x2: 101.245,
    y2: 3.72566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4741_7283",
    x1: 101.366,
    y1: 3.66024,
    x2: 101.343,
    y2: 3.68296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4741_7283",
    x1: 102.745,
    y1: 2.86275,
    x2: 102.705,
    y2: 2.90191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4741_7283",
    x1: 104.875,
    y1: 2.04623,
    x2: 104.848,
    y2: 2.07365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4741_7283",
    x1: 105.08,
    y1: 1.95202,
    x2: 105.057,
    y2: 1.97554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4741_7283",
    x1: 106.913,
    y1: 1.26202,
    x2: 106.333,
    y2: 1.84325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4741_7283",
    x1: 107.512,
    y1: 1.27498,
    x2: 107.194,
    y2: 1.59381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4741_7283",
    x1: 108.028,
    y1: 1.345,
    x2: 107.995,
    y2: 1.37791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4741_7283",
    x1: 107.698,
    y1: 1.38121,
    x2: 107.682,
    y2: 1.39768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4741_7283",
    x1: 107.777,
    y1: 1.34937,
    x2: 107.738,
    y2: 1.38852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4741_7283",
    x1: 100.718,
    y1: 5.08899,
    x2: 100.691,
    y2: 5.11641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4741_7283",
    x1: 102.416,
    y1: 4.1332,
    x2: 102.391,
    y2: 4.15827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4741_7283",
    x1: 98.2202,
    y1: 6.7785,
    x2: 97.9996,
    y2: 6.99942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4741_7283",
    x1: 98.4492,
    y1: 6.62422,
    x2: 98.2435,
    y2: 6.83024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4741_7283",
    x1: 104.344,
    y1: 3.79296,
    x2: 104.171,
    y2: 3.96606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4741_7283",
    x1: 103.727,
    y1: 3.77098,
    x2: 103.598,
    y2: 3.90022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4741_7283",
    x1: 104.322,
    y1: 3.80501,
    x2: 104.258,
    y2: 3.86847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4741_7283",
    x1: 105.448,
    y1: 3.39167,
    x2: 104.731,
    y2: 4.10918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4741_7283",
    x1: 105.39,
    y1: 3.46855,
    x2: 104.997,
    y2: 3.86239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4741_7283",
    x1: 100.674,
    y1: 5.19659,
    x2: 100.658,
    y2: 5.21226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4741_7283",
    x1: 100.252,
    y1: 5.47718,
    x2: 100.229,
    y2: 5.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4741_7283",
    x1: 98.5957,
    y1: 6.49216,
    x2: 98.4041,
    y2: 6.68406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4741_7283",
    x1: 101.529,
    y1: 4.82534,
    x2: 101.31,
    y2: 5.04387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4741_7283",
    x1: 104.167,
    y1: 3.84934,
    x2: 104.124,
    y2: 3.89242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4741_7283",
    x1: 98.8548,
    y1: 4.74607,
    x2: 109.119,
    y2: 4.74607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4741_7283",
    x1: 98.6314,
    y1: 6.56059,
    x2: 98.5908,
    y2: 6.60133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4741_7283",
    x1: 98.6213,
    y1: 6.58182,
    x2: 98.5845,
    y2: 6.61868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4741_7283",
    x1: 98.6146,
    y1: 6.68637,
    x2: 98.4973,
    y2: 6.80386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4741_7283",
    x1: 98.6634,
    y1: 6.68307,
    x2: 98.6305,
    y2: 6.71596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4741_7283",
    x1: 99.3379,
    y1: 5.98032,
    x2: 99.3059,
    y2: 6.01243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4741_7283",
    x1: 100.301,
    y1: 5.39591,
    x2: 100.119,
    y2: 5.57765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4741_7283",
    x1: 100.285,
    y1: 5.3947,
    x2: 100.226,
    y2: 5.45345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4741_7283",
    x1: 100.634,
    y1: 5.19532,
    x2: 100.602,
    y2: 5.22745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4741_7283",
    x1: 100.077,
    y1: 5.81711,
    x2: 100.036,
    y2: 5.85864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4741_7283",
    x1: 100.338,
    y1: 5.56801,
    x2: 100.31,
    y2: 5.59622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4741_7283",
    x1: 100.89,
    y1: 5.05529,
    x2: 100.857,
    y2: 5.08819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4741_7283",
    x1: 100.643,
    y1: 5.45046,
    x2: 100.613,
    y2: 5.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4741_7283",
    x1: 101.033,
    y1: 5.13876,
    x2: 100.998,
    y2: 5.17401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4741_7283",
    x1: 101.235,
    y1: 5.03698,
    x2: 101.198,
    y2: 5.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4741_7283",
    x1: 101.885,
    y1: 4.48648,
    x2: 101.77,
    y2: 4.60163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4741_7283",
    x1: 101.988,
    y1: 4.45215,
    x2: 101.958,
    y2: 4.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4741_7283",
    x1: 101.83,
    y1: 4.7175,
    x2: 101.785,
    y2: 4.76219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4741_7283",
    x1: 102.181,
    y1: 4.41084,
    x2: 102.152,
    y2: 4.43983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4741_7283",
    x1: 101.935,
    y1: 4.66152,
    x2: 101.9,
    y2: 4.69679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4741_7283",
    x1: 101.893,
    y1: 4.79161,
    x2: 101.838,
    y2: 4.84723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4741_7283",
    x1: 102.207,
    y1: 4.64353,
    x2: 102.102,
    y2: 4.74846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4741_7283",
    x1: 102.375,
    y1: 4.49267,
    x2: 102.332,
    y2: 4.53576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4741_7283",
    x1: 103.082,
    y1: 4.30975,
    x2: 103.035,
    y2: 4.35676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4741_7283",
    x1: 104.721,
    y1: 3.48323,
    x2: 104.654,
    y2: 3.55061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4741_7283",
    x1: 104.784,
    y1: 3.4728,
    x2: 104.748,
    y2: 3.50958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4741_7283",
    x1: 104.799,
    y1: 3.7301,
    x2: 104.772,
    y2: 3.75748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4741_7283",
    x1: 105.042,
    y1: 3.64188,
    x2: 104.993,
    y2: 3.69045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4741_7283",
    x1: 105.027,
    y1: 3.72878,
    x2: 105,
    y2: 3.75544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4741_7283",
    x1: 106.62,
    y1: 2.94067,
    x2: 106.187,
    y2: 3.37519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4741_7283",
    x1: 106.981,
    y1: 3.03775,
    x2: 106.931,
    y2: 3.08709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4741_7283",
    x1: 105.816,
    y1: 3.49683,
    x2: 105.661,
    y2: 3.65195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4741_7283",
    x1: 96.4901,
    y1: 7.45395,
    x2: 96.2,
    y2: 7.74456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4741_7283",
    x1: 96.7873,
    y1: 7.25016,
    x2: 96.5183,
    y2: 7.51961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4741_7283",
    x1: 99.1484,
    y1: 5.7443,
    x2: 99.1195,
    y2: 5.77329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4741_7283",
    x1: 99.5313,
    y1: 5.71188,
    x2: 99.5211,
    y2: 5.72206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4741_7283",
    x1: 96.9767,
    y1: 7.07178,
    x2: 96.7257,
    y2: 7.32322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4741_7283",
    x1: 98.6664,
    y1: 6.1185,
    x2: 98.6421,
    y2: 6.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4741_7283",
    x1: 98.6422,
    y1: 6.15364,
    x2: 98.5718,
    y2: 6.22414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4741_7283",
    x1: 97.0189,
    y1: 7.15742,
    x2: 96.9657,
    y2: 7.21068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4741_7283",
    x1: 97.0033,
    y1: 7.18389,
    x2: 96.9548,
    y2: 7.23244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4741_7283",
    x1: 96.9646,
    y1: 7.29414,
    x2: 96.8104,
    y2: 7.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4741_7283",
    x1: 97.0293,
    y1: 7.29024,
    x2: 96.9847,
    y2: 7.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4741_7283",
    x1: 99.2188,
    y1: 5.64395,
    x2: 98.9811,
    y2: 5.88207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4741_7283",
    x1: 99.2115,
    y1: 5.65699,
    x2: 99.1349,
    y2: 5.73376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4741_7283",
    x1: 98.8587,
    y1: 6.13057,
    x2: 98.8345,
    y2: 6.15482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4741_7283",
    x1: 99.6543,
    y1: 5.386,
    x2: 99.6128,
    y2: 5.42752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4741_7283",
    x1: 98.8834,
    y1: 6.14445,
    x2: 98.8295,
    y2: 6.19852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4741_7283",
    x1: 99.2425,
    y1: 5.83502,
    x2: 99.205,
    y2: 5.8726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4741_7283",
    x1: 99.9887,
    y1: 5.20055,
    x2: 99.9441,
    y2: 5.24519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4741_7283",
    x1: 99.6277,
    y1: 5.65809,
    x2: 99.587,
    y2: 5.69883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4741_7283",
    x1: 101.402,
    y1: 4.39879,
    x2: 101.363,
    y2: 4.43796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4741_7283",
    x1: 102.807,
    y1: 4.03873,
    x2: 102.745,
    y2: 4.1014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4741_7283",
    x1: 109.086,
    y1: 2.6608,
    x2: 109.041,
    y2: 2.70626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4741_7283",
    x1: 109.099,
    y1: 2.42674,
    x2: 109.074,
    y2: 2.45181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4741_7283",
    x1: 109.094,
    y1: 2.4515,
    x2: 109.058,
    y2: 2.48832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4741_7283",
    x1: 109.114,
    y1: 2.38275,
    x2: 109.085,
    y2: 2.41174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4741_7283",
    x1: 108.884,
    y1: 2.68228,
    x2: 108.852,
    y2: 2.7144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4741_7283",
    x1: 108.842,
    y1: 2.71126,
    x2: 108.739,
    y2: 2.81466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4741_7283",
    x1: 108.2,
    y1: 2.90027,
    x2: 108.177,
    y2: 2.92299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4741_7283",
    x1: 108.095,
    y1: 2.89142,
    x2: 108.061,
    y2: 2.92587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4741_7283",
    x1: 107.588,
    y1: 2.90447,
    x2: 107.571,
    y2: 2.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4741_7283",
    x1: 105.822,
    y1: 2.95103,
    x2: 105.044,
    y2: 3.73125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4741_7283",
    x1: 105.012,
    y1: 2.42011,
    x2: 104.969,
    y2: 2.46241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_4741_7283",
    x1: 104.69,
    y1: 2.5118,
    x2: 104.666,
    y2: 2.53609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_4741_7283",
    x1: 104.696,
    y1: 3.38819,
    x2: 104.619,
    y2: 3.46571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_4741_7283",
    x1: 104.637,
    y1: 3.40416,
    x2: 104.598,
    y2: 3.44408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_4741_7283",
    x1: 104.47,
    y1: 3.40884,
    x2: 104.407,
    y2: 3.47151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_4741_7283",
    x1: 104.315,
    y1: 2.60373,
    x2: 104.266,
    y2: 2.65309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_4741_7283",
    x1: 104.292,
    y1: 2.6617,
    x2: 104.264,
    y2: 2.68911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_4741_7283",
    x1: 104.077,
    y1: 3.56353,
    x2: 104.028,
    y2: 3.61205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_4741_7283",
    x1: 102.934,
    y1: 3.11911,
    x2: 102.731,
    y2: 3.32278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_4741_7283",
    x1: 102.887,
    y1: 3.24991,
    x2: 102.733,
    y2: 3.40345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_4741_7283",
    x1: 102.664,
    y1: 3.36924,
    x2: 102.632,
    y2: 3.40133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_4741_7283",
    x1: 102.623,
    y1: 3.2263,
    x2: 102.572,
    y2: 3.27725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_4741_7283",
    x1: 102.36,
    y1: 3.32939,
    x2: 102.314,
    y2: 3.37559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_4741_7283",
    x1: 102.342,
    y1: 3.38033,
    x2: 102.307,
    y2: 3.41555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_4741_7283",
    x1: 102.197,
    y1: 3.42914,
    x2: 102.166,
    y2: 3.45968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_4741_7283",
    x1: 102.114,
    y1: 3.46277,
    x2: 102.071,
    y2: 3.50664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_4741_7283",
    x1: 102.074,
    y1: 3.45043,
    x2: 102.016,
    y2: 3.5084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_4741_7283",
    x1: 102.025,
    y1: 3.4869,
    x2: 101.98,
    y2: 3.53232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_4741_7283",
    x1: 101.951,
    y1: 3.50719,
    x2: 101.874,
    y2: 3.58392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_4741_7283",
    x1: 101.67,
    y1: 3.73583,
    x2: 101.631,
    y2: 3.77498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_4741_7283",
    x1: 101.501,
    y1: 3.69637,
    x2: 101.456,
    y2: 3.7418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_4741_7283",
    x1: 101.53,
    y1: 4.12731,
    x2: 101.491,
    y2: 4.16571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_4741_7283",
    x1: 101.284,
    y1: 3.90708,
    x2: 101.223,
    y2: 3.96818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_4741_7283",
    x1: 101.197,
    y1: 3.70311,
    x2: 101.161,
    y2: 3.73914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_4741_7283",
    x1: 101.254,
    y1: 3.95513,
    x2: 101.219,
    y2: 3.99035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_4741_7283",
    x1: 101.206,
    y1: 3.95679,
    x2: 101.178,
    y2: 3.98418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_4741_7283",
    x1: 101.207,
    y1: 3.9944,
    x2: 101.178,
    y2: 4.02339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_4741_7283",
    x1: 101.108,
    y1: 3.86907,
    x2: 101.066,
    y2: 3.91135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_4741_7283",
    x1: 101.143,
    y1: 3.96646,
    x2: 101.11,
    y2: 3.99937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_4741_7283",
    x1: 100.997,
    y1: 3.78622,
    x2: 100.945,
    y2: 3.83868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_4741_7283",
    x1: 101.089,
    y1: 3.99815,
    x2: 101.06,
    y2: 4.02714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_4741_7283",
    x1: 101.066,
    y1: 3.93778,
    x2: 101.041,
    y2: 3.96284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_4741_7283",
    x1: 101.045,
    y1: 3.90422,
    x2: 101.01,
    y2: 3.93947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_4741_7283",
    x1: 101.049,
    y1: 3.94943,
    x2: 100.965,
    y2: 4.03323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_4741_7283",
    x1: 100.89,
    y1: 3.83787,
    x2: 100.796,
    y2: 3.93262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_4741_7283",
    x1: 100.87,
    y1: 4.17201,
    x2: 100.806,
    y2: 4.23548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_4741_7283",
    x1: 100.842,
    y1: 4.22756,
    x2: 100.777,
    y2: 4.29334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_4741_7283",
    x1: 100.762,
    y1: 4.22426,
    x2: 100.704,
    y2: 4.28301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_4741_7283",
    x1: 100.619,
    y1: 4.05344,
    x2: 100.528,
    y2: 4.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_4741_7283",
    x1: 100.899,
    y1: 4.62236,
    x2: 100.783,
    y2: 4.73906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_4741_7283",
    x1: 100.692,
    y1: 4.21722,
    x2: 100.651,
    y2: 4.25871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_4741_7283",
    x1: 100.491,
    y1: 4.1211,
    x2: 100.456,
    y2: 4.15635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_4741_7283",
    x1: 100.686,
    y1: 4.55355,
    x2: 100.636,
    y2: 4.60369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_4741_7283",
    x1: 100.506,
    y1: 4.2301,
    x2: 100.442,
    y2: 4.2951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_4741_7283",
    x1: 100.438,
    y1: 4.28369,
    x2: 100.369,
    y2: 4.35261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_4741_7283",
    x1: 100.718,
    y1: 4.82022,
    x2: 100.668,
    y2: 4.87037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_4741_7283",
    x1: 100.433,
    y1: 4.33839,
    x2: 100.398,
    y2: 4.3736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_4741_7283",
    x1: 100.39,
    y1: 4.28823,
    x2: 100.373,
    y2: 4.30468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_4741_7283",
    x1: 100.271,
    y1: 4.27965,
    x2: 100.175,
    y2: 4.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_4741_7283",
    x1: 100.162,
    y1: 4.27853,
    x2: 100.097,
    y2: 4.34355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_4741_7283",
    x1: 100.17,
    y1: 4.30929,
    x2: 100.141,
    y2: 4.33905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_4741_7283",
    x1: 100.279,
    y1: 4.52837,
    x2: 100.198,
    y2: 4.60985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_4741_7283",
    x1: 100.31,
    y1: 4.73147,
    x2: 100.217,
    y2: 4.82468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_4741_7283",
    x1: 100.153,
    y1: 4.50795,
    x2: 100.089,
    y2: 4.57218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_4741_7283",
    x1: 100.131,
    y1: 4.61229,
    x2: 100.1,
    y2: 4.64284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_4741_7283",
    x1: 100.208,
    y1: 4.77514,
    x2: 100.172,
    y2: 4.81119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_4741_7283",
    x1: 100.144,
    y1: 4.73805,
    x2: 100.092,
    y2: 4.79053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_4741_7283",
    x1: 100.295,
    y1: 4.74076,
    x2: 100.515,
    y2: 4.74076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_4741_7283",
    x1: 99.9051,
    y1: 4.54612,
    x2: 99.8527,
    y2: 4.59861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_4741_7283",
    x1: 99.8237,
    y1: 4.44011,
    x2: 99.7119,
    y2: 4.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_4741_7283",
    x1: 100.024,
    y1: 4.84364,
    x2: 99.9954,
    y2: 4.87262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_4741_7283",
    x1: 100.035,
    y1: 4.91183,
    x2: 99.9967,
    y2: 4.95023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_4741_7283",
    x1: 99.9817,
    y1: 4.82753,
    x2: 99.9457,
    y2: 4.86356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_4741_7283",
    x1: 99.9445,
    y1: 4.77625,
    x2: 99.8757,
    y2: 4.84521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_4741_7283",
    x1: 99.9693,
    y1: 4.87295,
    x2: 99.9513,
    y2: 4.89096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_4741_7283",
    x1: 99.8829,
    y1: 4.76668,
    x2: 99.8423,
    y2: 4.80738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_4741_7283",
    x1: 100.051,
    y1: 5.07664,
    x2: 99.9721,
    y2: 5.15578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_4741_7283",
    x1: 99.752,
    y1: 4.63301,
    x2: 99.6644,
    y2: 4.72075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_4741_7283",
    x1: 99.7434,
    y1: 4.71143,
    x2: 99.7145,
    y2: 4.74039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_4741_7283",
    x1: 99.7482,
    y1: 4.74788,
    x2: 99.7115,
    y2: 4.78467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_4741_7283",
    x1: 99.6698,
    y1: 4.74301,
    x2: 99.6283,
    y2: 4.78454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_4741_7283",
    x1: 99.9703,
    y1: 5.22445,
    x2: 99.932,
    y2: 5.26285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_4741_7283",
    x1: 99.7178,
    y1: 4.88775,
    x2: 99.6756,
    y2: 4.93005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_4741_7283",
    x1: 99.8135,
    y1: 5.18825,
    x2: 99.7298,
    y2: 5.27208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_4741_7283",
    x1: 99.4337,
    y1: 4.653,
    x2: 99.4008,
    y2: 4.6859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_4741_7283",
    x1: 99.6897,
    y1: 5.27866,
    x2: 99.6443,
    y2: 5.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_4741_7283",
    x1: 99.3817,
    y1: 4.93075,
    x2: 99.3355,
    y2: 4.97695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_4741_7283",
    x1: 99.1986,
    y1: 4.81068,
    x2: 99.0914,
    y2: 4.91799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_4741_7283",
    x1: 99.3927,
    y1: 5.0905,
    x2: 99.3271,
    y2: 5.15628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_4741_7283",
    x1: 99.2539,
    y1: 4.89853,
    x2: 99.2375,
    y2: 4.91497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_4741_7283",
    x1: 99.2512,
    y1: 5.17108,
    x2: 99.2105,
    y2: 5.2118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_4741_7283",
    x1: 99.1525,
    y1: 5.10874,
    x2: 99.1298,
    y2: 5.13145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_4741_7283",
    x1: 99.1114,
    y1: 5.09421,
    x2: 99.0856,
    y2: 5.12007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_4741_7283",
    x1: 99.37,
    y1: 5.46021,
    x2: 99.3309,
    y2: 5.49937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_4741_7283",
    x1: 99.1416,
    y1: 5.1513,
    x2: 99.1057,
    y2: 5.18731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_4741_7283",
    x1: 99.1522,
    y1: 5.18175,
    x2: 99.0944,
    y2: 5.23968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_4741_7283",
    x1: 99.003,
    y1: 5.03894,
    x2: 98.9138,
    y2: 5.12823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_4741_7283",
    x1: 99.1924,
    y1: 5.33463,
    x2: 99.1244,
    y2: 5.40279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_4741_7283",
    x1: 99.0595,
    y1: 5.1863,
    x2: 98.9845,
    y2: 5.26148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_4741_7283",
    x1: 99.2597,
    y1: 5.52093,
    x2: 99.2151,
    y2: 5.56557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_4741_7283",
    x1: 98.9145,
    y1: 5.14951,
    x2: 98.8793,
    y2: 5.18475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_4741_7283",
    x1: 99.0159,
    y1: 5.2993,
    x2: 98.9964,
    y2: 5.31888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_4741_7283",
    x1: 98.7931,
    y1: 5.01909,
    x2: 98.7376,
    y2: 5.07472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_4741_7283",
    x1: 98.9552,
    y1: 5.24657,
    x2: 98.8621,
    y2: 5.33979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_4741_7283",
    x1: 98.8555,
    y1: 5.12987,
    x2: 98.7968,
    y2: 5.18861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_4741_7283",
    x1: 98.9885,
    y1: 5.31577,
    x2: 98.9213,
    y2: 5.38314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_4741_7283",
    x1: 99.006,
    y1: 5.43782,
    x2: 98.9607,
    y2: 5.48325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_4741_7283",
    x1: 98.8269,
    y1: 5.21837,
    x2: 98.7807,
    y2: 5.26459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_4741_7283",
    x1: 98.8092,
    y1: 5.25557,
    x2: 98.7638,
    y2: 5.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_4741_7283",
    x1: 98.8807,
    y1: 5.38167,
    x2: 98.8456,
    y2: 5.41691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_4741_7283",
    x1: 99.1004,
    y1: 5.67893,
    x2: 99.0097,
    y2: 5.76979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_4741_7283",
    x1: 99.0281,
    y1: 5.59764,
    x2: 98.9945,
    y2: 5.63132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_4741_7283",
    x1: 98.9819,
    y1: 5.67323,
    x2: 98.9022,
    y2: 5.75312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_4741_7283",
    x1: 98.8153,
    y1: 5.46333,
    x2: 98.7942,
    y2: 5.48445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_4741_7283",
    x1: 98.793,
    y1: 5.55709,
    x2: 98.7242,
    y2: 5.62601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_4741_7283",
    x1: 98.5192,
    y1: 5.23023,
    x2: 98.4699,
    y2: 5.27961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_4741_7283",
    x1: 98.9738,
    y1: 5.81695,
    x2: 98.9394,
    y2: 5.85141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_4741_7283",
    x1: 98.6725,
    y1: 5.44591,
    x2: 98.6115,
    y2: 5.50701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_4741_7283",
    x1: 98.7253,
    y1: 5.56408,
    x2: 98.6791,
    y2: 5.61028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_4741_7283",
    x1: 98.4224,
    y1: 5.22114,
    x2: 98.3926,
    y2: 5.25095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_4741_7283",
    x1: 98.4407,
    y1: 5.3914,
    x2: 98.3937,
    y2: 5.43841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_4741_7283",
    x1: 98.5432,
    y1: 5.5298,
    x2: 98.4845,
    y2: 5.58857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_4741_7283",
    x1: 98.3583,
    y1: 5.3029,
    x2: 98.3372,
    y2: 5.32406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_4741_7283",
    x1: 98.7003,
    y1: 5.77054,
    x2: 98.6432,
    y2: 5.82772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_4741_7283",
    x1: 98.6646,
    y1: 5.83055,
    x2: 98.6309,
    y2: 5.86423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_4741_7283",
    x1: 98.7008,
    y1: 5.92437,
    x2: 98.639,
    y2: 5.98627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_4741_7283",
    x1: 98.6109,
    y1: 5.81735,
    x2: 98.5421,
    y2: 5.88628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_4741_7283",
    x1: 98.2266,
    y1: 5.38997,
    x2: 98.1867,
    y2: 5.42993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_4741_7283",
    x1: 98.6931,
    y1: 5.96525,
    x2: 98.6477,
    y2: 6.01068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_4741_7283",
    x1: 98.4049,
    y1: 5.64964,
    x2: 98.3697,
    y2: 5.68489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_4741_7283",
    x1: 98.2554,
    y1: 5.51582,
    x2: 98.1139,
    y2: 5.65761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_4741_7283",
    x1: 98.5273,
    y1: 5.88297,
    x2: 98.4984,
    y2: 5.91196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_4741_7283",
    x1: 98.2991,
    y1: 5.6207,
    x2: 98.0825,
    y2: 5.83769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_4741_7283",
    x1: 98.4769,
    y1: 5.90248,
    x2: 98.437,
    y2: 5.94243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_4741_7283",
    x1: 97.9734,
    y1: 5.55473,
    x2: 97.8804,
    y2: 5.64793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_4741_7283",
    x1: 98.343,
    y1: 5.98484,
    x2: 98.3195,
    y2: 6.00831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_4741_7283",
    x1: 97.9081,
    y1: 5.54276,
    x2: 97.8721,
    y2: 5.57877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_4741_7283",
    x1: 98.0077,
    y1: 5.66897,
    x2: 97.942,
    y2: 5.73475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_4741_7283",
    x1: 98.2945,
    y1: 6.01799,
    x2: 98.2201,
    y2: 6.09245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_4741_7283",
    x1: 97.9155,
    y1: 5.68018,
    x2: 97.8921,
    y2: 5.70367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_4741_7283",
    x1: 97.9902,
    y1: 5.81566,
    x2: 97.9245,
    y2: 5.88149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_4741_7283",
    x1: 97.815,
    y1: 5.65814,
    x2: 97.7493,
    y2: 5.72396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_4741_7283",
    x1: 97.9195,
    y1: 5.81374,
    x2: 97.9,
    y2: 5.83332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_4741_7283",
    x1: 97.744,
    y1: 5.62962,
    x2: 97.6963,
    y2: 5.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_4741_7283",
    x1: 97.8765,
    y1: 5.86175,
    x2: 97.8514,
    y2: 5.88682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_4741_7283",
    x1: 98.1911,
    y1: 6.25728,
    x2: 98.0832,
    y2: 6.36539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_4741_7283",
    x1: 97.6492,
    y1: 5.69109,
    x2: 97.596,
    y2: 5.74437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_4741_7283",
    x1: 98.0822,
    y1: 6.23458,
    x2: 98.0368,
    y2: 6.27999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_4741_7283",
    x1: 98.0342,
    y1: 6.23023,
    x2: 98.0006,
    y2: 6.26391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_4741_7283",
    x1: 97.9271,
    y1: 6.16237,
    x2: 97.8231,
    y2: 6.26657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_4741_7283",
    x1: 97.9947,
    y1: 6.319,
    x2: 97.9548,
    y2: 6.35896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_4741_7283",
    x1: 97.6795,
    y1: 6.02965,
    x2: 97.6474,
    y2: 6.06176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_4741_7283",
    x1: 97.5791,
    y1: 5.9871,
    x2: 97.5439,
    y2: 6.02235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_4741_7283",
    x1: 97.6045,
    y1: 6.02521,
    x2: 97.5889,
    y2: 6.04087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_4741_7283",
    x1: 97.9524,
    y1: 6.40209,
    x2: 97.8836,
    y2: 6.47101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_4741_7283",
    x1: 97.4537,
    y1: 6.09802,
    x2: 97.4357,
    y2: 6.11604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_4741_7283",
    x1: 97.4723,
    y1: 6.25885,
    x2: 97.4371,
    y2: 6.29411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_4741_7283",
    x1: 97.5861,
    y1: 6.55995,
    x2: 97.5517,
    y2: 6.59441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_4741_7283",
    x1: 97.1992,
    y1: 6.24292,
    x2: 97.164,
    y2: 6.27818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_4741_7283",
    x1: 97.527,
    y1: 6.60444,
    x2: 97.4816,
    y2: 6.6499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_4741_7283",
    x1: 97.5017,
    y1: 6.64802,
    x2: 97.4048,
    y2: 6.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_4741_7283",
    x1: 97.568,
    y1: 6.73606,
    x2: 97.5344,
    y2: 6.76971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_4741_7283",
    x1: 97.3535,
    y1: 6.81756,
    x2: 97.2402,
    y2: 6.93115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_4741_7283",
    x1: 96.8916,
    y1: 6.38476,
    x2: 96.8736,
    y2: 6.40279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_4741_7283",
    x1: 96.7931,
    y1: 6.32388,
    x2: 96.7626,
    y2: 6.35445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_4741_7283",
    x1: 97.2943,
    y1: 6.82722,
    x2: 97.2552,
    y2: 6.86638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_4741_7283",
    x1: 96.8559,
    y1: 6.4566,
    x2: 96.8387,
    y2: 6.47383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_4741_7283",
    x1: 96.6668,
    y1: 6.45715,
    x2: 96.6425,
    y2: 6.48142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_4741_7283",
    x1: 96.5718,
    y1: 6.43599,
    x2: 96.5179,
    y2: 6.49004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_4741_7283",
    x1: 105.309,
    y1: 3.30378,
    x2: 105.261,
    y2: 3.35156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_4741_7283",
    x1: 104.81,
    y1: 3.41374,
    x2: 104.754,
    y2: 3.47016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_4741_7283",
    x1: 104.627,
    y1: 2.52867,
    x2: 104.584,
    y2: 2.57176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_4741_7283",
    x1: 104.523,
    y1: 2.51762,
    x2: 104.411,
    y2: 2.63039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_4741_7283",
    x1: 104.331,
    y1: 3.47372,
    x2: 104.273,
    y2: 3.53248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_4741_7283",
    x1: 104.227,
    y1: 3.45273,
    x2: 104.094,
    y2: 3.58669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_4741_7283",
    x1: 102.988,
    y1: 3.1976,
    x2: 102.945,
    y2: 3.24063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_4741_7283",
    x1: 102.951,
    y1: 3.19038,
    x2: 102.873,
    y2: 3.26794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_4741_7283",
    x1: 102.812,
    y1: 3.2414,
    x2: 102.706,
    y2: 3.34787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_4741_7283",
    x1: 102.702,
    y1: 3.07558,
    x2: 102.543,
    y2: 3.23458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_4741_7283",
    x1: 102.737,
    y1: 3.55849,
    x2: 102.702,
    y2: 3.59296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_4741_7283",
    x1: 102.561,
    y1: 3.39557,
    x2: 102.451,
    y2: 3.50602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_4741_7283",
    x1: 102.519,
    y1: 3.27048,
    x2: 102.458,
    y2: 3.33159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_4741_7283",
    x1: 102.351,
    y1: 3.4921,
    x2: 102.32,
    y2: 3.52265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_4741_7283",
    x1: 102.253,
    y1: 3.39823,
    x2: 102.201,
    y2: 3.45072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_4741_7283",
    x1: 102.264,
    y1: 3.49353,
    x2: 102.153,
    y2: 3.60477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_4741_7283",
    x1: 102.213,
    y1: 3.43747,
    x2: 102.156,
    y2: 3.49465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_4741_7283",
    x1: 101.59,
    y1: 3.65134,
    x2: 101.536,
    y2: 3.70538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_4741_7283",
    x1: 101.493,
    y1: 3.84067,
    x2: 101.443,
    y2: 3.89159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_4741_7283",
    x1: 101.353,
    y1: 3.82595,
    x2: 101.253,
    y2: 3.92623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_4741_7283",
    x1: 101.286,
    y1: 3.75571,
    x2: 101.146,
    y2: 3.89593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_4741_7283",
    x1: 101.16,
    y1: 4.00876,
    x2: 101.126,
    y2: 4.04324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_4741_7283",
    x1: 101.132,
    y1: 3.94888,
    x2: 101.104,
    y2: 3.97628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_4741_7283",
    x1: 100.971,
    y1: 3.89577,
    x2: 100.842,
    y2: 4.02421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_4741_7283",
    x1: 100.93,
    y1: 3.99449,
    x2: 100.896,
    y2: 4.02894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_4741_7283",
    x1: 100.846,
    y1: 3.90439,
    x2: 100.467,
    y2: 4.28448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_4741_7283",
    x1: 100.868,
    y1: 3.99749,
    x2: 100.695,
    y2: 4.1714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_4741_7283",
    x1: 100.559,
    y1: 4.24493,
    x2: 100.237,
    y2: 4.56769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_4741_7283",
    x1: 100.411,
    y1: 4.14504,
    x2: 100.322,
    y2: 4.23356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_4741_7283",
    x1: 100.371,
    y1: 4.20249,
    x2: 100.29,
    y2: 4.28321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_4741_7283",
    x1: 100.313,
    y1: 4.20912,
    x2: 100.201,
    y2: 4.32111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_4741_7283",
    x1: 100.136,
    y1: 4.34002,
    x2: 100.035,
    y2: 4.44108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_4741_7283",
    x1: 99.9654,
    y1: 4.41426,
    x2: 99.8966,
    y2: 4.48321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_4741_7283",
    x1: 99.9529,
    y1: 4.4751,
    x2: 99.9239,
    y2: 4.50409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_4741_7283",
    x1: 99.6525,
    y1: 4.56796,
    x2: 99.4438,
    y2: 4.77711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_4741_7283",
    x1: 99.6324,
    y1: 4.64764,
    x2: 99.0302,
    y2: 5.25081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_4741_7283",
    x1: 99.726,
    y1: 4.79603,
    x2: 99.4766,
    y2: 5.0459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_4741_7283",
    x1: 99.5966,
    y1: 4.67638,
    x2: 99.356,
    y2: 4.91743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_4741_7283",
    x1: 99.633,
    y1: 4.73141,
    x2: 99.6017,
    y2: 4.76272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_4741_7283",
    x1: 99.3792,
    y1: 4.71886,
    x2: 99.2908,
    y2: 4.80738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_4741_7283",
    x1: 98.9199,
    y1: 4.9735,
    x2: 98.794,
    y2: 5.09961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_4741_7283",
    x1: 98.8652,
    y1: 5.17976,
    x2: 98.8144,
    y2: 5.23067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_4741_7283",
    x1: 98.7673,
    y1: 5.19487,
    x2: 98.5632,
    y2: 5.39931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_4741_7283",
    x1: 98.7611,
    y1: 5.07607,
    x2: 98.647,
    y2: 5.19043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_4741_7283",
    x1: 98.6729,
    y1: 5.33545,
    x2: 99.1482,
    y2: 5.33545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_4741_7283",
    x1: 98.716,
    y1: 5.50206,
    x2: 98.6589,
    y2: 5.55924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_4741_7283",
    x1: 98.4663,
    y1: 5.20586,
    x2: 98.4296,
    y2: 5.24271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_4741_7283",
    x1: 98.5629,
    y1: 5.38657,
    x2: 98.394,
    y2: 5.55577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_4741_7283",
    x1: 98.4888,
    y1: 5.34861,
    x2: 98.2948,
    y2: 5.54291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_4741_7283",
    x1: 98.3399,
    y1: 5.33446,
    x2: 98.3032,
    y2: 5.37128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_4741_7283",
    x1: 98.4204,
    y1: 5.60417,
    x2: 98.3915,
    y2: 5.63315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_4741_7283",
    x1: 98.3597,
    y1: 5.53271,
    x2: 98.2893,
    y2: 5.60323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_4741_7283",
    x1: 98.5116,
    y1: 6.04208,
    x2: 98.4795,
    y2: 6.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_4741_7283",
    x1: 97.9283,
    y1: 5.73204,
    x2: 97.8571,
    y2: 5.80333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_4741_7283",
    x1: 98.2197,
    y1: 6.23109,
    x2: 98.1877,
    y2: 6.26319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_4741_7283",
    x1: 98.1519,
    y1: 6.25099,
    x2: 98.0558,
    y2: 6.34734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_4741_7283",
    x1: 97.3286,
    y1: 6.76014,
    x2: 97.2199,
    y2: 6.86902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_4741_7283",
    x1: 97.2164,
    y1: 6.79803,
    x2: 97.1828,
    y2: 6.83171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_4741_7283",
    x1: 109.076,
    y1: 2.54419,
    x2: 108.888,
    y2: 2.73297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_4741_7283",
    x1: 105.046,
    y1: 3.28597,
    x2: 104.934,
    y2: 3.39799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_4741_7283",
    x1: 104.665,
    y1: 3.34374,
    x2: 104.568,
    y2: 3.44088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_4741_7283",
    x1: 101.206,
    y1: 3.88664,
    x2: 101.153,
    y2: 3.93989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_4741_7283",
    x1: 100.633,
    y1: 4.07318,
    x2: 100.354,
    y2: 4.35203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_4741_7283",
    x1: 98.2518,
    y1: 5.56869,
    x2: 97.9696,
    y2: 5.85146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_4741_7283",
    x1: 110.761,
    y1: 2.15676,
    x2: 110.721,
    y2: 2.19671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_4741_7283",
    x1: 111.001,
    y1: 1.47705,
    x2: 110.983,
    y2: 1.49505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_4741_7283",
    x1: 110.799,
    y1: 1.90913,
    x2: 110.78,
    y2: 1.92871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_4741_7283",
    x1: 110.875,
    y1: 1.6957,
    x2: 110.83,
    y2: 1.74114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_4741_7283",
    x1: 110.794,
    y1: 1.93567,
    x2: 110.762,
    y2: 1.96859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_4741_7283",
    x1: 110.826,
    y1: 1.86989,
    x2: 110.799,
    y2: 1.89653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_4741_7283",
    x1: 110.595,
    y1: 2.25105,
    x2: 110.577,
    y2: 2.26908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_4741_7283",
    x1: 110.601,
    y1: 2.16346,
    x2: 110.574,
    y2: 2.19007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_4741_7283",
    x1: 110.566,
    y1: 2.18459,
    x2: 110.467,
    y2: 2.28333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_4741_7283",
    x1: 110.727,
    y1: 1.39243,
    x2: 110.701,
    y2: 1.4183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_4741_7283",
    x1: 110.052,
    y1: 2.34054,
    x2: 110.032,
    y2: 2.36091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_4741_7283",
    x1: 109.972,
    y1: 2.32401,
    x2: 109.942,
    y2: 2.35456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_4741_7283",
    x1: 105.063,
    y1: 2.38193,
    x2: 105.018,
    y2: 2.42657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_4741_7283",
    x1: 104.511,
    y1: 2.04553,
    x2: 104.441,
    y2: 2.11522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_4741_7283",
    x1: 104.258,
    y1: 2.19961,
    x2: 104.198,
    y2: 2.25994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_4741_7283",
    x1: 104.159,
    y1: 2.23227,
    x2: 104.135,
    y2: 2.25654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_4741_7283",
    x1: 103.949,
    y1: 2.28252,
    x2: 103.921,
    y2: 2.31072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_4741_7283",
    x1: 103.879,
    y1: 2.33416,
    x2: 103.857,
    y2: 2.35609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_4741_7283",
    x1: 103.768,
    y1: 2.83346,
    x2: 103.741,
    y2: 2.86089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_4741_7283",
    x1: 103.885,
    y1: 2.76406,
    x2: 104.069,
    y2: 2.76406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_4741_7283",
    x1: 103.586,
    y1: 2.36886,
    x2: 103.506,
    y2: 2.44957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_4741_7283",
    x1: 103.623,
    y1: 2.84373,
    x2: 103.602,
    y2: 2.86488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_4741_7283",
    x1: 103.268,
    y1: 2.47965,
    x2: 103.243,
    y2: 2.50472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_4741_7283",
    x1: 103.046,
    y1: 2.57854,
    x2: 102.968,
    y2: 2.65609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_4741_7283",
    x1: 102.843,
    y1: 2.74805,
    x2: 102.778,
    y2: 2.81308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_4741_7283",
    x1: 102.707,
    y1: 2.66767,
    x2: 102.664,
    y2: 2.71074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_4741_7283",
    x1: 102.722,
    y1: 2.80779,
    x2: 102.682,
    y2: 2.84852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_4741_7283",
    x1: 102.674,
    y1: 2.8816,
    x2: 102.642,
    y2: 2.91451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_4741_7283",
    x1: 102.739,
    y1: 2.85685,
    x2: 102.613,
    y2: 2.98298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_4741_7283",
    x1: 102.707,
    y1: 3.32274,
    x2: 102.683,
    y2: 3.34704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_4741_7283",
    x1: 102.632,
    y1: 3.34125,
    x2: 102.589,
    y2: 3.38355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_4741_7283",
    x1: 102.453,
    y1: 2.80715,
    x2: 102.416,
    y2: 2.84396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_4741_7283",
    x1: 102.503,
    y1: 3.20797,
    x2: 102.47,
    y2: 3.24084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_4741_7283",
    x1: 102.392,
    y1: 2.78117,
    x2: 102.37,
    y2: 2.80312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_4741_7283",
    x1: 102.347,
    y1: 2.94552,
    x2: 102.312,
    y2: 2.97996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_4741_7283",
    x1: 102.385,
    y1: 3.45799,
    x2: 102.361,
    y2: 3.48227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_4741_7283",
    x1: 102.353,
    y1: 3.43515,
    x2: 102.304,
    y2: 3.4845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_4741_7283",
    x1: 102.202,
    y1: 2.89792,
    x2: 102.18,
    y2: 2.91983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_4741_7283",
    x1: 102.165,
    y1: 3.01132,
    x2: 102.062,
    y2: 3.11471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_4741_7283",
    x1: 102.28,
    y1: 3.46993,
    x2: 102.257,
    y2: 3.49265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_4741_7283",
    x1: 101.971,
    y1: 2.98512,
    x2: 101.899,
    y2: 3.05719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_4741_7283",
    x1: 101.935,
    y1: 2.94904,
    x2: 101.906,
    y2: 2.97882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_4741_7283",
    x1: 101.964,
    y1: 3.10198,
    x2: 101.91,
    y2: 3.15603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_4741_7283",
    x1: 102.043,
    y1: 3.50736,
    x2: 101.978,
    y2: 3.57238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_4741_7283",
    x1: 101.901,
    y1: 3.08811,
    x2: 101.883,
    y2: 3.10611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_4741_7283",
    x1: 101.826,
    y1: 3.04199,
    x2: 101.778,
    y2: 3.08977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_4741_7283",
    x1: 101.871,
    y1: 3.23362,
    x2: 101.853,
    y2: 3.25085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_4741_7283",
    x1: 101.699,
    y1: 3.0307,
    x2: 101.661,
    y2: 3.06909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_4741_7283",
    x1: 101.83,
    y1: 3.67003,
    x2: 101.805,
    y2: 3.69509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_4741_7283",
    x1: 101.766,
    y1: 3.57496,
    x2: 101.687,
    y2: 3.65409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_4741_7283",
    x1: 101.571,
    y1: 3.30679,
    x2: 101.545,
    y2: 3.33264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_4741_7283",
    x1: 101.453,
    y1: 3.38171,
    x2: 101.435,
    y2: 3.4005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_4741_7283",
    x1: 101.432,
    y1: 3.87953,
    x2: 101.406,
    y2: 3.90537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_4741_7283",
    x1: 101.381,
    y1: 3.90318,
    x2: 101.345,
    y2: 3.93922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_4741_7283",
    x1: 100.907,
    y1: 3.42101,
    x2: 100.884,
    y2: 3.44372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_4741_7283",
    x1: 100.922,
    y1: 3.58017,
    x2: 100.912,
    y2: 3.59034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_4741_7283",
    x1: 100.719,
    y1: 3.49133,
    x2: 100.675,
    y2: 3.53521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_4741_7283",
    x1: 97.1816,
    y1: 4.04392,
    x2: 111.157,
    y2: 4.04392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_4741_7283",
    x1: 110.58,
    y1: 2.14849,
    x2: 110.549,
    y2: 2.17983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_4741_7283",
    x1: 104.085,
    y1: 2.23145,
    x2: 104.023,
    y2: 2.29333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_4741_7283",
    x1: 104.044,
    y1: 2.2859,
    x2: 103.987,
    y2: 2.34305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_4741_7283",
    x1: 104.01,
    y1: 2.28478,
    x2: 103.93,
    y2: 2.36468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_4741_7283",
    x1: 103.702,
    y1: 2.3857,
    x2: 103.654,
    y2: 2.43346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_4741_7283",
    x1: 103.41,
    y1: 2.44453,
    x2: 103.258,
    y2: 2.59728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_4741_7283",
    x1: 103.202,
    y1: 2.53763,
    x2: 103.14,
    y2: 2.6003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_4741_7283",
    x1: 102.799,
    y1: 2.65397,
    x2: 102.702,
    y2: 2.75109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_4741_7283",
    x1: 102.707,
    y1: 2.83939,
    x2: 102.667,
    y2: 2.87935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_4741_7283",
    x1: 102.618,
    y1: 2.84002,
    x2: 102.464,
    y2: 2.99447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_4741_7283",
    x1: 102.663,
    y1: 2.71065,
    x2: 102.572,
    y2: 2.80152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_4741_7283",
    x1: 102.385,
    y1: 2.9293,
    x2: 102.24,
    y2: 3.07433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_4741_7283",
    x1: 102.303,
    y1: 2.86289,
    x2: 102.273,
    y2: 2.89346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_4741_7283",
    x1: 101.892,
    y1: 3.13757,
    x2: 101.834,
    y2: 3.19555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_4741_7283",
    x1: 101.187,
    y1: 3.99884,
    x2: 101.107,
    y2: 4.07874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_4741_7283",
    x1: 101.109,
    y1: 4.00491,
    x2: 101.081,
    y2: 4.03309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_4741_7283",
    x1: 110.78,
    y1: 2.03251,
    x2: 110.597,
    y2: 2.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_4741_7283",
    x1: 109.014,
    y1: 1.26276,
    x2: 109,
    y2: 1.27686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_4741_7283",
    x1: 109.125,
    y1: 0.242064,
    x2: 108.619,
    y2: 0.748868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_4741_7283",
    x1: 109,
    y1: 1.2818,
    x2: 108.949,
    y2: 1.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_4741_7283",
    x1: 109.962,
    y1: 0.230157,
    x2: 109.898,
    y2: 0.2944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_4741_7283",
    x1: 110.347,
    y1: 0.190501,
    x2: 110.327,
    y2: 0.210083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1076da08b68f0ade5bc8e6289d9bbb4.svg";
export { ForwardRef as ReactComponent };